webpackJsonp([1],{

/***/ 142:
/***/ (function(module, exports) {

module.exports = {
  be: {
    authorised: 'Wat is een geautoriseerde dealer?',
    directions: 'Routebeschrijving',
    continue: 'Verder winkelen',
    listHeader: 'Winkel op de kaart',
    listHeaderMult: 'Winkels op de kaart',
    matrix: 'km',
    myPosition: 'Mijn locatie',
    search: 'Zoek op land, provincie, plaats, adres, postcode, …',
    closed: 'Gesloten',
    showIpad: 'Weergeven op kaart',
    monFri: 'ma - vrij',
    sat: 'zat',
    sun: 'zon',
    legalH1: 'GEAUTORISEERDE DEALERS',
    legalH2: 'WAAROM KOPEN BIJ EEN GEAUTORISEERDE DEALER?',
    legalL1: 'U koopt een origineel Daniel Wellington-horloge',
    legalL2: 'Uw horloge wordt gedekt door de internationale garantie van Daniel Wellington',
    legalL3: 'Onderhoud of reparatie wordt door ervaren medewerkers uitgevoerd',
    legalL4: 'U geniet van het hoogste niveau aan klantenservice',
    legalP1: 'Bij Daniel Wellington willen we ervoor zorgen dat u een uitstekende ervaring hebt met onze producten voor, tijdens en na uw aankoop. We werken exclusief met een selecte groep partners over de hele wereld die het privilege verdiend hebben een geautoriseerde dealer van Daniel Wellington te worden.',
    legalP2: 'Of u nu bij een winkel of online koopt, wij willen dat u een ervaring hebt die niets te wensen overlaat. Onze retailpartners hebben aan ons bewezen dat ze zich toeleggen op het leveren van een consistent uitstekend serviceniveau.',
    legalP3: 'De enige manier om te zorgen dat u een origineel Daniel Wellington-horloge koopt, is via een geautoriseerde dealer of via danielwellington.com.',
    legalP4: 'Wanneer u een horloge koopt bij een geautoriseerde dealer van Daniel Wellington, weet u het volgende zeker:',
    legalP5: 'Als je koopt op e-commerce platforms zoals eBay en Groupon of bij een niet-gemachtigde derde verkoper op Amazon, loop je het risico dat het horloge namaak, gebruikt of defect is. Daniel Wellington gaat niet in op garantieclaims die niet vergezeld gaan van de originele documentatie.',
    legalP6: 'Voor meer informatie en om een geautoriseerde dealer in uw regio te zoeken, gaat u naar www.danielwellington.com/authorized-retailers'
  },
  ch: {
    authorised: 'Was ist ein autorisierter Händler?',
    directions: 'Anfahrt',
    continue: 'Einkauf fortsetzen',
    listHeader: 'Geschäft auf der Karte',
    listHeaderMult: 'Geschäfte auf der Karte',
    matrix: 'km',
    myPosition: 'Mein Standort',
    search: 'Nach Land, Bundesland, Stadt, Adresse, Postleitzahl suchen ...',
    closed: 'Geschlossen',
    showIpad: 'Auf Karte anzeigen',
    monFri: 'Mo. - Fr.',
    sat: 'Sa.',
    sun: 'So.',
    legalH1: 'AUTORISIERTE EINZELHÄNDLER',
    legalH2: 'WARUM VON EINEM AUTORISIERTEN EINZELHÄNDLER KAUFEN?',
    legalL1: 'Sie einen echten Daniel Wellington-Zeitmesser kaufen,',
    legalL2: 'Ihre Armbanduhr von Daniel Wellingtons internationaler Garantie gedeckt wird,',
    legalL3: 'jeglicher Service oder Reparatur von erfahrenem Personal durchgeführt wird,',
    legalL4: 'Sie einen Kundenservice von höchstem Niveau erfahren.',
    legalP1: 'Wir bei Daniel Wellington wollen sichergehen, dass Ihr Erlebnis mit unseren Produkten erstklassig ist, und zwar vor, während und nach Ihrem Einkauf. Wir arbeiten rund um die Welt exklusiv mit einer ausgewählten Gruppe an Partnern zusammen, die sich das Privileg verdient haben, autorisierte Einzelhändler von Daniel Wellington zu sein.',
    legalP2: 'Egal ob Sie in einem Einzelhandelsgeschäft oder online einkaufen, wir möchten, dass dieses Erlebnis Sie vollkommen zufriedenstellt. Unsere Einzelhandelspartner haben uns bewiesen, dass sie sich einem gleichbleibend hervorragenden Kundenservice verpflichtet haben.',
    legalP3: 'Der einzige Weg zu gewährleisten, dass Sie eine echte Daniel Wellington-Armbanduhr kaufen, ist, sie von einem autorisierten Einzelhändler oder auf danielwellington.com zu erwerben.',
    legalP4: 'Wenn Sie eine Uhr durch einen autorisierten Einzelhändler von Daniel Wellington kaufen, können Sie versichert sein, dass:',
    legalP5: 'Wenn Sie von Internethandel-Plattformen wie eBay und Groupon oder von einem nicht autorisierten Drittanbieter auf Amazon kaufen, besteht ein Risiko, dass Sie einen Zeitmesser erhalten, der gefälscht, gebraucht oder defekt ist. Daniel Wellington übernimmt keine Garantie, sofern nicht die Kaufbelege im Original vorgelegt werden.',
    legalP6: 'Für weitere Informationen und um einen autorisierten Händler oder Einzelhändler in Ihrer Gegend zu finden, besuchen Sie bitte www.danielwellington.com/authorized-retailers'
  },
  cn: {
    authorised: '什麼是授權零售商？',
    directions: '規劃路線',
    continue: '繼續購物',
    listHeader: '地圖上顯示的實體店',
    listHeaderMult: '地圖上顯示的實體店',
    matrix: 'km',
    myPosition: '我的位置',
    search: '按照國家、州、城市、地址、郵編進行搜索…… ',
    closed: '已關閉',
    showIpad: '在地圖上顯示p',
    monFri: '週一到週五',
    sat: '週六',
    sun: '週日',
    legalH1: '授权零售商',
    legalH2: '为什么从授权零售商处购买产品？',
    legalL1: '您所购买的手表为正宗的 Daniel Wellington 手表',
    legalL2: '您的手表将可获得 Daniel Wellington 国际联保服务',
    legalL3: '所有服务和维修人员均经验丰富',
    legalL4: '您将获得最棒的客户服务体验',
    legalP1: '在 Daniel Wellington，我们希望确保您在购买产品时，能享受到无与伦比的售前、售中及售后体验。我们还在世界各地精心挑选了可靠的合作伙伴，指定其为 Daniel Wellington 授权零售商。',
    legalP2: '无论是在零售店，还是网上商店，我们都希望您能获得愉快的体验。我们的零售合作伙伴也证明了它们始终致力于提供持续卓越服务的承诺。',
    legalP3: '购买正宗 Daniel Wellington 手表的惟一途径便是通过授权零售商，或前往 danielwellington.com 网店购买。',
    legalP4: '当您从 Daniel Wellington 授权零售商处购买手表时，您可获得以下保证：',
    legalP5: '如果您从 Amazon、eBay 或 Groupon 等非授权零售商处购买手表，则您收到的手表可能是仿冒产品、二手产品或缺陷产品。对于无法提供原始文件的索赔，Daniel Wellington 不予理赔。',
    legalP6: '如需了解更多信息，寻找您当地的授权经销商或零售商，请访问：www.danielwellington.com/authorized-retailers'
  },
  cz: {
    authorised: 'Co znamená „autorizovaný prodejce“?',
    directions: 'Získejte pokyny',
    continue: 'Pokračovat v nákupu',
    listHeader: 'Prodejna na mapě',
    listHeaderMult: 'Prodejny na mapě',
    matrix: 'km',
    myPosition: 'Moje poloha',
    search: 'Vyhledávání podle země, města, adresy, směrovacího čísla...',
    closed: 'Zavřeno',
    showIpad: 'Ukázat na mapě',
    monFri: 'Pondělí - Pátek',
    sat: 'Sobota',
    sun: 'Neděle',
    legalH1: 'AUTORIZOVANÍ PRODEJCI',
    legalH2: 'PROČ NAKUPOVAT U AUTORIZOVANÝCH PRODEJCŮ',
    legalL1: 'Kupujete pravé hodinky značky Daniel Wellington.',
    legalL2: 'Vaše hodinky mají mezinárodní záruku poskytovanou společností Daniel Wellington.',
    legalL3: 'Všechny služby a opravy provádějí zkušení pracovníci.',
    legalL4: 'Získáte maximální úroveň zákaznické podpory.',
    legalP1: 'Naším přáním u společnosti Daniel Wellington je zajistit, aby byla vaše zkušenost s našimi výrobky vynikající před jejich zakoupením, ale i během nákupu a po něm. Pracujeme výhradně s vybranou skupinou partnerů po celém světě, kteří získali oprávnění být autorizovanými prodejci společnosti Daniel Wellington.',
    legalP2: 'Ať už nakupujete v prodejně nebo na e-shopu, chceme vám poskytnout takový zážitek, jaký vás zcela uspokojí. Naši obchodní partneři nám dokázali, že jsou odhodláni poskytovat trvale vynikající úroveň služeb.',
    legalP3: 'Jediným způsobem, jak zajistit, že si koupíte pravé hodinky značky Daniel Wellington, je zakoupit si je prostřednictvím autorizovaného prodejce nebo na adrese danielwellington.com.',
    legalP4: 'Pokud hodinky zakoupíte u autorizovaného prodejce společnosti Daniel Wellington, můžete se spolehnout, že:',
    legalP5: 'Pokud nakupujete na e-shopech, jako je například eBay a Groupon, nebo od neautorizovaného prodejce třetí strany v obchodě Amazon, vyvstává riziko zakoupení padělaných, použitých nebo vadných hodinek. Společnost Daniel Wellington nebude brát ohled na žádné žádosti o reklamaci, které nebudou dodány společně s původní dokumentací.',
    legalP6: 'Více informací a způsob vyhledání autorizovaného prodejce ve vašem okolí získáte na webové stránce www.danielwellington.com/authorized-retailers'
  },
  dk: {
    authorised: 'Hvad er en autoriseret forhandler?',
    directions: 'Få anvisninger',
    continue: 'Fortsæt med at shoppe',
    listHeader: 'Butik vist på kort',
    listHeaderMult: 'Butikker vist på kort',
    matrix: 'km',
    myPosition: 'Min placering',
    search: 'Søg efter land, stat, by, adresse, postnummer...',
    closed: 'Lukket',
    showIpad: 'Vist på kort',
    monFri: 'Man - Fre',
    sat: 'Lør',
    sun: 'Søn',
    legalH1: 'AUTORISEREDE FORHANDLERE',
    legalH2: 'HVORFOR KØBE HOS EN AUTORISERET FORHANDLER?',
    legalL1: 'Du køber et ægte Daniel Wellington ur',
    legalL2: 'Dit ur vil være dækket af Daniel Wellingtons internationale garanti',
    legalL3: 'Alle serviceydelser og reparationer vil blive udført af erfarne medarbejdere',
    legalL4: 'Du vil få den bedst mulige kundeservice',
    legalP1: 'Hos Daniel Wellington vil vi gerne være sikre på, at du får en enestående oplevelse med vores produkter både før, under og efter dit køb. Vi samarbejder kun med en udvalgt gruppe af partnere i hele verden, der har opnået det privilegium at være autoriserede Daniel Wellington-forhandlere.',
    legalP2: 'Uanset om du handler i en butik eller online, er det vores ønske, at du får en oplevelse, du kan være fuldstændig tilfreds med. Vores partnere i detailhandelen har bevist overfor os, at de ønsker at levere et fremragende og vedvarende serviceniveau.',
    legalP3: 'Den eneste måde, du kan være sikker på at købe et ægte Daniel Wellington ur, er at købe det hos en autoriseret forhandler eller hos danielwellington.com.',
    legalP4: 'Når du køber et ur hos en autoriseret Daniel Wellington-forhandler, kan du være sikker på, at:',
    legalP5: 'Hvis du handler på nettet hos udbydere som eBay og Groupon eller en uautoriseret tredjepartsforhandler på Amazon, er der risiko for at modtage et ur, der er en efterligning, brugt eller defekt. Daniel Wellington imødekommer ikke garantikrav, der ikke er ledsaget af den originale dokumentation.',
    legalP6: 'Besøg www.danielWellington.com/autoriserede forhandlere for at få flere oplysninger og finde en autoriseret forhandler i dit område.'
  },
  en: {
    authorised: 'What is an Authorised retailer?',
    directions: 'Get directions',
    continue: 'Continue Shopping',
    listHeader: 'Store shown on map',
    listHeaderMult: 'Stores shown on map',
    matrix: 'km',
    myPosition: 'My position',
    search: 'Search by country, state, city, address, zip code...',
    closed: 'Closed',
    showIpad: 'Show on map',
    monFri: 'Mon - Fri',
    sat: 'Sat',
    sun: 'Sun',
    legalH1: 'AUTHORIZED RETAILERS',
    legalH2: 'WHY BUY FROM AN AUTHORIZED RETAILER?',
    legalL1: 'You are buying an authentic Daniel Wellington timepiece',
    legalL2: 'Your watch will be covered by Daniel Wellington’s international warranty',
    legalL3: 'Any service or repair will be conducted by experienced personnel',
    legalL4: 'You will experience the highest level of customer service',
    legalP1: 'At Daniel Wellington, we want to ensure that your experience with our products is outstanding, before, during and after your purchase. We work exclusively with a select group of partners around the world who have earned the privilege of being an authorized Daniel Wellington retailer.',
    legalP2: 'Whether you purchase from a retail store or online, we want you to have an experience that leaves you completely satisfied. Our retail partners have proven to us that they are committed to delivering a consistently excellent level of service.',
    legalP3: 'The only way to ensure you are buying an authentic Daniel Wellington watch is to purchase it through an authorized retailer or at danielwellington.com.',
    legalP4: 'When you purchase a watch from an authorized Daniel Wellington retailer, you can be assured that:',
    legalP5: 'If purchasing from e commerce platforms such as eBay and Groupon or an unauthorized third party vendor on Amazon, there is a risk of receiving a timepiece that is counterfeit, used or defective. Daniel Wellington does not honor any warranty claims that are not accompanied by the original documentation.',
    legalP6: 'For more information and to find an authorized dealer or retailer in your area, please visit www.danielwellington.com/authorized-retailers'
  },
  es: {
    authorised: '¿Qué es un distribuidor autorizado?',
    directions: 'Infórmate sobre cómo llegar',
    continue: 'Seguir comprando',
    listHeader: 'Tienda mostrada en el mapa',
    listHeaderMult: 'Tiendas mostradas en el mapa',
    matrix: 'km',
    myPosition: 'Mi posición',
    search: 'Búsqueda por país, estado, ciudad, dirección, código postal...',
    closed: 'Cerrado',
    showIpad: 'Mostrar en el mapa',
    monFri: 'Lun. - Vie.',
    sat: 'Sáb.',
    sun: 'Dom.',
    legalH1: 'DISTRIBUIDORES AUTORIZADOS',
    legalH2: 'MOTIVOS PARA COMPRAR EN UN DISTRIBUIDOR AUTORIZADO',
    legalL1: 'Está comprando un reloj auténtico de Daniel Wellington',
    legalL2: 'Su reloj quedará cubierto por la garantía internacional de Daniel Wellington',
    legalL3: 'Cualquier reparación o servicio será realizado por personal experimentado',
    legalL4: 'Disfrutará de un servicio a clientes del máximo nivel',
    legalP1: 'En Daniel Wellington, queremos estar seguros de que disfruta de una experiencia extraordinaria con nuestros productos antes, durante y después de la compra. Trabajamos exclusivamente con un grupo de socios seleccionados que se han ganado el privilegio de ser distribuidores autorizados de Daniel Wellington.',
    legalP2: 'Independientemente de que realice su compra en un punto de venta o en Internet, queremos que la experiencia sea de su total satisfacción. Nuestros socios minoristas nos han demostrado su compromiso para ofrecer siempre un servicio excelente.',
    legalP3: 'El único modo de estar seguro de comprar un reloj auténtico de Daniel Wellington es hacerlo a través de un distribuidor autorizado o bien, en danielwellington.com.',
    legalP4: 'Si compra un reloj en un distribuidor autorizado de Daniel Wellington, podrá estar seguro de que:',
    legalP5: 'Al realizar tu compra en plataformas de comercio electrónico tales como eBay y Groupon o bien, en distribuidores no autorizados en Amazon, existe el riesgo de que recibas un reloj falso, usado o defectuoso. Daniel Wellington no atenderá reclamaciones de garantía que no se presenten acompañadas de la documentación original.',
    legalP6: 'Si desea obtener más información o buscar un minorista o distribuidor autorizado en su zona, visite www.danielwellington.com/authorized-retailers'
  },
  fi: {
    authorised: 'Mikä on valtuutettu jälleenmyyjä?',
    directions: 'Ajo-ohjeet',
    continue: 'Jatka ostoksia',
    listHeader: 'Myymälä kartalla',
    listHeaderMult: 'Myymälät kartalla',
    matrix: 'km',
    myPosition: 'Oma sijaintini',
    search: 'Hae esimerkiksi maan, osavaltion, paikkakunnan, katuosoitteen tai postinumeron perusteella',
    closed: 'Suljettu',
    showIpad: 'Näytä kartalla',
    monFri: 'Ma – pe',
    sat: 'La',
    sun: 'Su',
    legalH1: 'VALTUUTETUT JÄLLEENMYYJÄT',
    legalH2: 'MIKSI KANNATTAA OSTAA VALTUUTETULTA JÄLLEENMYYJÄLTÄ?',
    legalL1: 'Olet ostamassa aitoa Daniel Wellington -kelloa',
    legalL2: 'Saat kellollesi Daniel Wellingtonin kansainvälisen takuun',
    legalL3: 'Huollot tai korjaukset suorittaa kokenut henkilöstö',
    legalL4: 'Saat parasta mahdollista asiakaspalvelua',
    legalP1: 'Haluamme Daniel Wellingtonilla varmistaa, että saat ainutlaatuisen kokemuksen tuotteistamme ennen niiden ostamista, ostotilanteessa ja ostamisen jälkeen. Työskentelemme eri puolilla maailmaa ainoastaan niiden valittujen jälleenmyyjien kanssa, jotka ovat ansainneet etuoikeuden toimia valtuutettuina Daniel Wellington -jälleenmyyjinä.',
    legalP2: 'Hankitpa kellon myymälästä tai verkkokaupasta, haluamme tarjota kokemuksen, johon olet täysin tyytyväinen. Jälleenmyyjäkumppanimme ovat todistaneet meille, että he ovat sitoutuneet toimittamaan jatkuvasti erinomaista palvelua.',
    legalP3: 'Ainoa tapa varmistaa, että ostat aidon Daniel Wellington -kellon on ostaa se valtuutetulta jälleenmyyjältä tai verkkokaupasta danielwellington.com.',
    legalP4: 'Ostaessasi kellon valtuutetulta Daniel Wellington -jälleenmyyjältä voit olla varma, että:',
    legalP5: 'Jos ostat verkkokauppapalvelusta, kuten eBaysta ja Grouponista tai valtuuttamattomalta kolmannen osapuolen myyjältä Amazonista, saatat saada kellon, joka on väärennös, käytetty tai viallinen. Daniel Wellington ei vastaa takuupyynnöistä, joiden mukana ei ole alkuperäistä todistusta.',
    legalP6: 'Katso lisätietoja ja etsi alueesi valtuutettu välittäjä tai jälleenmyyjä osoitteesta www.danielwellington.com/authorized-retailers'
  },
  fr: {
    authorised: 'Qu’est-ce qu’un revendeur agréé ?',
    directions: 'Obtenir un itinéraire',
    continue: 'Continuer mes achats',
    listHeader: 'Indiquer la boutique sur la carte',
    listHeaderMult: 'Indiquer les boutiques sur la carte',
    matrix: 'km',
    myPosition: 'Ma position',
    search: 'Recherche par pays, état, ville, adresse, code postal...',
    closed: 'Fermé',
    showIpad: 'Afficher sur la cartep',
    monFri: 'Lun - Ven',
    sat: 'Sam.',
    sun: 'Dim.',
    legalH1: 'REVENDEURS AGRÉÉS',
    legalH2: 'POURQUOI ACHETER AUPRÈS D\'UN REVENDEUR AGRÉÉ ?',
    legalL1: 'D’acheter une montre Daniel Wellington authentique',
    legalL2: 'Que votre montre sera couverte par la garantie internationale de Daniel Wellington',
    legalL3: 'Que les entretiens et réparations seront réalisés par du personnel expérimenté',
    legalL4: 'Que vous bénéficierez d\'une qualité de service clientèle exceptionnelle',
    legalP1: 'Chez Daniel Wellington, nous voulons nous assurer de vous proposer une expérience exceptionnelle de nos produits – avant, pendant et après votre achat. Nous travaillons exclusivement avec un groupe de partenaires choisis, présents dans le monde entier, qui ont mérité le privilège d\'être un revendeur agréé de Daniel Wellington.',
    legalP2: 'Peu importe que vous fassiez vos achats dans un magasin ou en ligne, nous voulons vous proposer une expérience qui vous apporte une satisfaction totale. Nos partenaires revendeurs nous ont démontré qu\'ils s’engagent à offrir une qualité de service constamment excellente.',
    legalP3: 'La seule manière de vous assurer d’acheter une montre Daniel Wellington authentique est de l’acheter auprès d\'un revendeur agréé ou sur danielwellington.com.',
    legalP4: 'Lorsque vous achetez une montre auprès d\'un revendeur agréé de Daniel Wellington, vous avez l’assurance :',
    legalP5: 'Si vous effectuez votre achat sur une plate-forme de commerce en ligne telle qu’eBay ou Groupon ou auprès d’un revendeur tiers non agréé sur Amazon, vous courez le risque de recevoir une montre contrefaite, d’occasion ou défectueuse. Daniel Wellington n’honorera aucune réclamation au titre de la garantie si elle n’est pas accompagnée de la documentation d’origine.',
    legalP6: 'Pour plus d\'informations et pour localiser un revendeur ou un détaillant agréé dans votre région, veuillez consulter la page www.danielwellington.com/authorized-retailers'
  },
  hr: {
    authorised: 'Što je „ovlašteni trgovac”?',
    directions: 'Dobijte upute',
    continue: 'Nastavak kupnje',
    listHeader: 'Trgovina prikazana na karti',
    listHeaderMult: 'Trgovine prikazane na karti',
    matrix: 'km',
    myPosition: 'Moja pozicija',
    search: 'Pretraživanje po državi, gradu, adresi, poštanskom broju...',
    closed: 'Zatvoreno',
    showIpad: 'Prikaži na karti',
    monFri: 'Pon. – pet.',
    sat: 'Sub.',
    sun: 'Ned.',
    legalH1: 'OVLAŠTENI TRGOVCI',
    legalH2: 'ZAŠTO KUPOVATI KOD OVLAŠTENOG TRGOVCA?',
    legalL1: 'Kupujete autentični sat marke Daniel Wellington',
    legalL2: 'Za svoj ćete sat dobiti međunarodno jamstvo poduzeća Daniel Wellington',
    legalL3: 'Sve servise i popravke obavit će iskusni djelatnici',
    legalL4: 'Doživjet ćete najvišu razinu usluge prema korisnicima',
    legalP1: 'U poduzeću Daniel Wellington želimo biti sigurni da će vam naši proizvodi pružiti izvanredan doživljaj prije, tijekom i nakon kupnje. Surađujemo isključivo s odabranom skupinom partnera diljem svijeta koji su zaslužili pravo da postanu ovlašteni trgovci proizvoda Daniel Wellington.',
    legalP2: 'Želimo vam pružiti doživljaj kojim ćete biti potpuno zadovoljni, bez obzira na to kupujete li u maloprodajnoj trgovini ili putem interneta. Naši maloprodajni partneri dokazali su nam da se trude pružiti dosljedno izvrsnu razinu usluge.',
    legalP3: 'Jedini način da budete sigurni kako ste kupili autentični sat Daniel Wellington jest to da ga kupite putem ovlaštenog trgovca ili na stranici danielwellington.com.',
    legalP4: 'Kada kupite sat od ovlaštenog trgovca proizvoda Daniel Wellington, možete biti sigurni u sljedeće:',
    legalP5: 'Ako kupnju obavite putem platformi za e-trgovinu kao što su eBay i Groupon ili kod neovlaštenog nezavisnog trgovca na Amazonu, postoji opasnost da ćete dobiti sat koji je krivotvoren, rabljen ili neispravan. Daniel Wellington neće prihvatiti zahtjeve na temelju jamstva ako oni nisu popraćeni originalnom dokumentacijom.',
    legalP6: 'Želite li više informacija ili pronaći obližnjeg ovlaštenog distributera ili trgovca, posjetite stranicu www.danielwellington.com/authorized-retailers'
  },
  id: {
    authorised: 'Apa yang dimaksud dengan pengecer resmi?',
    directions: 'Tampilkan arah',
    continue: 'Teruskan Belanja',
    listHeader: 'Toko yang ada di peta',
    listHeaderMult: 'Toko-toko yang ada di peta',
    matrix: 'km',
    myPosition: 'Posisi saya',
    search: 'Cari berdasarkan negara, negara bagian, kota, alamat, kode pos…',
    closed: 'Tutup',
    showIpad: 'Tampilkan di peta',
    monFri: 'Sen - Jum',
    sat: 'Sab',
    sun: 'Min',
  },
  ie: {
    authorised: 'What is an Authorised retailer?',
    directions: 'Get directions',
    continue: 'Continue Shopping',
    listHeader: 'Store shown on map',
    listHeaderMult: 'Stores shown on map',
    matrix: 'km',
    myPosition: 'My position',
    search: 'Search by country, state, city, address, zip code...',
    closed: 'Closed',
    showIpad: 'Show on map',
    monFri: 'Mon - Fri',
    sat: 'Sat',
    sun: 'Sun',
    legalH1: 'AUTHORIZED RETAILERS',
    legalH2: 'WHY BUY FROM AN AUTHORIZED RETAILER?',
    legalL1: 'You are buying an authentic Daniel Wellington timepiece',
    legalL2: 'Your watch will be covered by Daniel Wellington’s international warranty',
    legalL3: 'Any service or repair will be conducted by experienced personnel',
    legalL4: 'You will experience the highest level of customer service',
    legalP1: 'At Daniel Wellington, we want to ensure that your experience with our products is outstanding, before, during and after your purchase. We work exclusively with a select group of partners around the world who have earned the privilege of being an authorized Daniel Wellington retailer.',
    legalP2: 'Whether you purchase from a retail store or online, we want you to have an experience that leaves you completely satisfied. Our retail partners have proven to us that they are committed to delivering a consistently excellent level of service.',
    legalP3: 'The only way to ensure you are buying an authentic Daniel Wellington watch is to purchase it through an authorized retailer or at danielwellington.com.',
    legalP4: 'When you purchase a watch from an authorized Daniel Wellington retailer, you can be assured that:',
    legalP5: 'If purchasing from e commerce platforms such as eBay and Groupon or an unauthorized third party vendor on Amazon, there is a risk of receiving a timepiece that is counterfeit, used or defective. Daniel Wellington does not honor any warranty claims that are not accompanied by the original documentation.',
    legalP6: 'For more information and to find an authorized dealer or retailer in your area, please visit www.danielwellington.com/authorized-retailers'
  },
  it: {
    authorised: 'Che cos\'è un rivenditore autorizzato?',
    directions: 'Indicazioni stradali',
    continue: 'Continua ad acquistare',
    listHeader: 'Negozio visualizzato sulla mappa',
    listHeaderMult: 'Negozi visualizzati sulla mappa',
    matrix: 'km',
    myPosition: 'La mia posizione',
    search: 'Cerca per paese, stato, città, indirizzo, C.A.P …',
    closed: 'Chiuso',
    showIpad: 'Mostra sulla mappa',
    monFri: 'Lun - Ven',
    sat: 'Sab',
    sun: 'Dom',
    legalH1: 'RIVENDITORI AUTORIZZATI',
    legalH2: 'PERCHÉ ACQUISTARE DA UN RIVENDITORE AUTORIZZATO?',
    legalL1: 'state acquistando un orologio Daniel Wellington autentico',
    legalL2: 'l’orologio è coperto dalla garanzia internazionale di Daniel Wellington',
    legalL3: 'qualunque intervento di assistenza o riparazione sarà eseguito da personale qualificato',
    legalL4: 'sperimenterete il massimo livello di assistenza ai clienti',
    legalP1: 'Alla Daniel Wellington vogliamo essere sicuri che la vostra esperienza con i nostri prodotti sia eccellente, prima, durante e dopo l’acquisto. Lavoriamo esclusivamente con un gruppo selezionato di partner in tutto il mondo che hanno acquisito il privilegio di essere rivenditori autorizzati Daniel Wellington.',
    legalP2: 'Sia che l’acquisto venga effettuato presso un negozio oppure online, vogliamo offrirvi un’esperienza che vi lasci completamente soddisfatti. I nostri rivenditori ci hanno dimostrato il loro impegno nell’offrire un livello di assistenza sempre eccellente.',
    legalP3: 'L’unico modo per essere sicuri di stare acquistando un orologio Daniel Wellington autentico è quello di acquistarlo tramite un rivenditore autorizzato o su danielwellington.com.',
    legalP4: 'Quando acquistate un orologio da un rivenditore autorizzato Daniel Wellington, possiamo garantirvi che:',
    legalP5: 'Se si acquista da piattaforme e-commerce come eBay e Groupon o da un fornitore esterno non autorizzato su Amazon, si corre il rischio di ricevere un orologio falso, usato o difettoso. Daniel Wellington non onorerà alcuna richiesta di intervento in garanzia non accompagnata dalla documentazione originale.',
    legalP6: 'Per maggiori informazioni o per trovare un distributore o rivenditore autorizzato nella propria zona, visitare il sito www.danielwellington.com/rivenditori-autorizzati'
  },
  jp: {
    authorised: '正規販売店とは？',
    directions: '道順を表示する',
    continue: '買い物を続ける',
    listHeader: 'ストアを地図上で表示しています',
    listHeaderMult: 'ストアを地図上で表示しています',
    matrix: 'km',
    myPosition: 'あなたの場所',
    search: '国、州、市、住所、郵便番号等で検索',
    closed: '営業時間外',
    showIpad: '地図上で表示',
    monFri: '月曜 - 金曜',
    sat: '土曜',
    sun: '日曜',
    legalH1: '正規販売店について',
    legalH2: '正規販売店でのご購入をおすすめする理由',
    legalL1: 'ダニエル・ウェリントンの正規品のタイムピースのご購入',
    legalL2: 'ご購入いただいた時計はダニエル・ウェリントンの国際保証対象',
    legalL3: '熟練した担当者・技術者によるサービスまたは修理',
    legalL4: 'きめ細かなカスタマーサービス',
    legalP1: 'ダニエル・ウェリントンでは、ご購入前、ご購入時、またご購入後に至るまで、製品について心からご満足いただきたいと考えております。ダニエル・ウェリントンが販売を委託しているのは、正規取扱店として特別に認定した、世界中の選ばれたパートナーグループだけです。',
    legalP2: '小売店またはオンラインのいずれでご購入になる場合でも、心から満足したと実感していただくことが私たちの願いです。ダニエル・ウェリントンの販売パートナーは、弊社との契約において、高いレベルでお客様にサービスをご提供し続けることをお約束しています。',
    legalP3: '確実にダニエル・ウェリントンの正規品の腕時計をお買い求めいただけるのは、正規販売店またはdanielwellington.comのみです。',
    legalP4: 'ダニエル・ウェリントン正規販売店で腕時計をご購入いただくと、次のことが保証されます。',
    legalP5: 'eBay、Groupon、またはAmazonの正規販売店以外の第三者ベンダーでご購入の場合、模造品や中古品、欠陥品であるリスクを伴います。 ダニエル・ウェリントンでは、正規品であることを証明する書類のない場合の保証のご請求にはご対応致しかねます。',
    legalP6: '詳細、ならびにお近くの正規販売店または正規ディーラーについては、www.danielwellington.com/authorized-retailersでご確認ください。'
  },
  de: {
    authorised: 'Was ist ein autorisierter Händler?',
    directions: 'Anfahrt',
    continue: 'Einkauf fortsetzen',
    listHeader: 'Geschäft auf der Karte',
    listHeaderMult: 'Geschäfte auf der Karte',
    matrix: 'km',
    myPosition: 'Mein Standort',
    search: 'Nach Land, Bundesland, Stadt, Adresse, Postleitzahl suchen ...',
    closed: 'Geschlossen',
    showIpad: 'Auf Karte anzeigen',
    monFri: 'Mo. - Fr.',
    sat: 'Sa.',
    sun: 'So.',
    legalH1: 'AUTORISIERTE EINZELHÄNDLER',
    legalH2: 'WARUM VON EINEM AUTORISIERTEN EINZELHÄNDLER KAUFEN?',
    legalL1: 'Sie einen echten Daniel Wellington-Zeitmesser kaufen,',
    legalL2: 'Ihre Armbanduhr von Daniel Wellingtons internationaler Garantie gedeckt wird,',
    legalL3: 'jeglicher Service oder Reparatur von erfahrenem Personal durchgeführt wird,',
    legalL4: 'Sie einen Kundenservice von höchstem Niveau erfahren.',
    legalP1: 'Wir bei Daniel Wellington wollen sichergehen, dass Ihr Erlebnis mit unseren Produkten erstklassig ist, und zwar vor, während und nach Ihrem Einkauf. Wir arbeiten rund um die Welt exklusiv mit einer ausgewählten Gruppe an Partnern zusammen, die sich das Privileg verdient haben, autorisierte Einzelhändler von Daniel Wellington zu sein.',
    legalP2: 'Egal ob Sie in einem Einzelhandelsgeschäft oder online einkaufen, wir möchten, dass dieses Erlebnis Sie vollkommen zufriedenstellt. Unsere Einzelhandelspartner haben uns bewiesen, dass sie sich einem gleichbleibend hervorragenden Kundenservice verpflichtet haben.',
    legalP3: 'Der einzige Weg zu gewährleisten, dass Sie eine echte Daniel Wellington-Armbanduhr kaufen, ist, sie von einem autorisierten Einzelhändler oder auf danielwellington.com zu erwerben.',
    legalP4: 'Wenn Sie eine Uhr durch einen autorisierten Einzelhändler von Daniel Wellington kaufen, können Sie versichert sein, dass:',
    legalP5: 'Wenn Sie von Internethandel-Plattformen wie eBay und Groupon oder von einem nicht autorisierten Drittanbieter auf Amazon kaufen, besteht ein Risiko, dass Sie einen Zeitmesser erhalten, der gefälscht, gebraucht oder defekt ist. Daniel Wellington übernimmt keine Garantie, sofern nicht die Kaufbelege im Original vorgelegt werden.',
    legalP6: 'Für weitere Informationen und um einen autorisierten Händler oder Einzelhändler in Ihrer Gegend zu finden, besuchen Sie bitte www.danielwellington.com/authorized-retailers'
  },
  hk: {
    authorised: '什麼是授權零售商？',
    directions: '規劃路線',
    continue: '繼續購物',
    listHeader: '地圖上顯示的實體店',
    listHeaderMult: '地圖上顯示的實體店',
    matrix: 'km',
    myPosition: '我的位置',
    search: '按照國家、州、城市、地址、郵編進行搜索…… ',
    closed: '已關閉',
    showIpad: '在地圖上顯示',
    monFri: '週一到週五',
    sat: '週六',
    sun: '週日',
    legalH1: '授權經銷商',
    legalH2: '為何要向授權經銷商購買？',
    legalL1: '您買到的是 Daniel Wellington 原廠錶款',
    legalL2: '您的手錶可享有 Daniel Wellington 國際保固',
    legalL3: '服務或維修一律由經驗豐富的人員提供',
    legalL4: '您可以獲得最高品質的客戶服務',
    legalP1: 'Daniel Wellington 期許我們的產品能讓您無論在購買前、購買時及購買後都留下完美的印象。我們與一群在世界各地精心挑選的合作夥伴配合，他們就是 Daniel Wellington 授權經銷商。',
    legalP2: '無論您的購買途徑是零售店或網絡商店，我們都希望令您完全滿意。我們的經銷合作夥伴向我們證明了他們會努力提供穩定且卓越的服務水準。',
    legalP3: '透過授權經銷商或 danielwellington.com 購買，是能買到 Daniel Wellington 原廠手錶的唯一保證。',
    legalP4: '只要向 Daniel Wellington 授權經銷商購買手錶，就能享有下列保障：',
    legalP5: '從諸如eBay和Groupon等電子商務平台或亞馬遜網站上未經授權的第三方購買我們的腕錶，您可能會買到假冒、二手或者劣次品。若無法出示證明文件原件，Daniel Wellington 不提供任何保固。',
    legalP6: '如需詳細資訊及尋找所在地附近的授權經銷商，請訪問 www.danielwellington.com/authorized-retailers'
  },
  hu: {
    authorised: 'Mit jelent a hivatalos márkakereskedő elnevezés?',
    directions: 'Útvonaltervezés',
    continue: 'Vásárlás folytatása',
    listHeader: 'Üzlet megjelenítése a térképen',
    listHeaderMult: 'Üzletek megjelenítése a térképen',
    matrix: 'km',
    myPosition: 'Az én helyzetem',
    search: 'Keresés ország, állam, város, cím... alapján',
    closed: 'Zárva',
    showIpad: 'Mutasd a térképen',
    monFri: 'Hét - Pén',
    sat: 'Szo',
    sun: 'Vas',
    legalH1: 'HIVATALOS MÁRKAKERESKEDŐK',
    legalH2: 'MIÉRT VÁSÁROLJAK HIVATALOS MÁRKAKERESKEDŐTŐL?',
    legalL1: 'Ön eredeti Daniel Wellington órát vásárol',
    legalL2: 'Karórájára kiterjed a Daniel Wellington nemzetközi garanciája',
    legalL3: 'Mindennemű szerviz vagy javítási tevékenységet gyakorlott személyzet végez',
    legalL4: 'A legmagasabb szintű ügyfélszolgálatban lesz része',
    legalP1: 'A Daniel Wellington biztosítani szeretné, hogy Önnek a vásárlás előtt, alatt és után egyaránt a lehető legjobb tapasztalatai legyenek termékeinkkel kapcsolatosan. Világszerte kizárólag olyan partnerekkel dolgozunk, akik abban a kiváltságos helyzetben vannak, hogy a Daniel Wellington hivatalos márkakereskedői lehetnek.',
    legalP2: 'Akár kiskereskedelmi üzletben, akár online vásárol, azt szeretnénk, ha ez egy olyan élmény lenne az Ön számára, amellyel teljes mértékben elégedett. Kiskereskedelmi partnereink számunkra már bizonyították, hogy elkötelezettek a folyamatosan magas színvonalú szolgáltatás nyújtása iránt.',
    legalP3: 'Az egyetlen módja annak, hogy Ön eredeti Daniel Wellington órát vásároljon, ha azt egy hivatalos márkakereskedőn vagy a danielwellington.com weboldalon keresztül teszi.',
    legalP4: 'Ha Ön egy hivatalos Daniel Wellington márkakereskedőtől vásárol karórát, biztos lehet benne, hogy:',
    legalP5: 'Ha Ön olyan e-kereskedelmi platformokon vásárol, mint az eBay és a Groupon, vagy egy nem hivatalos harmadik fél beszállítótól az Amazonon, fennáll annak a kockázata, hogy hamis, használt vagy hibás órát kap. A Daniel Wellingtonnak nem áll módjában teljesíteni eredeti dokumentációval nem rendelkező jótállási igényeket.',
    legalP6: 'További információkért és az Ön lakhelyéhez közeli hivatalos forgalmazó vagy márkakereskedő megtalálásához kérjük, látogasson el a www.danielwellington.com/authorized-retailers weboldalra'
  },
  kr: {
    authorised: '공식판매처란?',
    directions: '주소 확인하기',
    continue: '계속 쇼핑하기',
    listHeader: '지도에 표시된 매장',
    listHeaderMult: '지도에 표시된 매장들',
    matrix: 'km',
    myPosition: '내 위치',
    search: '국가, 주, 시, 도, 주소, 우편번호로 검색',
    closed: '영업 종료',
    showIpad: '지도 보기',
    monFri: '월 - 금',
    sat: '토',
    sun: '일',
    legalH1: '공인 판매점',
    legalH2: '공인판매점에서구매해야하는이유',
    legalL1: '신뢰할 수 있는 정품 Daniel Wellington 제품을 구매하는 것입니다.',
    legalL2: 'Daniel Wellington의 국제 보증의 적용을 받습니다.',
    legalL3: '전문 기술자가 모든 서비스나 수리를 진행합니다.',
    legalL4: '가장 높은 수준의 고객 경험을 제공합니다.',
    legalP1: 'Daniel Wellington은 상품을 구매하기 전, 구매하는 동안 그리고 구매한 후에도 뛰어난 고객 경험을 제공하기 위해 모든 노력을 기울이고 있습니다. 이를 위해 전 세계에서 공인 Daniel Wellington 판매권을 획득한 선택된 파트너들과 긴밀하게 협력하고 있습니다.',
    legalP2: '소매 상점이나 온라인을 포함하여 어떤 공인 판매점에서 상품을 구매하든지 Daniel Wellington은 고객이 완전히 만족할 수 있는 경험을 전달해 드리기를 원합니다. Daniel Wellington의 소매 파트너들은 일관되고 탁월한 수준의 서비스를 전달하기 위해 헌신하고 있음을 시장에서 입증해 보여주었습니다.',
    legalP3: '정품 Daniel Wellington 시계를 확실하게 구매할 수 있는 유일한 방법은 공인 판매점이나 danielwellington.com을 통해 구매하는 것입니다.',
    legalP4: '공인 Daniel Wellington 판매점에서 시계를 구매하는 경우 다음과 같은 이점이 있습니다.',
    legalP5: 'Amazon, eBay 또는 Groupon과 같이 공인되지 않은 판매점에서 구매하는 경우 위조 제품, 중고 제품 또는 결함 제품을 받을 위험이 있습니다. Daniel Wellington은 원본 보증 문서에서 명시하지 않은 모든 보증 청구를 받아들이지 않습니다.',
    legalP6: '현지 공인 판매점이나 소매상에 대한 자세한 정보나 그 위치를 확인하려면 www.danielwellington.com/authorized-retailers를 방문하시기 바랍니다.'
  },
  kz_kk: {
    authorised: 'Өкілетті бөлшек сауда саудагері деген кім?',
    directions: 'Қалай жетуге болады',
    continue: 'Сауда жасауды жалғастыру',
    listHeader: 'Картада көрсетілген дүкен',
    listHeaderMult: 'Картада көрсетілген дүкендер',
    matrix: 'км',
    myPosition: 'Менің орным',
    search: 'Ел, штат, қала, мекенжай, пошталық индекс бойынша іздеу...',
    closed: 'Жабық',
    showIpad: 'Картада көрсету',
    monFri: 'Дүй - Жұм',
    sat: 'Сен',
    sun: 'Жек',
    legalH1: 'ӨКІЛЕТТІ БӨЛШЕК САУДА САУДАГЕРЛЕРІ',
    legalH2: 'НЕЛІКТЕН ӨКІЛЕТТІ БӨЛШЕК САУДА САУДАГЕРІНЕН САТЫП АЛУ КЕРЕК?',
    legalL1: 'Daniel Wellington түпнұсқалық сағатын сатып аласыз',
    legalL2: 'Сағатыңыз Daniel Wellington компаниясының халықаралық кепілдігімен қамтылады',
    legalL3: 'Кез келген қызмет көрсету немесе жөндеу жұмыстары тәжірибелі маманмен орындалады',
    legalL4: 'Сізге тұтынушылар қызметінің ең жоғары деңгейі көрсетіледі',
    legalP1: 'Daniel Wellington компаниясында біз сіздің сатып алғанға дейін, кезінде және кейін біздің өнімдерімізді пайдалану тәжірибеңіздің тамаша болғанын қалаймыз. Біз бүкіл әлем бойынша Daniel Wellington компаниясының өкілетті бөлшек сауда саудагері болудың айрықша құқығына лайықты болған серіктестердің таңдамалы тобымен ғана жұмыс істейміз.',
    legalP2: 'Бөлшек сауда дүкенінен болсын немесе онлайн режимде болсын, қайсысын сатып алсаңыз да, біз сіздің өнімге риза болғаныңызды қалаймыз. Біздің бөлшек саудамен айналысатын серіктестеріміз бізге қызмет көрсетудің әрқашан жоғары деңгейін қамтамасыз етуге ұмтылатындарын дәлелдеді.',
    legalP3: 'Daniel Wellington түпнұсқалық сағатын сатып алып жатқаныңызға көз жеткізудің жалғыз жолы – оны өкілетті бөлшек сауда саудагері арқылы немесе danielwellington.com сайтында сатып алу.',
    legalP4: 'Сағатты өкілетті Daniel Wellington бөлшек сауда саудагерінен сатып алу арқылы сіз келесілерге сенімді боласыз:',
    legalP5: 'Егер eBay және Groupon сияқты электронды коммерциялық платформалардан немесе Amazon платформасындағы авторизацияланбаған үшінші тарап жеткізушісінен сатып алсаңыз, онда жасанды, қолданылған немесе ақаулы сағатты алуы қаупі бар. Daniel Wellington компаниясы түпнұсқалық құжаттамамен бірге берілмеген қандай да бір кепілдік талаптарын орындамайды.',
    legalP6: 'Қосымша ақпарат алу және өз аймағыңыздағы өкілетті алып сатушыны немесе бөлшек сауда саудагерін табу үшін, www.danielwellington.com/authorized-retailers сайтына кіріңіз'
  },
  kz_ru: {
    authorised: 'Что такое уполномоченный розничный продавец?',
    directions: 'Узнать направление',
    continue: 'Продолжить покупки',
    listHeader: 'Магазин на карте',
    listHeaderMult: 'Магазины на карте',
    matrix: 'km',
    myPosition: 'МОЁ МЕСТОПОЛОЖЕНИЕ',
    search: 'Искать по стране, области, городу, адресу, индексу',
    closed: 'Закрыто',
    showIpad: 'Показать на карте',
    monFri: 'Понедельник-Пятница',
    sat: 'Суббота',
    sun: 'Воскресенье',
    legalH1: 'ОФИЦИАЛЬНЫЕ ДИСТРИБЬЮТОРЫ',
    legalH2: 'ПОЧЕМУ НЕОБХОДИМО ПОКУПАТЬ ИЗДЕЛИЯ DANIEL WELLINGTON У ОФИЦИАЛЬНЫХ ДИСТРИБЬЮТОРОВ?',
    legalL1: 'Вы покупаете настоящие часы бренда Daniel Wellington',
    legalL2: 'На ваши часы будет распространяться международная гарантия Daniel Wellington',
    legalL3: 'Все работы по сервисному обслуживанию и ремонту будут проводиться опытными специалистами',
    legalL4: 'Вам будет предоставлено обслуживание наивысшего качества',
    legalP1: 'Компания Daniel Wellington стремится к тому, чтобы ваши впечатления от нашей продукции были непревзойденными до, во время и после ее приобретения. Мы работаем только с группой избранных торговых партнеров по всему миру, которые заслужили право стать официальными дистрибьюторами продукции Daniel Wellington.',
    legalP2: 'Независимо от того, приобретаете вы часы в розничном магазине или интернет-магазине, мы хотим, чтобы ваши впечатления от нашего бренда всегда были на высоте. Наши партнеры по розничной торговле доказали нам, что стремятся предоставлять клиентам обслуживание неизменно высокого качества.',
    legalP3: 'Единственный способ удостовериться в том, что вы покупаете настоящие часы Daniel Wellington — приобрести их у официального дистрибьютора или на сайте danielwellington.com.',
    legalP4: 'Приобретая часы у официального дистрибьютора продукции Daniel Wellington, вы можете быть уверены в том, что:',
    legalP5: 'В случае покупки с платформ электронной коммерции, например, eBay и Groupon, или у неавторизованного стороннего продавца на Amazon, вы подвергаетесь риску получения поддельных, использованных или поврежденных часов. Компания Daniel Wellington не выполняет требования по исполнению гарантийных обязательств, не подкрепленные оригиналами соответствующей документации.',
    legalP6: 'Для получения дополнительной информации и поиска официальных дилеров или дистрибьюторов продукции Daniel Wellington в вашем регионе, пожалуйста, посетите сайт www.danielwellington.com/authorized-retailers'
  },
  no: {
    authorised: 'Hva er en autorisert forhandler?',
    directions: 'Få veibeskrivelse',
    continue: 'Fortsett å handle',
    listHeader: 'Forretning vist på kart',
    listHeaderMult: 'Forretninger vist på kart',
    matrix: 'km',
    myPosition: 'Min posisjon',
    search: 'Søk etter land, fylke, by, adresse, postnummer ...',
    closed: 'Stengt',
    showIpad: 'Vis på kart',
    monFri: 'Man - fre',
    sat: 'Lør',
    sun: 'Søn',
    legalH1: 'AUTORISERTE FORHANDLERE',
    legalH2: 'HVORFOR KJØPE FRA EN AUTORISERT FORHANDLER?',
    legalL1: 'Du kjøper en autentisk Daniel Wellington-klokke',
    legalL2: 'Klokken din vil bli dekket av Daniel Wellingtons internasjonale garanti',
    legalL3: 'Service eller reparasjon vil bli utført av erfarent personale',
    legalL4: 'Du vil oppleve den høyeste grad av kundeservice',
    legalP1: 'Hos Daniel Wellington ønsker vi å sikre at din opplevelse med produktene våre er enestående, før, under og etter kjøpet. Vi arbeider utelukkende med en utvalgt gruppe partnere rundt om i verden som har fortjent det privilegium det er å være en autorisert Daniel Wellington-forhandler.',
    legalP2: 'Enten du kjøper fra en butikk eller på nettet, vil vi at du skal få en opplevelse som gjør deg absolutt fornøyd. Våre forhandlere har bevist for oss at de er opptatt av å levere en gjennomgående fremragende service.',
    legalP3: 'Den eneste måten å sikre at du kjøper en autentisk Daniel Wellington-klokke er å kjøpe den gjennom en autorisert forhandler eller på danielwellington.com.',
    legalP4: 'Når du kjøper en klokke fra en autorisert forhandler av Daniel Wellington kan du være sikker på at:',
    legalP5: 'Hvis du kjøper fra en e-handelsplattform så som eBay og Groupon, eller en ikke-autorisert, tredjeparts selger på Amazon, er det en mulighet for at du får en klokke som er falsk, brukt eller defekt. Daniel Wellington respekterer ikke eventuelle garantikrav som ikke er ledsaget av den opprinnelige dokumentasjonen.',
    legalP6: 'For mer informasjon, og for å finne en autorisert forhandler i ditt område, vennligst besøk www.danielwellington.com/authorized-retailers'
  },
  nl: {
    authorised: 'Wat is een geautoriseerde dealer?',
    directions: 'Routebeschrijving',
    continue: 'Verder winkelen',
    listHeader: 'Winkel op de kaart',
    listHeaderMult: 'Winkels op de kaart',
    matrix: 'km',
    myPosition: 'Mijn locatie',
    search: 'Zoek op land, provincie, plaats, adres, postcode, …',
    closed: 'Gesloten',
    showIpad: 'Weergeven op kaart',
    monFri: 'ma - vrij',
    sat: 'zat',
    sun: 'zon',
    legalH1: 'GEAUTORISEERDE DEALERS',
    legalH2: 'WAAROM KOPEN BIJ EEN GEAUTORISEERDE DEALER?',
    legalL1: 'U koopt een origineel Daniel Wellington-horloge',
    legalL2: 'Uw horloge wordt gedekt door de internationale garantie van Daniel Wellington',
    legalL3: 'Onderhoud of reparatie wordt door ervaren medewerkers uitgevoerd',
    legalL4: 'U geniet van het hoogste niveau aan klantenservice',
    legalP1: 'Bij Daniel Wellington willen we ervoor zorgen dat u een uitstekende ervaring hebt met onze producten voor, tijdens en na uw aankoop. We werken exclusief met een selecte groep partners over de hele wereld die het privilege verdiend hebben een geautoriseerde dealer van Daniel Wellington te worden.',
    legalP2: 'Of u nu bij een winkel of online koopt, wij willen dat u een ervaring hebt die niets te wensen overlaat. Onze retailpartners hebben aan ons bewezen dat ze zich toeleggen op het leveren van een consistent uitstekend serviceniveau.',
    legalP3: 'De enige manier om te zorgen dat u een origineel Daniel Wellington-horloge koopt, is via een geautoriseerde dealer of via danielwellington.com.',
    legalP4: 'Wanneer u een horloge koopt bij een geautoriseerde dealer van Daniel Wellington, weet u het volgende zeker:',
    legalP5: 'Als je koopt op e-commerce platforms zoals eBay en Groupon of bij een niet-gemachtigde derde verkoper op Amazon, loop je het risico dat het horloge namaak, gebruikt of defect is. Daniel Wellington gaat niet in op garantieclaims die niet vergezeld gaan van de originele documentatie.',
    legalP6: 'Voor meer informatie en om een geautoriseerde dealer in uw regio te zoeken, gaat u naar www.danielwellington.com/authorized-retailers'
  },
  pl: {
    authorised: 'Kto to jest Autoryzowany sprzedawca?',
    directions: 'Jak trafić?',
    continue: 'Kontynuuj zakupy',
    listHeader: 'Sklep widoczny na mapie',
    listHeaderMult: 'Sklepy widoczne na mapie',
    matrix: 'km',
    myPosition: 'Moja pozycja',
    search: 'Szukaj wg kraju, województwa, miasta, adresu, kodu pocztowego...',
    closed: 'Zamknięte',
    showIpad: 'Pokaż na mapie',
    monFri: 'Pon. - Pt.',
    sat: 'Pon. - Pt.',
    sun: 'Ndz.',
    legalH1: 'AUTORYZOWANI SPRZEDAWCY',
    legalH2: 'DLACZEGO WARTO KUPOWAĆ U AUTORYZOWANEGO SPRZEDAWCY?',
    legalL1: 'zyskuje się pewność, że jest to oryginalny zegarek Daniel Wellington',
    legalL2: 'zakupiony zegarek będzie objęty międzynarodową gwarancją Daniel Wellington',
    legalL3: 'konserwacja lub naprawy zegarka będą przeprowadzane przez doświadczonych specjalistów',
    legalL4: 'można być pewnym najwyższego poziomu obsługi klienta',
    legalP1: 'Daniel Wellington dokłada wszelkich starań, aby wszystko, co dotyczy naszych produktów, przekraczało oczekiwania naszych klientów – przed zakupem, w jego trakcie, a także już po jego dokonaniu. Współpracujemy wyłącznie ze starannie wybranymi partnerami na całym świecie. Każdy z nich uzyskał tytuł autoryzowanego sprzedawcy Daniel Wellington.',
    legalP2: 'Pragniemy, aby nasi klienci byli w pełni zadowoleni z zakupu, niezależnie od tego, czy dokonują go w sklepie stacjonarnym, czy internetowym. Nasi partnerzy handlowi wyraźnie udowodnili nam, że dokładają wszelkich starań, aby nieprzerwanie dostarczać usługi na jak najwyższym poziomie.',
    legalP3: 'Aby mieć pewność, że posiadany zegarek Daniel Wellington jest oryginalny, wystarczy dokonać zakupu u autoryzowanego sprzedawcy lub na stronie internetowej danielwellington.com.',
    legalP4: 'Kupując zegarek od autoryzowanego sprzedawcy Daniel Wellington:',
    legalP5: 'Robiąc zakupy na platformach handlu elektronicznego, takich jak eBay i Groupon, lub u nieautoryzowanych sprzedawców zewnętrznych obecnych w serwisie Amazon, istnieje ryzyko otrzymania podrobionego, używanego lub uszkodzonego zegarka. Daniel Wellington nie honoruje roszczeń gwarancyjnych w stosunku do produktów, które nie posiadają oryginalnej dokumentacji.',
    legalP6: 'Aby uzyskać więcej informacji i znaleźć najbliższego autoryzowanego sprzedawcę, wystarczy odwiedzić stronę internetową: www.danielwellington.com/authorized-retailers'
  },
  pt: {
    authorised: 'O que é um revendedor autorizado?',
    directions: 'Obter endereços',
    continue: 'Continuar a comprar',
    listHeader: 'Loja mostrada no mapa',
    listHeaderMult: 'Lojas mostradas no mapa',
    matrix: 'km',
    myPosition: 'A minha posição',
    search: 'Pesquisar por país, estado, cidade, endereço, código postal...',
    closed: 'Fechado',
    showIpad: 'Mostrar no mapa',
    monFri: 'Seg. - Sex.',
    sat: 'Sab.',
    sun: 'Dom.',
    legalH1: 'REVENDEDORES AUTORIZADOS',
    legalH2: 'PORQUÊ COMPRAR A UM REVENDEDOR AUTORIZADO?',
    legalL1: 'Está a comprar um relógio autêntico Daniel Wellington',
    legalL2: 'O seu relógio estará coberto pela garantia internacional Daniel Wellington',
    legalL3: 'Qualquer assistência ou reparação será realizada por pessoal experiente',
    legalL4: 'Irá beneficiar do mais elevado nível de assistência ao cliente',
    legalP1: 'Na Daniel Wellington queremos garantir-lhe uma experiência excecional com os nossos produtos, antes, durante e depois da sua compra. Trabalhamos exclusivamente com um grupo de parceiros selecionados no mundo inteiro que conquistaram o privilégio de serem agentes autorizados da Daniel Wellington.',
    legalP2: 'Quer efetue a sua compra numa loja de retalho ou online, queremos que essa sua experiência o deixe completamente satisfeito. Os nossos parceiros retalhistas deram-nos provas de que estão empenhados em desenvolver um nível de serviço de excelência permanente.',
    legalP3: 'A única forma de assegurar que está a comprar um relógio Daniel Wellington autêntico é comprá-lo através de um revendedor autorizado ou em danielwellington.com.',
    legalP4: 'Quando compra um relógio a um revendedor Daniel Wellington, pode ter a certeza de que:',
    legalP5: 'Ao comprar em plataformas de ecommerce como o eBay e o Groupon ou através de outros fornecedores não autorizados na Amazon, correrá o risco de receber um relógio falsificado, usado ou com defeito. A Daniel Wellington não aceita quaisquer reclamações de garantia que não sejam acompanhadas pela documentação original.',
    legalP6: 'Para obter mais informações e encontrar um revendedor autorizado na sua área, visite www.danielwellington.com/authorized-retailers'
  },
  ro: {
    authorised: 'Ce este un retailer autorizat?',
    directions: 'Obțineți îndrumări',
    continue: 'Continuați cumpărăturile',
    listHeader: 'Magazin prezentat pe hartă',
    listHeaderMult: 'Magazine prezentate pe hartă',
    matrix: 'km',
    myPosition: 'Poziția mea',
    search: 'Căutare după țară, stat, oraș, adresă, cod poștal ...',
    closed: 'Închis',
    showIpad: 'Prezentare pe hartă',
    monFri: 'Luni - Vineri',
    sat: 'Sâm',
    sun: 'Dum',
    legalH1: 'RETAILERI AUTORIZAȚI',
    legalH2: 'DE CE SĂ CUMPĂRAȚI DE LA UN RETAILER AUTORIZAT?',
    legalL1: 'Cumpărați un ceas autentic Daniel Wellington',
    legalL2: 'Ceasul dumneavoastră va fi acoperit de garanția internațională Daniel Wellington',
    legalL3: 'Orice lucrări de service sau reparații vor fi realizate de către personal experimentat',
    legalL4: 'Vă veți bucura de cel mai înalt nivel al serviciilor pentru clienți',
    legalP1: 'Noi, cei de la Daniel Wellington, dorim să ne asigurăm că experiența dumneavoastră cu produsele noastre este excepțională, înainte, în timpul și după achiziție. Noi lucrăm exclusiv cu un grup selecționat de parteneri din întreaga lume, care și-au câștigat privilegiul de a fi retaileri autorizați Daniel Wellington.',
    legalP2: 'Fie că achiziționați dintr-un magazin de vânzare cu amănuntul sau online, dorim să vă bucurați de o experiență care să vă satisfacă în totalitate. Partenerii noștri de retail ne-au dovedit că sunt angajați în furnizarea consecventă a unui nivel excelent de servicii.',
    legalP3: 'Unicul mod prin care vă asigurați de achiziționarea unui ceas autentic Daniel Wellington este de a-l cumpăra prin intermediul unui retailer autorizat sau de la danielwellington.com.',
    legalP4: 'Când achiziționați un ceas de la un retailer autorizat Daniel Wellington, puteți fi siguri că:',
    legalP5: 'În cazul în care achiziționați de pe platforme de comerț electronic, de exemplu eBay și Groupon sau de la un distribuitor neautorizat de terță parte de pe Amazon, există riscul de a primi un ceas contrafăcut, folosit sau defect. Daniel Wellington nu onorează nicio cerere de garanție care nu este însoțită de documentația originală.',
    legalP6: 'Pentru informații suplimentare și pentru a găsi un distribuitor sau retailer autorizat din zona dumneavoastră, vă rugăm să consultați www.danielwellington.com/authorized-retailers'
  },
  ru: {
    authorised: 'Что такое уполномоченный розничный продавец?',
    directions: 'Узнать направление',
    continue: 'Продолжить покупки',
    listHeader: 'Магазин на карте',
    listHeaderMult: 'Магазины на карте',
    matrix: 'km',
    myPosition: 'МОЁ МЕСТОПОЛОЖЕНИЕ',
    search: 'Искать по стране, области, городу, адресу, индексу',
    closed: 'Закрыто',
    showIpad: 'Показать на карте',
    monFri: 'Понедельник-Пятница',
    sat: 'Суббота',
    sun: 'Воскресенье',
    legalH1: 'ОФИЦИАЛЬНЫЕ ДИСТРИБЬЮТОРЫ',
    legalH2: 'ПОЧЕМУ НЕОБХОДИМО ПОКУПАТЬ ИЗДЕЛИЯ DANIEL WELLINGTON У ОФИЦИАЛЬНЫХ ДИСТРИБЬЮТОРОВ?',
    legalL1: 'Вы покупаете настоящие часы бренда Daniel Wellington',
    legalL2: 'На ваши часы будет распространяться международная гарантия Daniel Wellington',
    legalL3: 'Все работы по сервисному обслуживанию и ремонту будут проводиться опытными специалистами',
    legalL4: 'Вам будет предоставлено обслуживание наивысшего качества',
    legalP1: 'Компания Daniel Wellington стремится к тому, чтобы ваши впечатления от нашей продукции были непревзойденными до, во время и после ее приобретения. Мы работаем только с группой избранных торговых партнеров по всему миру, которые заслужили право стать официальными дистрибьюторами продукции Daniel Wellington.',
    legalP2: 'Независимо от того, приобретаете вы часы в розничном магазине или интернет-магазине, мы хотим, чтобы ваши впечатления от нашего бренда всегда были на высоте. Наши партнеры по розничной торговле доказали нам, что стремятся предоставлять клиентам обслуживание неизменно высокого качества.',
    legalP3: 'Единственный способ удостовериться в том, что вы покупаете настоящие часы Daniel Wellington — приобрести их у официального дистрибьютора или на сайте danielwellington.com.',
    legalP4: 'Приобретая часы у официального дистрибьютора продукции Daniel Wellington, вы можете быть уверены в том, что:',
    legalP5: 'В случае покупки с платформ электронной коммерции, например, eBay и Groupon, или у неавторизованного стороннего продавца на Amazon, вы подвергаетесь риску получения поддельных, использованных или поврежденных часов. Компания Daniel Wellington не выполняет требования по исполнению гарантийных обязательств, не подкрепленные оригиналами соответствующей документации.',
    legalP6: 'Для получения дополнительной информации и поиска официальных дилеров или дистрибьюторов продукции Daniel Wellington в вашем регионе, пожалуйста, посетите сайт www.danielwellington.com/authorized-retailers'
  },
  sa_ar: {
    authorised: 'من هو تاجر التجزئة المعتمد؟',
    directions: 'احصل على التوجيهات',
    continue: 'متابعة التسوّق',
    listHeader: 'المتجر المعروض على الخريطة',
    listHeaderMult: 'المتاجر المعروضة على الخريطة',
    matrix: 'km',
    myPosition: 'الموضع الخاص بي',
    search: 'البحث باستخدام الدولة، الولاية، المدينة، العنوان، الرمز البريدي...',
    closed: 'مغلق',
    showIpad: 'معروض على الخريطة',
    monFri: 'الاثنين - الجمعة',
    sat: 'السبت',
    sun: 'الأحد',
    legalH1: 'باعة التجزئة المُعتمدون لـ «دانيال ولينغتون',
    legalH2: 'لماذا الشراء من بائع تجزئة مُعتمد؟',
    legalL1: 'لكونك تشتري ساعة «دانيال ولينغتون» أصليّة',
    legalL2: 'أن ساعتك ستكون مُغطّاة بكفالة «دانيال ولينغتون» العالميّة',
    legalL3: 'أن أي خدمة أو صيانة ستُنجز من قبل طاقم من العاملين ذوي الخبرة',
    legalL4: 'أنك ستتلقّى خدمة زبائن على أعلى مستوى',
    legalP1: 'في «دانيال ولينغتون»، نودّ ضمان أن تكون تجربتك مع منتجاتنا تجربة متميزة قبل، وأثناء، وبعد عملية الشراء. نحن نعمل بشكلٍ حصري مع مجموعة مُختارة من الشركاء في مختلف أنحاء العالم ممّن قد نالوا امتياز كونهم بائعي تجزئة معتمدين لـ «دانيال ولينغتون».',
    legalP2: 'سواءً كنت تشتري من أحد متاجر البيع بالتجزئة أو عبر شبكة الإنترنت، نريدك أن تحظى بتجربة تتركك راضٍ تماما. وقد أثبت شركاؤنا في البيع بالتجزئة أنهم مُلتزمون بتقديم مستوى خدمة ممتاز بشكلٍ ثابت.',
    legalP3: 'إن الطريقة الوحيدة لتضمن أنك تشتري ساعة «دانيال ولينغتون» أصليّة هي أن تقوم بشرائها من أحد باعة التجزئة المُعتمدين أو من خلال danielwellington.com',
    legalP4: 'عند شرائك ساعة من أحد باعة التجزئة المُعتمدين لـ «دانيال ولينغتون»، يمكنك الاطمئنان:',
    legalP5: 'في حال الشراء من أحد الباعة غير الممُعتمدين، مثل «أمازون» و«إيباي» و«غروبون»، ثمّة مجازفة باستلام ساعة مُزيّفة أو مُستعملة أو معيبة. لا تقبل «دانيال ولينغتون» أي طلبات كفالة غير مُرفقة بالوثائق الأصليّة.',
    legalP6: 'للمزيد من المعلومات ولإيجاد وكيل أو بائع تجزئة مُعتمد في منطقتك، يرجى زيارة www.danielwellington.com/authorized-retailers'
  },
  se: {
    authorised: 'Vad är en auktoriserad återförsäljare?',
    directions: 'Hämta väganvisning',
    continue: 'Fortsätt shoppa',
    listHeader: 'Butik visas på kartan',
    listHeaderMult: 'Butiker visas på kartan',
    matrix: 'km',
    myPosition: 'Min position',
    search: 'Sök på land, region, stad, adress, postadress ...',
    closed: 'Stängt',
    showIpad: 'Visa på karta',
    monFri: 'Mån - Fre',
    sat: 'Lör',
    sun: 'Sön',
    legalH1: 'AUKTORISERAD ÅTERFÖRSÄLJARE',
    legalH2: 'VARFÖR HANDLA HOS EN AUKTORISERAD ÅTERFÖRSÄLJARE?',
    legalL1: 'Du köper en autentiskt klocka från Daniel Wellington',
    legalL2: 'Du får Daniel Wellingtons världsomspännande garanti',
    legalL3: 'All service och alla reparationer utförs av erfaren personal',
    legalL4: 'Du får uppleva en förstklassig kundtjänst',
    legalP1: 'Vi på Daniel Wellington vill att du får en överlägsen upplevelse av våra produkter både före, under och efter ditt köp. Vi arbetar exklusivt med ett urval av partners över hela världen, som har förtjänat privilegiet att vara auktoriserade återförsäljare för Daniel Wellington.',
    legalP2: 'Oavsett om du handlar i butik eller online vill vi att du alltid är nöjd med din upplevelse, och våra återförsäljare har visat oss att de inte nöjer sig med något annat än en förstklassig service.',
    legalP3: 'Det enda sättet för dig att få en garanti för att du har köpt en autentisk Daniel Wellington-klocka är att köpa den hos en auktoriserad återförsäljare eller på danielwellington.com.',
    legalP4: 'När du köper en klocka av en auktoriserad Daniel Wellington-återförsäljare får du en garanti för att:',
    legalP5: 'Om du handlar från e-handelsplattformar som eBay och Groupon eller en oauktoriserad tredjepartsleverantör på Amazon så riskerar du att få en klocka som är begagnad, innehåller defekter eller är en kopia. Daniel Wellington tar inte emot garantireklamationer som inte åtföljs av originaldokumentet.',
    legalP6: ''
  },
  sk: {
    authorised: 'Aký je autorizovaný predajca?',
    directions: 'Získať informácie o trase',
    continue: 'Pokračovať v nákupe',
    listHeader: 'Ukázať obchod na mape',
    listHeaderMult: 'Obchody zobrazené na mape',
    matrix: 'km',
    myPosition: 'Moja pozícia',
    search: 'Hľadať podľa krajiny, štátu, mesta, adresy, PSČ... ',
    closed: 'Zatvorené',
    showIpad: 'Ukázať na mape',
    monFri: 'Pondelok – piatok',
    sat: 'Sobota',
    sun: 'Nedeľa',
    legalH1: 'AUTORIZOVANÍ MALOOBCHODNÍ PREDAJCOVIA',
    legalH2: 'PREČO NAKUPOVAŤ OD AUTORIZOVANÉHO PREDAJCU?',
    legalL1: 'Kupujete originálne hodinky Daniel Wellington',
    legalL2: 'Vaše hodinky budú kryté medzinárodnou zárukou spoločnosti Daniel Wellington',
    legalL3: 'Všetky služby a opravy vykonávajú skúsení odborníci',
    legalL4: 'Máte k dispozícii zákaznícky servis na najvyššej úrovni',
    legalP1: 'V spoločnosti Daniel Wellington chceme zabezpečiť, aby vaše skúsenosti s našimi produktmi boli vynikajúce pred ich kúpou, počas nej a aj po nej. Pracujeme exkluzívne so skupinou vybraných partnerov z celého sveta, ktorí získali privilegované postavenie autorizovaného maloobchodného predajcu značky Daniel Wellington.',
    legalP2: 'Či už nakupujete v maloobchodnej predajni, alebo online, chceme vám poskytnúť zážitok absolútnej spokojnosti. Naši maloobchodní partneri nám dokázali, že sú odhodlaní poskytovať trvale vynikajúcu úroveň služieb.',
    legalP3: 'Jediný istý spôsob, ako si kúpiť originálne hodinky Daniel Wellington, je ich kúpa cez autorizovaného predajcu alebo na stránke danielwellington.com.',
    legalP4: 'Pokiaľ si hodinky kúpite od autorizovaného predajcu Daniel Wellington, máte istotu, že:',
    legalP5: 'Keď nakupujete na internetových platformách, ako je eBay a Groupon, alebo od neautorizovaného predajcu tretej strany na platforme Amazon, hrozí, že dostanete falošné, použité alebo pokazené hodinky. Daniel Wellington neuznáva nároky na záruku, ku ktorým nie je predložená originálna dokumentácia.',
    legalP6: 'Bližšie informácie a rady, ako nájsť autorizovaného predajcu vo svojej blízkosti, nájdete na stránke www.danielwellington.com/autorizovani-predajcovia'
  },
  th: {
    authorised: 'ผู้ค้าปลีกที่ได้รับอนุญาตคืออะไร',
    directions: 'หาข้อมูลบอกทิศทาง',
    continue: 'ซื้อสินค้าต่อ',
    listHeader: 'ร้านค้าที่ปรากฏบนแผนที่',
    listHeaderMult: 'ร้านค้าที่ปรากฏบนแผนที่',
    matrix: 'km',
    myPosition: 'ตำแหน่งที่ตั้งของฉัน',
    search: 'ค้นหาตามชื่อประเทศ, รัฐ, เมือง/จังหวัด, ที่อยู่, รหัสไปรษณีย์…',
    closed: 'ปิด',
    showIpad: 'แสดงบนแผนที่',
    monFri: 'จันทร์ - ศุกร์',
    sat: 'เสาร์',
    sun: 'อาทิตย์',
  },
  tr: {
    authorised: 'Yetkili perakende satıcı nedir?',
    directions: 'Yol tarifi alın',
    continue: 'Alışverişe devam edin',
    listHeader: 'Haritada gösterilen mağaza',
    listHeaderMult: 'Haritada gösterilen mağazalar',
    matrix: 'km',
    myPosition: 'Pozisyonum',
    search: 'Ülke, eyalet, şehir, adres, posta kodu ile arama yapın ...',
    closed: 'Kapalı',
    showIpad: 'Haritada göster',
    monFri: 'Pazartesi - Cuma',
    sat: 'Cumartesi',
    sun: 'Pazar',
    legalH1: 'Yetkili Bayiler',
    legalH2: 'Niçin bir yetkili bayiden satın almalısınız?',
    legalL1: 'Orijinal bir Daniel Wellington saat satın alıyorsunuz',
    legalL2: 'Saatiniz Daniel Wellington uluslararası garanti kapsamında yer alıyor',
    legalL3: 'Her türlü servis veya tamir işlemi, deneyimli personel tarafından yerine getirilecek',
    legalL4: 'En üst düzey müşteri hizmeti deneyimini yaşayacaksınız',
    legalP1: 'Daniel Wellington\'da ürünlerimizle yaşadığınız deneyimin satın almanız öncesinde, sırasında ve sonrasında mükemmel olduğundan emin olmak istiyoruz. Dünya çapında Daniel Wellington yetkili bayisi olma ayrıcalığına erişmiş seçkin bir ortaklar grubuyla birlikte özel olarak çalışmaktayız.',
    legalP2: 'Gerek bir perakende satış mağazasından gerekse internetten satın almış olun, sizi tamamen memnun edecek bir deneyim yaşamanızı istiyoruz. Perakende ortaklarımız, bizlere sürekli mükemmel seviyede bir deneyim sunacaklarına kendilerini adamış oldukları hususuna bizlere kanıtlamış bulunmaktadır.',
    legalP3: 'Orijinal bir Daniel Wellington saat aldığınıza emin olmanızın tek yolu, o ürünü ya bir yetkili bayiden ya da danielwellington.com internet sitesinden satın almaktır.',
    legalP4: 'Yetkili bir Daniel Wellington bayisinden bir saat satın aldığınız zaman emin olabilirsiniz ki:',
    legalP5: 'Ürünlerimizi eBay ve Groupon gibi e-ticaret platformlarından veyaAmazon\'da yetkisiz bir üçüncü parti satıcıdan satın almanız durumunda size sahte, kullanılmış ya da kusurlu bir saatin ulaşması riski mevcuttur. Daniel Wellington, orijinal garanti belgesi eşliğinde iletilmeksizin hiçbir garanti kapsamında işlem talebine itibar etmemektedir.',
    legalP6: 'Daha detaylı bilgi edinmek ve size en yakın yetkili bayiyi veya perakende satıcıyı bulmak için lütfen web sitemizi ziyaret edin: www.danielwellington.com/storelocator'
  },
  ua: {
    authorised: 'Що таке авторизирований ретейлер?',
    directions: 'Отримати напрямки',
    continue: 'Продовжити покупки',
    listHeader: 'Магазин на карті',
    listHeaderMult: 'Магазини на карті',
    matrix: 'км',
    myPosition: 'Моє розташування',
    search: 'Пошук за країною, штатом, містом, адресою, поштовим індексом тощо ...',
    closed: 'Закрито',
    showIpad: 'Показати на карті',
    monFri: 'З понеділка по п\'ятницю',
    sat: 'Суббота',
    sun: 'Неділя',
    legalH1: 'АВТОРИЗОВАНІ РЕТЕЙЛЕРИ',
    legalH2: 'НАВІЩО КУПУВАТИ В АВТОРИЗОВАНИХ РЕТЕЙЛЕРІВ?',
    legalL1: 'Ви купуєте справжній годинник Daniel Wellington',
    legalL2: 'На ваш годинник від Daniel Wellington поширюється міжнародна гарантія',
    legalL3: 'Будь-яке обслуговування або ремонт буде проводитися досвідченим персоналом',
    legalL4: 'Вам буде надано найвищий рівень обслуговування',
    legalP1: 'У Daniel Wellington ми піклуємося про те, щоб ваш досвід із нашими товарами був бездоганний до, під час та після здійснення покупки. Ми працюємо виключно з вибраною групою партнерів по всьому світі, які отримали привілей бути авторизованими ретейлерами Daniel Wellington.',
    legalP2: 'Чи здійснили ви покупку в магазині або онлайн, ми хочемо, щоб ви залишилися повністю задоволеними. Наші ретейлери довели, що вони налаштовані забезпечувати постійний відмінний рівень послуг.',
    legalP3: 'Єдиний спосіб бути впевненим, що ви купуєте справжній годинник Daniel Wellington, — це здійснення покупки в авторизованого ретейлера або на сайті danielwellington.com.',
    legalP4: 'Купуючи годинник Daniel Wellington в авторизованого ретейлера, ви можете бути впевнені в наступному.',
    legalP5: 'Якщо покупка здійснюється на таких інтернет-платформах, як eBay і Groupon, або в неавторизованої третьої сторони на Amazon, існує ризик отримати підробний, уживаний або несправний годинник. Daniel Wellington не приймає претензій щодо гарантії, якщо вона не підкріплена оригінальними документами.',
    legalP6: 'Докладніше про те, як знайти авторизованого дилера або ретейлера у вашій місцевості, дивіться на сайті: www.danielwellington.com/authorized-retailers'
  },
  vn: {
    authorised: 'Đại lý bán lẻ được ủy quyền là gì?',
    directions: 'Tải hướng dẫn',
    continue: 'Tiếp tục mua sắm',
    listHeader: 'Cửa hàng hiển thị trên bản đồ',
    listHeaderMult: 'Các cửa hàng hiển thị trên bản đồ',
    matrix: 'km',
    myPosition: 'Vị trí của tôi',
    search: 'Tìm kiếm theo quốc gia, bang, thành phố, địa chỉ, mã zip…',
    closed: 'Đóng',
    showIpad: 'Hiển thị trên bản đồ',
    monFri: 'Thứ Hai - Thứ Sáu',
    sat: 'Thứ Bảy',
    sun: 'Chủ Nhật',
  }
}


/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Overview_Index__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Overview_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Overview_Index__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/:lang?',
    props: true,
    name: 'Map',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Overview_Index___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (to.path.toLowerCase() !== to.path) {
        return next(to.path.toLowerCase());
      }
      next();
    }
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
  __webpack_require__(242)
  __webpack_require__(243)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(415),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5930af97",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__localizations_locales__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__localizations_locales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__localizations_locales__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
  load: {
    key: 'AIzaSyA2KXx4lNcdCzwoD3jj-K5fKkFWS1dETd4',
    libraries: 'places'
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = true;

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = '/api';

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;
var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  state: {
    bounds: null,
    connected: true,
    error: null,
    currentPosition: false,
    initPosition: null,
    loading: true,
    positionWithinBounds: false,
    selectedMarker: null,
    showLegalModal: false
  },
  mutations: {
    bounds: function bounds(state, _bounds) {
      state.bounds = _bounds;
    },
    connected: function connected(state, coords) {
      state.connected = coords;
    },
    error: function error(state, coords) {
      state.error = coords;
    },
    initPosition: function initPosition(state, coords) {
      state.initPosition = coords;
    },
    loading: function loading(state, isLoading) {
      state.loading = isLoading;
    },
    currentPosition: function currentPosition(state, coords) {
      state.currentPosition = coords;
    },
    positionWithinBounds: function positionWithinBounds(state, bool) {
      state.positionWithinBounds = bool;
    },
    showLegalModal: function showLegalModal(state, bool) {
      state.showLegalModal = bool;
    },
    selectedMarker: function selectedMarker(state, marker) {
      state.selectedMarker = marker;
    }
  }
});

var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: __WEBPACK_IMPORTED_MODULE_6__localizations_locales___default.a,
  fallbackLocale: 'en'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: store,
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

var countries = function countries(key) {
  var _br$ca$ca_fr$ca_en$mx;

  var countryKey = typeof key === 'string' ? key.toLowerCase() : 'unknown';
  return (_br$ca$ca_fr$ca_en$mx = {
    br: {
      country: 'Brazil',
      stronghold: 'Americas'
    },
    ca: {
      country: 'Canada',
      stronghold: 'Americas'
    },
    ca_fr: {
      country: 'Canada',
      stronghold: 'Americas'
    },
    ca_en: {
      country: 'Canada',
      stronghold: 'Americas'
    },
    mx: {
      country: 'Mexico',
      stronghold: 'Americas'
    },
    us: {
      country: 'USA',
      stronghold: 'Americas'
    },
    au: {
      country: 'Australia',
      stronghold: 'APAC'
    },
    hk: {
      country: 'Hong Kong',
      stronghold: 'APAC'
    },
    hk_en: {
      country: 'Hong Kong',
      stronghold: 'APAC'
    },
    id: {
      country: 'Indonesia',
      stronghold: 'APAC'
    },
    jp: {
      country: 'Japan',
      stronghold: 'APAC'
    },
    kr: {
      country: 'Korea',
      stronghold: 'APAC'
    },
    my: {
      country: 'Malaysia',
      stronghold: 'APAC'
    },
    nz: {
      country: 'New Zealand',
      stronghold: 'APAC'
    },
    ph: {
      country: 'Philippines',
      stronghold: 'APAC'
    },
    sg: {
      country: 'Singapore',
      stronghold: 'APAC'
    },
    th: {
      country: 'Thailand',
      stronghold: 'APAC'
    },
    tw: {
      country: 'Taiwan',
      stronghold: 'APAC'
    },
    vn: {
      country: 'Vietnam',
      stronghold: 'APAC'
    },
    kz: {
      country: 'Kazakhstan',
      stronghold: 'APAC'
    },
    cn: {
      country: 'China',
      stronghold: 'China'
    },
    at: {
      country: 'Austria',
      stronghold: 'Europe'
    },
    ch: {
      country: 'Switzerland',
      stronghold: 'Europe'
    },
    de: {
      country: 'Germany',
      stronghold: 'Europe'
    },
    dk: {
      country: 'Denmark',
      stronghold: 'Europe'
    },
    es: {
      country: 'Spain',
      stronghold: 'Europe'
    },
    eu: {
      country: 'Europe',
      stronghold: 'Europe'
    },
    fi: {
      country: 'Finland',
      stronghold: 'Europe'
    },
    fr: {
      country: 'France',
      stronghold: 'Europe'
    },
    it: {
      country: 'Italy',
      stronghold: 'Europe'
    },
    nl: {
      country: 'Netherlands',
      stronghold: 'Europe'
    },
    no: {
      country: 'Norway',
      stronghold: 'Europe'
    },
    pl: {
      country: 'Poland',
      stronghold: 'Europe'
    },
    pt: {
      country: 'Portugal',
      stronghold: 'Europe'
    },
    ru: {
      country: 'Russia',
      stronghold: 'Europe'
    },
    hr: {
      country: 'Croatia',
      stronghold: 'Europe'
    },
    cz: {
      country: 'Czech',
      stronghold: 'Europe'
    },
    se: {
      country: 'Sweden',
      stronghold: 'Europe'
    },
    uk: {
      country: 'United Kingdom',
      stronghold: 'Europe'
    },
    ro: {
      country: 'Romania',
      stronghold: 'Europe'
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'ro', {
    country: 'Romania',
    stronghold: 'Europe'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'sk', {
    country: 'Slovakia',
    stronghold: 'Europe'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'hu', {
    country: 'Hungary',
    stronghold: 'Europe'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'global', {
    country: 'Global',
    stronghold: 'Global'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'ae', {
    country: 'Arabic Emirates',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'ae_sa', {
    country: 'Arabic Emirates',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'ae_en', {
    country: 'Arabic Emirates',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'eg', {
    country: 'Egypt',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'eg_en', {
    country: 'Egypt',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'in', {
    country: 'India',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'il', {
    country: 'Israel',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'me', {
    country: 'Middle East & Africa',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'mea', {
    country: 'Middle East & Africa',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'sa', {
    country: 'Saudi arabia',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'sa_ar', {
    country: 'Saudi arabia',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'tr', {
    country: 'Turkiska',
    stronghold: 'IMEA'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_br$ca$ca_fr$ca_en$mx, 'za', {
    country: 'South Africa',
    stronghold: 'IMEA'
  }), _br$ca$ca_fr$ca_en$mx)[countryKey] || {
    stronghold: 'unknown',
    name: 'unknown'
  };
};

/* harmony default export */ __webpack_exports__["a"] = (countries);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_countries__ = __webpack_require__(167);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      locale: window.location.pathname.split('/').filter(function (a) {
        return a;
      })[0] || ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    var langs = {
      da: 'dk',
      ge: 'de',
      sa: 'sa_ar',
      sv: 'se',
      zh: 'cn',
      kz: 'kz_kk'
    };

    this.$i18n.locale = langs[this.locale] || this.locale || 'en';
    if (true) {
      var _window$dataLayer$pus;

      /*eslint-disable */
      window.dataLayer.push((_window$dataLayer$pus = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_window$dataLayer$pus, 'site.strongholdName', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_countries__["a" /* default */])(this.$i18n.locale).stronghold), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_window$dataLayer$pus, 'site.websiteId', this.$i18n.locale), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_window$dataLayer$pus, 'site.storeViewId', this.$i18n.locale), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_window$dataLayer$pus, 'site.websiteName', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_countries__["a" /* default */])(this.$i18n.locale).country), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_window$dataLayer$pus, 'site.version', '1'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_window$dataLayer$pus, 'user.isInternal', document.cookie.indexOf('isinternal=') > -1 ? 'yes' : 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_window$dataLayer$pus, 'site.environment', window.location.host.indexOf('test-') > -1 ? 'stage' : window.location.host.indexOf('dev-') > -1 ? 'test' : 'prod'), _window$dataLayer$pus));
      // Initiate GA after datalayer has been populated
      var gaEnv = window.location.hostname.split('-')[0];
      if (gaEnv !== 'localhost' && gaEnv !== 'test' && gaEnv !== 'dev') {
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-5Z46J5');
      }
      /*eslint-enable */
    }

    window.addEventListener('online', function () {
      _this.$store.commit('connected', true);
    }, false);
    window.addEventListener('offline', function () {
      _this.$store.commit('connected', false);
    }, false);
  }
});

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_Authorised__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_Authorised___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_Authorised__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Map__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_List__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_Popup__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_Popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_Popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Search__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_Type__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_Type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_Type__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  props: ['lang'],
  components: {
    Authorised: __WEBPACK_IMPORTED_MODULE_0__partials_Authorised___default.a,
    GoogleMap: __WEBPACK_IMPORTED_MODULE_1__partials_Map___default.a,
    List: __WEBPACK_IMPORTED_MODULE_2__partials_List___default.a,
    Popup: __WEBPACK_IMPORTED_MODULE_3__partials_Popup___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_4__partials_Search___default.a,
    Type: __WEBPACK_IMPORTED_MODULE_5__partials_Type___default.a
  },
  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    }
  }
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Auth',
  computed: {
    active: function active() {
      return this.$store.state.showLegalModal;
    }
  },
  methods: {
    toggleAuthorised: function toggleAuthorised(bool) {
      this.$store.commit('showLegalModal', bool);
    }
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_geodist__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_geodist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_geodist__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',
  data: function data() {
    return {
      service: null,
      showGradient: false,
      showMaximum: 50,
      stores: [],
      timer: null
    };
  },
  computed: {
    bounds: function bounds() {
      return this.$store.state.bounds;
    },
    listHeaderNo: function listHeaderNo() {
      return '' + (this.stores.length >= this.showMaximum ? '+' : '') + this.stores.length;
    },
    listHeaderSuffix: function listHeaderSuffix() {
      return '' + this.$t(this.stores.length > 1 ? 'listHeaderMult' : 'listHeader');
    },
    selectedMarker: function selectedMarker() {
      return this.$store.state.selectedMarker;
    },
    position: function position() {
      return this.$store.state.currentPosition;
    }
  },
  methods: {
    calculateDistance: function calculateDistance() {
      var _this = this;

      if (!this.position) return;
      var maxdist = 20000;

      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        var dests = _this.stores.slice(0, 10).filter(function (marker) {
          return marker.geodist < maxdist;
        }).map(function (marker) {
          return new google.maps.LatLng(marker.latitude, marker.longitude);
        });

        _this.getDistanceService(dests).then(function (rows) {
          var _loop = function _loop(index) {
            setTimeout(function () {
              if (_this.stores[index]) {
                var distanceText = rows[index] && rows[index].status === 'OK' && rows[index].distance.value < maxdist ? (rows[index].distance.value / 1000).toFixed(1) : _this.stores[index].geodist < maxdist ? (_this.stores[index].geodist * 1.2 / 1000).toFixed(1) : '+' + maxdist / 1000;
                _this.$set(_this.stores[index], 'distance', distanceText);
              }
            }, 100 * index);
          };

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.stores.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _ref = _step.value;

              var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 1);

              var index = _ref2[0];

              _loop(index);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }).catch(function () {
          // Silent fail
        });
      }, 1000);
    },
    getDistanceService: function getDistanceService(destinations) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (destinations.length === 0) return resolve({});

        _this2.service.getDistanceMatrix({
          origins: [new google.maps.LatLng(_this2.position.latitude, _this2.position.longitude)],
          destinations: destinations,
          travelMode: 'WALKING'
        }, function (response, status) {
          if (status !== 'OK') reject();
          resolve(response.rows[0].elements);
        });
      });
    },
    filterSeen: function filterSeen(markers) {
      var _this3 = this;

      if (!this.bounds) return;

      this.stores = markers.filter(function (marker) {
        if (_this3.position) {
          var origin = { lat: _this3.position.latitude, lon: _this3.position.longitude };
          var dist = { lat: marker.latitude, lon: marker.longitude };
          marker.geodist = __WEBPACK_IMPORTED_MODULE_4_geodist___default()(origin, dist, { unit: 'meters' });
        }

        var latitude = marker.latitude,
            longitude = marker.longitude;

        var latLng = new google.maps.LatLng(latitude, longitude);
        return _this3.bounds.contains(latLng);
      }).sort(function (a, b) {
        if (a.monobrand === b.monobrand) {
          return a.geodist < b.geodist ? -1 : 1;
        }
        return a.monobrand && (a.monobrand === '1' || a.monobrand === true) ? -1 : 1;
      }).splice(0, this.showMaximum);

      this.calculateDistance();
    },
    listClick: function listClick(marker) {
      this.$store.commit('selectedMarker', marker);
      scroll(0, 0);
    }
  },
  watch: {
    stores: function stores() {
      var _this4 = this;

      this.$nextTick(function () {
        var el = document.getElementById('items');
        _this4.showGradient = el.scrollHeight > el.clientHeight;
      });
    },
    position: function position() {
      this.filterSeen(this.stores);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* EventBus */].$on('googleReady', function () {
      _this5.service = new google.maps.DistanceMatrixService();
    });
    __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* EventBus */].$on('markers', this.filterSeen);
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_map_style_json__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_map_style_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_map_style_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ngeohash__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ngeohash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ngeohash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_supercluster__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_supercluster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_supercluster__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GoogleMap',
  props: ['lang'],
  data: function data() {
    return {
      bounds: null,
      currentZoom: null,
      cluster: null,
      clusters: [],
      monoBrandStores: [],
      currentlySeenGeohashes: [],
      mapCenter: { lat: 48, lng: 18 },
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: true,
        gestureHandling: 'greedy',
        styles: __WEBPACK_IMPORTED_MODULE_5__assets_map_style_json___default.a
      },
      mapZoom: 5,
      marker: null,
      maxZoomOut: 6,
      place: null,
      position: null,
      request: null,
      stores: [],
      timer: null
    };
  },
  computed: {
    currentPosition: function currentPosition() {
      return this.$store.state.currentPosition;
    },
    map: function map() {
      return this.$refs.map;
    },
    selectedMarker: function selectedMarker() {
      return this.$store.state.selectedMarker;
    }
  },
  methods: {
    constructIcon: function constructIcon(type, scaled) {
      return {
        url: ('/static/images/types/' + type + '.png').toLowerCase(),
        scaledSize: new (Function.prototype.bind.apply(google.maps.Size, [null].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(scaled))))(),
        labelOrigin: new google.maps.Point(12, 13)
      };
    },
    createCluster: function createCluster() {
      this.cluster = __WEBPACK_IMPORTED_MODULE_8_supercluster___default()({
        radius: 160,
        maxZoom: 16
      });
      this.monoBrandStores = this.stores.filter(function (s) {
        return s.monobrand === '1' || s.monobrand === true;
      }).map(function (store) {
        return {
          coords: {
            lat: parseFloat(store.latitude),
            lng: parseFloat(store.longitude)
          },
          properties: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, store)
        };
      });
      var places = this.stores.filter(function (s) {
        return !s.monobrand || s.monobrand !== '1';
      }).map(function (store) {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [store.longitude, store.latitude]
          },
          properties: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, store)
        };
      });

      try {
        this.cluster.load(places);
      } catch (e) {
        console.debug('Failed to create cluster', e);
      }
    },
    getMarkers: function getMarkers() {
      var _bounds$toJSON = this.bounds.toJSON(),
          south = _bounds$toJSON.south,
          west = _bounds$toJSON.west,
          north = _bounds$toJSON.north,
          east = _bounds$toJSON.east;

      this.clusters = this.cluster.getClusters([west, south, east, north], this.currentZoom).map(function (cluster) {
        cluster.coords = {
          lng: parseFloat(cluster.geometry.coordinates[0]),
          lat: parseFloat(cluster.geometry.coordinates[1])
        };
        return cluster;
      });
    },
    fetchStores: function fetchStores() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _bounds$toJSON2 = _this.bounds.toJSON(),
            south = _bounds$toJSON2.south,
            west = _bounds$toJSON2.west,
            north = _bounds$toJSON2.north,
            east = _bounds$toJSON2.east;

        var zoom = _this.map.$mapObject.zoom;

        if (zoom < _this.maxZoomOut) {
          _this.currentlySeenGeohashes = [];
          _this.stores = [];
          return resolve();
        }

        var additionalGeohashes = __WEBPACK_IMPORTED_MODULE_6_ngeohash___default.a.bboxes(south, west, north, east, 3).filter(function (hash) {
          return !(_this.currentlySeenGeohashes.indexOf(hash) > -1);
        });

        _this.currentZoom = zoom;

        /* Cancel last request if a new is made */
        var CancelToken = _this.$http.CancelToken;
        if (_this.request !== null) _this.request.cancel();
        _this.request = CancelToken.source();

        if (additionalGeohashes.length === 0) return resolve();

        _this.$http.all(additionalGeohashes.map(function (geohash) {
          return _this.$http.get('/stores/geohash/' + geohash, {
            cancelToken: _this.request.token
          });
        })).then(function (response) {
          _this.currentlySeenGeohashes = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this.currentlySeenGeohashes), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(additionalGeohashes));

          var items = response.reduce(function (prev, curr) {
            return prev.concat(curr.data);
          }, []).filter(function (item) {
            return (!item.closingDate || Date.now() < item.closingDate) && (!item.openingDate || Date.now() > item.openingDate);
          });

          _this.stores = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this.stores), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(items));
          return resolve();
        }).catch(function () {
          // Silent fail
        });
      });
    },
    hasAcceptedPosition: function hasAcceptedPosition() {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!navigator.permissions) {
          return resolve(false);
        }
        navigator.permissions.query({ name: 'geolocation' }).then(function (permission) {
          return resolve(permission.state === 'granted');
        });
      });
    },
    tryToFetchCurrentPosition: function tryToFetchCurrentPosition() {
      __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* EventBus */].$emit('getCurrentPosition');
    },
    tryToFetchCountryPosition: function tryToFetchCountryPosition() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!_this2.lang) return resolve(false);

        var redirects = {
          sa_ar: 'sa'
        };

        var overrides = {
          ir: 'iran',
          uk: 'england'
        };

        var address = overrides[_this2.lang] || __WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries___default.a.getName(redirects[_this2.lang] || _this2.lang, 'en');

        if (!address) return resolve(false);

        new google.maps.Geocoder().geocode({ address: address }, function (results, status) {
          if (status !== 'OK') return resolve(false);

          _this2.place = results[0];
          return resolve(_this2.place.geometry.viewport);
        });
      });
    },
    initializeCenter: function initializeCenter() {
      var _this3 = this;

      this.hasAcceptedPosition().then(function (hasAccepted) {
        if (hasAccepted) _this3.tryToFetchCurrentPosition();

        _this3.tryToFetchCountryPosition().then(function (viewport) {
          if (viewport && !(_this3.currentPosition !== null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this3.currentPosition) === 'object')) {
            _this3.map.fitBounds(viewport);
            _this3.$store.commit('initPosition', viewport);
          }

          if (!hasAccepted) {
            _this3.$store.commit('loading', false);
          }
        });
      });
    },
    onBoundsChanged: function onBoundsChanged(bounds) {
      var _this4 = this;

      this.bounds = bounds;
      this.$store.commit('bounds', bounds);

      if (this.selectedMarker) {
        var _selectedMarker = this.selectedMarker,
            latitude = _selectedMarker.latitude,
            longitude = _selectedMarker.longitude;

        var latLng = new google.maps.LatLng(latitude, longitude);

        if (!this.bounds.contains(latLng)) {
          this.$store.commit('selectedMarker', null);
        }
      }

      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this4.mapZoom = _this4.map.$mapObject.zoom;
        _this4.mapCenter = _this4.map.$mapObject.center;

        _this4.fetchStores().then(_this4.createCluster).then(_this4.getMarkers).then(_this4.setList);

        if (!_this4.currentPosition) return;

        var currentLatLng = new google.maps.LatLng(_this4.currentPosition.latitude, _this4.currentPosition.longitude);
        var isWithin = _this4.bounds.contains(currentLatLng);
        if (isWithin !== _this4.positionWithinBounds) {
          _this4.positionWithinBounds = isWithin;
          _this4.$store.commit('positionWithinBounds', _this4.bounds.contains(currentLatLng));
        }
      }, 60);
    },
    onMarkerClick: function onMarkerClick(marker) {
      var latLng = new google.maps.LatLng(marker.geometry.coordinates[1], marker.geometry.coordinates[0]);

      if ((marker.properties || {}).cluster_id) {
        // If cluster
        this.mapCenter = latLng;
        this.mapZoom = this.cluster.getClusterExpansionZoom(marker.properties.cluster_id);
      } else {
        // If marker
        this.map.panTo(latLng);
        this.$store.commit('selectedMarker', marker.properties);
      }
    },
    setList: function setList() {
      __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* EventBus */].$emit('markers', this.stores);
    },
    centerMarker: function centerMarker(marker) {
      if (!marker) return;

      var latLng = new google.maps.LatLng(marker.latitude, marker.longitude);
      this.map.panTo(latLng);
      if (this.map.$mapObject.zoom < 15) this.mapZoom = 15;
    },
    recenterViewport: function recenterViewport() {
      if (this.$store.state.initPosition) {
        return this.map.fitBounds(this.$store.state.initPosition);
      }
    },
    updateMapOnAutoComplete: function updateMapOnAutoComplete(place) {
      if (!place.geometry) return;
      this.place = place;
      this.map.fitBounds(place.geometry.viewport);
    }
  },
  watch: {
    selectedMarker: function selectedMarker(marker) {
      this.centerMarker(marker);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* EventBus */].$on('autocomplete', this.updateMapOnAutoComplete);
    __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* EventBus */].$on('recenterViewport', this.recenterViewport);
    __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* EventBus */].$on('recenterPosition', function () {
      _this5.centerMarker(_this5.currentPosition);
    });

    this.map.$mapCreated.then(function () {
      _this5.initializeCenter();
      __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* EventBus */].$emit('googleReady');
    });
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Popup',
  computed: {
    marker: function marker() {
      return this.$store.state.selectedMarker;
    },
    phone: function phone() {
      if (this.marker.details && this.marker.details.phone) {
        return this.marker.details.phone.replace('-', ' - ');
      } else if (this.marker.phone) {
        return this.marker.phone.replace('-', ' - ');
      } else {
        return null;
      }
    },
    hours: function hours() {
      if (!(((this.marker || {}).details || {}).opening_hours || {}).periods) return null;
      var periods = this.marker.details.opening_hours.periods;

      var hours = {};

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(periods), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var period = _step.value;

          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(hours, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, period.open.day, hours[period.open.day] || {}));

          if (hours[period.open.day].open === undefined) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(hours[period.open.day], { open: period.open.time });
          }
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(hours[period.open.day], { close: period.close.time });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return hours;
    },
    url: function url() {
      if (!this.marker) return null;

      if (this.marker.googleID) {
        // eslint-disable-line
        return 'https://www.google.com/maps/place/?q=place_id:' + this.marker.googleID;
      }

      var saddr = '';

      if (this.$store.state.currentPosition) {
        saddr = 'saddr=' + this.$store.state.currentPosition.latitude + ',' + this.$store.state.currentPosition.longitude + '&';
      }
      var daddr = 'daddr=' + this.marker.latitude + ',' + this.marker.longitude;
      return 'https://maps.google.com/maps?' + saddr + daddr;
    }
  },
  methods: {
    closePopup: function closePopup() {
      this.$store.commit('selectedMarker', null);
    }
  },
  watch: {
    marker: function marker(_marker) {
      var _this = this;

      if (!_marker || !_marker.googleID) return;

      this.$http.get('/stores/google/details/' + _marker.googleID).then(function (response) {
        _this.$set(_this.marker, 'details', response.data);
      }).catch(function (err) {
        console.error(err);
      });
    }
  }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__(38);

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Position',
  data: function data() {
    return {
      options: {
        maximumAge: 30000,
        timeout: 10000,
        enableHighAccuracy: true
      }
    };
  },
  computed: {
    positionWithinBounds: function positionWithinBounds() {
      return this.$store.state.positionWithinBounds;
    },
    currentPosition: function currentPosition() {
      return this.$store.state.currentPosition;
    }
  },
  methods: {
    _success: function _success(position) {
      var _position$coords = position.coords,
          latitude = _position$coords.latitude,
          longitude = _position$coords.longitude;

      this.$store.commit('currentPosition', { latitude: latitude, longitude: longitude });
      this.$store.commit('loading', false);
    },
    _error: function _error() {
      this.$store.commit('currentPosition', false);
      this.$store.commit('loading', false);
      __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* EventBus */].$emit('recenterViewport');
    },
    getCurrentPosition: function getCurrentPosition() {
      if (this.currentPosition !== null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.currentPosition) === 'object') {
        return __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* EventBus */].$emit('recenterPosition');
      }

      if (navigator.geolocation) {
        this.$store.commit('currentPosition', null);
        this.$store.commit('loading', true);
        navigator.geolocation.watchPosition(this._success, this._error, this.options);
      }
    }
  },
  watch: {
    currentPosition: function currentPosition(newVal, oldVal) {
      if (newVal !== null && (typeof newVal === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(newVal)) === 'object' && !oldVal) {
        __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* EventBus */].$emit('recenterPosition');
      }
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* EventBus */].$on('getCurrentPosition', this.getCurrentPosition);
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositionButton__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PositionButton__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',
  components: {
    Position: __WEBPACK_IMPORTED_MODULE_1__PositionButton___default.a
  },
  data: function data() {
    return {
      autocomplete: null
    };
  },
  methods: {
    openAutocomplete: function openAutocomplete() {
      document.getElementsByClassName('pac-container')[0].style.display = 'block';
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* EventBus */].$on('googleReady', function () {
      _this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: [] });
      _this.autocomplete.addListener('place_changed', function () {
        __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* EventBus */].$emit('autocomplete', _this.autocomplete.getPlace());
      });
    });
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Type',
  methods: {
    toggleAuthorised: function toggleAuthorised(bool) {
      this.$store.commit('showLegalModal', bool);
    }
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports = [
	[
		"AF",
		"AFG",
		"004",
		"ISO 3166-2:AF"
	],
	[
		"AX",
		"ALA",
		"248",
		"ISO 3166-2:AX"
	],
	[
		"AL",
		"ALB",
		"008",
		"ISO 3166-2:AL"
	],
	[
		"DZ",
		"DZA",
		"012",
		"ISO 3166-2:DZ"
	],
	[
		"AS",
		"ASM",
		"016",
		"ISO 3166-2:AS"
	],
	[
		"AD",
		"AND",
		"020",
		"ISO 3166-2:AD"
	],
	[
		"AO",
		"AGO",
		"024",
		"ISO 3166-2:AO"
	],
	[
		"AI",
		"AIA",
		"660",
		"ISO 3166-2:AI"
	],
	[
		"AQ",
		"ATA",
		"010",
		"ISO 3166-2:AQ"
	],
	[
		"AG",
		"ATG",
		"028",
		"ISO 3166-2:AG"
	],
	[
		"AR",
		"ARG",
		"032",
		"ISO 3166-2:AR"
	],
	[
		"AM",
		"ARM",
		"051",
		"ISO 3166-2:AM"
	],
	[
		"AW",
		"ABW",
		"533",
		"ISO 3166-2:AW"
	],
	[
		"AU",
		"AUS",
		"036",
		"ISO 3166-2:AU"
	],
	[
		"AT",
		"AUT",
		"040",
		"ISO 3166-2:AT"
	],
	[
		"AZ",
		"AZE",
		"031",
		"ISO 3166-2:AZ"
	],
	[
		"BS",
		"BHS",
		"044",
		"ISO 3166-2:BS"
	],
	[
		"BH",
		"BHR",
		"048",
		"ISO 3166-2:BH"
	],
	[
		"BD",
		"BGD",
		"050",
		"ISO 3166-2:BD"
	],
	[
		"BB",
		"BRB",
		"052",
		"ISO 3166-2:BB"
	],
	[
		"BY",
		"BLR",
		"112",
		"ISO 3166-2:BY"
	],
	[
		"BE",
		"BEL",
		"056",
		"ISO 3166-2:BE"
	],
	[
		"BZ",
		"BLZ",
		"084",
		"ISO 3166-2:BZ"
	],
	[
		"BJ",
		"BEN",
		"204",
		"ISO 3166-2:BJ"
	],
	[
		"BM",
		"BMU",
		"060",
		"ISO 3166-2:BM"
	],
	[
		"BT",
		"BTN",
		"064",
		"ISO 3166-2:BT"
	],
	[
		"BO",
		"BOL",
		"068",
		"ISO 3166-2:BO"
	],
	[
		"BQ",
		"BES",
		"535",
		"ISO 3166-2:BQ"
	],
	[
		"BA",
		"BIH",
		"070",
		"ISO 3166-2:BA"
	],
	[
		"BW",
		"BWA",
		"072",
		"ISO 3166-2:BW"
	],
	[
		"BV",
		"BVT",
		"074",
		"ISO 3166-2:BV"
	],
	[
		"BR",
		"BRA",
		"076",
		"ISO 3166-2:BR"
	],
	[
		"IO",
		"IOT",
		"086",
		"ISO 3166-2:IO"
	],
	[
		"BN",
		"BRN",
		"096",
		"ISO 3166-2:BN"
	],
	[
		"BG",
		"BGR",
		"100",
		"ISO 3166-2:BG"
	],
	[
		"BF",
		"BFA",
		"854",
		"ISO 3166-2:BF"
	],
	[
		"BI",
		"BDI",
		"108",
		"ISO 3166-2:BI"
	],
	[
		"KH",
		"KHM",
		"116",
		"ISO 3166-2:KH"
	],
	[
		"CM",
		"CMR",
		"120",
		"ISO 3166-2:CM"
	],
	[
		"CA",
		"CAN",
		"124",
		"ISO 3166-2:CA"
	],
	[
		"CV",
		"CPV",
		"132",
		"ISO 3166-2:CV"
	],
	[
		"KY",
		"CYM",
		"136",
		"ISO 3166-2:KY"
	],
	[
		"CF",
		"CAF",
		"140",
		"ISO 3166-2:CF"
	],
	[
		"TD",
		"TCD",
		"148",
		"ISO 3166-2:TD"
	],
	[
		"CL",
		"CHL",
		"152",
		"ISO 3166-2:CL"
	],
	[
		"CN",
		"CHN",
		"156",
		"ISO 3166-2:CN"
	],
	[
		"CX",
		"CXR",
		"162",
		"ISO 3166-2:CX"
	],
	[
		"CC",
		"CCK",
		"166",
		"ISO 3166-2:CC"
	],
	[
		"CO",
		"COL",
		"170",
		"ISO 3166-2:CO"
	],
	[
		"KM",
		"COM",
		"174",
		"ISO 3166-2:KM"
	],
	[
		"CG",
		"COG",
		"178",
		"ISO 3166-2:CG"
	],
	[
		"CD",
		"COD",
		"180",
		"ISO 3166-2:CD"
	],
	[
		"CK",
		"COK",
		"184",
		"ISO 3166-2:CK"
	],
	[
		"CR",
		"CRI",
		"188",
		"ISO 3166-2:CR"
	],
	[
		"CI",
		"CIV",
		"384",
		"ISO 3166-2:CI"
	],
	[
		"HR",
		"HRV",
		"191",
		"ISO 3166-2:HR"
	],
	[
		"CU",
		"CUB",
		"192",
		"ISO 3166-2:CU"
	],
	[
		"CW",
		"CUW",
		"531",
		"ISO 3166-2:CW"
	],
	[
		"CY",
		"CYP",
		"196",
		"ISO 3166-2:CY"
	],
	[
		"CZ",
		"CZE",
		"203",
		"ISO 3166-2:CZ"
	],
	[
		"DK",
		"DNK",
		"208",
		"ISO 3166-2:DK"
	],
	[
		"DJ",
		"DJI",
		"262",
		"ISO 3166-2:DJ"
	],
	[
		"DM",
		"DMA",
		"212",
		"ISO 3166-2:DM"
	],
	[
		"DO",
		"DOM",
		"214",
		"ISO 3166-2:DO"
	],
	[
		"EC",
		"ECU",
		"218",
		"ISO 3166-2:EC"
	],
	[
		"EG",
		"EGY",
		"818",
		"ISO 3166-2:EG"
	],
	[
		"SV",
		"SLV",
		"222",
		"ISO 3166-2:SV"
	],
	[
		"GQ",
		"GNQ",
		"226",
		"ISO 3166-2:GQ"
	],
	[
		"ER",
		"ERI",
		"232",
		"ISO 3166-2:ER"
	],
	[
		"EE",
		"EST",
		"233",
		"ISO 3166-2:EE"
	],
	[
		"ET",
		"ETH",
		"231",
		"ISO 3166-2:ET"
	],
	[
		"FK",
		"FLK",
		"238",
		"ISO 3166-2:FK"
	],
	[
		"FO",
		"FRO",
		"234",
		"ISO 3166-2:FO"
	],
	[
		"FJ",
		"FJI",
		"242",
		"ISO 3166-2:FJ"
	],
	[
		"FI",
		"FIN",
		"246",
		"ISO 3166-2:FI"
	],
	[
		"FR",
		"FRA",
		"250",
		"ISO 3166-2:FR"
	],
	[
		"GF",
		"GUF",
		"254",
		"ISO 3166-2:GF"
	],
	[
		"PF",
		"PYF",
		"258",
		"ISO 3166-2:PF"
	],
	[
		"TF",
		"ATF",
		"260",
		"ISO 3166-2:TF"
	],
	[
		"GA",
		"GAB",
		"266",
		"ISO 3166-2:GA"
	],
	[
		"GM",
		"GMB",
		"270",
		"ISO 3166-2:GM"
	],
	[
		"GE",
		"GEO",
		"268",
		"ISO 3166-2:GE"
	],
	[
		"DE",
		"DEU",
		"276",
		"ISO 3166-2:DE"
	],
	[
		"GH",
		"GHA",
		"288",
		"ISO 3166-2:GH"
	],
	[
		"GI",
		"GIB",
		"292",
		"ISO 3166-2:GI"
	],
	[
		"GR",
		"GRC",
		"300",
		"ISO 3166-2:GR"
	],
	[
		"GL",
		"GRL",
		"304",
		"ISO 3166-2:GL"
	],
	[
		"GD",
		"GRD",
		"308",
		"ISO 3166-2:GD"
	],
	[
		"GP",
		"GLP",
		"312",
		"ISO 3166-2:GP"
	],
	[
		"GU",
		"GUM",
		"316",
		"ISO 3166-2:GU"
	],
	[
		"GT",
		"GTM",
		"320",
		"ISO 3166-2:GT"
	],
	[
		"GG",
		"GGY",
		"831",
		"ISO 3166-2:GG"
	],
	[
		"GN",
		"GIN",
		"324",
		"ISO 3166-2:GN"
	],
	[
		"GW",
		"GNB",
		"624",
		"ISO 3166-2:GW"
	],
	[
		"GY",
		"GUY",
		"328",
		"ISO 3166-2:GY"
	],
	[
		"HT",
		"HTI",
		"332",
		"ISO 3166-2:HT"
	],
	[
		"HM",
		"HMD",
		"334",
		"ISO 3166-2:HM"
	],
	[
		"VA",
		"VAT",
		"336",
		"ISO 3166-2:VA"
	],
	[
		"HN",
		"HND",
		"340",
		"ISO 3166-2:HN"
	],
	[
		"HK",
		"HKG",
		"344",
		"ISO 3166-2:HK"
	],
	[
		"HU",
		"HUN",
		"348",
		"ISO 3166-2:HU"
	],
	[
		"IS",
		"ISL",
		"352",
		"ISO 3166-2:IS"
	],
	[
		"IN",
		"IND",
		"356",
		"ISO 3166-2:IN"
	],
	[
		"ID",
		"IDN",
		"360",
		"ISO 3166-2:ID"
	],
	[
		"IR",
		"IRN",
		"364",
		"ISO 3166-2:IR"
	],
	[
		"IQ",
		"IRQ",
		"368",
		"ISO 3166-2:IQ"
	],
	[
		"IE",
		"IRL",
		"372",
		"ISO 3166-2:IE"
	],
	[
		"IM",
		"IMN",
		"833",
		"ISO 3166-2:IM"
	],
	[
		"IL",
		"ISR",
		"376",
		"ISO 3166-2:IL"
	],
	[
		"IT",
		"ITA",
		"380",
		"ISO 3166-2:IT"
	],
	[
		"JM",
		"JAM",
		"388",
		"ISO 3166-2:JM"
	],
	[
		"JP",
		"JPN",
		"392",
		"ISO 3166-2:JP"
	],
	[
		"JE",
		"JEY",
		"832",
		"ISO 3166-2:JE"
	],
	[
		"JO",
		"JOR",
		"400",
		"ISO 3166-2:JO"
	],
	[
		"KZ",
		"KAZ",
		"398",
		"ISO 3166-2:KZ"
	],
	[
		"KE",
		"KEN",
		"404",
		"ISO 3166-2:KE"
	],
	[
		"KI",
		"KIR",
		"296",
		"ISO 3166-2:KI"
	],
	[
		"KP",
		"PRK",
		"408",
		"ISO 3166-2:KP"
	],
	[
		"KR",
		"KOR",
		"410",
		"ISO 3166-2:KR"
	],
	[
		"KW",
		"KWT",
		"414",
		"ISO 3166-2:KW"
	],
	[
		"KG",
		"KGZ",
		"417",
		"ISO 3166-2:KG"
	],
	[
		"LA",
		"LAO",
		"418",
		"ISO 3166-2:LA"
	],
	[
		"LV",
		"LVA",
		"428",
		"ISO 3166-2:LV"
	],
	[
		"LB",
		"LBN",
		"422",
		"ISO 3166-2:LB"
	],
	[
		"LS",
		"LSO",
		"426",
		"ISO 3166-2:LS"
	],
	[
		"LR",
		"LBR",
		"430",
		"ISO 3166-2:LR"
	],
	[
		"LY",
		"LBY",
		"434",
		"ISO 3166-2:LY"
	],
	[
		"LI",
		"LIE",
		"438",
		"ISO 3166-2:LI"
	],
	[
		"LT",
		"LTU",
		"440",
		"ISO 3166-2:LT"
	],
	[
		"LU",
		"LUX",
		"442",
		"ISO 3166-2:LU"
	],
	[
		"MO",
		"MAC",
		"446",
		"ISO 3166-2:MO"
	],
	[
		"MK",
		"MKD",
		"807",
		"ISO 3166-2:MK"
	],
	[
		"MG",
		"MDG",
		"450",
		"ISO 3166-2:MG"
	],
	[
		"MW",
		"MWI",
		"454",
		"ISO 3166-2:MW"
	],
	[
		"MY",
		"MYS",
		"458",
		"ISO 3166-2:MY"
	],
	[
		"MV",
		"MDV",
		"462",
		"ISO 3166-2:MV"
	],
	[
		"ML",
		"MLI",
		"466",
		"ISO 3166-2:ML"
	],
	[
		"MT",
		"MLT",
		"470",
		"ISO 3166-2:MT"
	],
	[
		"MH",
		"MHL",
		"584",
		"ISO 3166-2:MH"
	],
	[
		"MQ",
		"MTQ",
		"474",
		"ISO 3166-2:MQ"
	],
	[
		"MR",
		"MRT",
		"478",
		"ISO 3166-2:MR"
	],
	[
		"MU",
		"MUS",
		"480",
		"ISO 3166-2:MU"
	],
	[
		"YT",
		"MYT",
		"175",
		"ISO 3166-2:YT"
	],
	[
		"MX",
		"MEX",
		"484",
		"ISO 3166-2:MX"
	],
	[
		"FM",
		"FSM",
		"583",
		"ISO 3166-2:FM"
	],
	[
		"MD",
		"MDA",
		"498",
		"ISO 3166-2:MD"
	],
	[
		"MC",
		"MCO",
		"492",
		"ISO 3166-2:MC"
	],
	[
		"MN",
		"MNG",
		"496",
		"ISO 3166-2:MN"
	],
	[
		"ME",
		"MNE",
		"499",
		"ISO 3166-2:ME"
	],
	[
		"MS",
		"MSR",
		"500",
		"ISO 3166-2:MS"
	],
	[
		"MA",
		"MAR",
		"504",
		"ISO 3166-2:MA"
	],
	[
		"MZ",
		"MOZ",
		"508",
		"ISO 3166-2:MZ"
	],
	[
		"MM",
		"MMR",
		"104",
		"ISO 3166-2:MM"
	],
	[
		"NA",
		"NAM",
		"516",
		"ISO 3166-2:NA"
	],
	[
		"NR",
		"NRU",
		"520",
		"ISO 3166-2:NR"
	],
	[
		"NP",
		"NPL",
		"524",
		"ISO 3166-2:NP"
	],
	[
		"NL",
		"NLD",
		"528",
		"ISO 3166-2:NL"
	],
	[
		"NC",
		"NCL",
		"540",
		"ISO 3166-2:NC"
	],
	[
		"NZ",
		"NZL",
		"554",
		"ISO 3166-2:NZ"
	],
	[
		"NI",
		"NIC",
		"558",
		"ISO 3166-2:NI"
	],
	[
		"NE",
		"NER",
		"562",
		"ISO 3166-2:NE"
	],
	[
		"NG",
		"NGA",
		"566",
		"ISO 3166-2:NG"
	],
	[
		"NU",
		"NIU",
		"570",
		"ISO 3166-2:NU"
	],
	[
		"NF",
		"NFK",
		"574",
		"ISO 3166-2:NF"
	],
	[
		"MP",
		"MNP",
		"580",
		"ISO 3166-2:MP"
	],
	[
		"NO",
		"NOR",
		"578",
		"ISO 3166-2:NO"
	],
	[
		"OM",
		"OMN",
		"512",
		"ISO 3166-2:OM"
	],
	[
		"PK",
		"PAK",
		"586",
		"ISO 3166-2:PK"
	],
	[
		"PW",
		"PLW",
		"585",
		"ISO 3166-2:PW"
	],
	[
		"PS",
		"PSE",
		"275",
		"ISO 3166-2:PS"
	],
	[
		"PA",
		"PAN",
		"591",
		"ISO 3166-2:PA"
	],
	[
		"PG",
		"PNG",
		"598",
		"ISO 3166-2:PG"
	],
	[
		"PY",
		"PRY",
		"600",
		"ISO 3166-2:PY"
	],
	[
		"PE",
		"PER",
		"604",
		"ISO 3166-2:PE"
	],
	[
		"PH",
		"PHL",
		"608",
		"ISO 3166-2:PH"
	],
	[
		"PN",
		"PCN",
		"612",
		"ISO 3166-2:PN"
	],
	[
		"PL",
		"POL",
		"616",
		"ISO 3166-2:PL"
	],
	[
		"PT",
		"PRT",
		"620",
		"ISO 3166-2:PT"
	],
	[
		"PR",
		"PRI",
		"630",
		"ISO 3166-2:PR"
	],
	[
		"QA",
		"QAT",
		"634",
		"ISO 3166-2:QA"
	],
	[
		"RE",
		"REU",
		"638",
		"ISO 3166-2:RE"
	],
	[
		"RO",
		"ROU",
		"642",
		"ISO 3166-2:RO"
	],
	[
		"RU",
		"RUS",
		"643",
		"ISO 3166-2:RU"
	],
	[
		"RW",
		"RWA",
		"646",
		"ISO 3166-2:RW"
	],
	[
		"BL",
		"BLM",
		"652",
		"ISO 3166-2:BL"
	],
	[
		"SH",
		"SHN",
		"654",
		"ISO 3166-2:SH"
	],
	[
		"KN",
		"KNA",
		"659",
		"ISO 3166-2:KN"
	],
	[
		"LC",
		"LCA",
		"662",
		"ISO 3166-2:LC"
	],
	[
		"MF",
		"MAF",
		"663",
		"ISO 3166-2:MF"
	],
	[
		"PM",
		"SPM",
		"666",
		"ISO 3166-2:PM"
	],
	[
		"VC",
		"VCT",
		"670",
		"ISO 3166-2:VC"
	],
	[
		"WS",
		"WSM",
		"882",
		"ISO 3166-2:WS"
	],
	[
		"SM",
		"SMR",
		"674",
		"ISO 3166-2:SM"
	],
	[
		"ST",
		"STP",
		"678",
		"ISO 3166-2:ST"
	],
	[
		"SA",
		"SAU",
		"682",
		"ISO 3166-2:SA"
	],
	[
		"SN",
		"SEN",
		"686",
		"ISO 3166-2:SN"
	],
	[
		"RS",
		"SRB",
		"688",
		"ISO 3166-2:RS"
	],
	[
		"SC",
		"SYC",
		"690",
		"ISO 3166-2:SC"
	],
	[
		"SL",
		"SLE",
		"694",
		"ISO 3166-2:SL"
	],
	[
		"SG",
		"SGP",
		"702",
		"ISO 3166-2:SG"
	],
	[
		"SX",
		"SXM",
		"534",
		"ISO 3166-2:SX"
	],
	[
		"SK",
		"SVK",
		"703",
		"ISO 3166-2:SK"
	],
	[
		"SI",
		"SVN",
		"705",
		"ISO 3166-2:SI"
	],
	[
		"SB",
		"SLB",
		"090",
		"ISO 3166-2:SB"
	],
	[
		"SO",
		"SOM",
		"706",
		"ISO 3166-2:SO"
	],
	[
		"ZA",
		"ZAF",
		"710",
		"ISO 3166-2:ZA"
	],
	[
		"GS",
		"SGS",
		"239",
		"ISO 3166-2:GS"
	],
	[
		"SS",
		"SSD",
		"728",
		"ISO 3166-2:SS"
	],
	[
		"ES",
		"ESP",
		"724",
		"ISO 3166-2:ES"
	],
	[
		"LK",
		"LKA",
		"144",
		"ISO 3166-2:LK"
	],
	[
		"SD",
		"SDN",
		"729",
		"ISO 3166-2:SD"
	],
	[
		"SR",
		"SUR",
		"740",
		"ISO 3166-2:SR"
	],
	[
		"SJ",
		"SJM",
		"744",
		"ISO 3166-2:SJ"
	],
	[
		"SZ",
		"SWZ",
		"748",
		"ISO 3166-2:SZ"
	],
	[
		"SE",
		"SWE",
		"752",
		"ISO 3166-2:SE"
	],
	[
		"CH",
		"CHE",
		"756",
		"ISO 3166-2:CH"
	],
	[
		"SY",
		"SYR",
		"760",
		"ISO 3166-2:SY"
	],
	[
		"TW",
		"TWN",
		"158",
		"ISO 3166-2:TW"
	],
	[
		"TJ",
		"TJK",
		"762",
		"ISO 3166-2:TJ"
	],
	[
		"TZ",
		"TZA",
		"834",
		"ISO 3166-2:TZ"
	],
	[
		"TH",
		"THA",
		"764",
		"ISO 3166-2:TH"
	],
	[
		"TL",
		"TLS",
		"626",
		"ISO 3166-2:TL"
	],
	[
		"TG",
		"TGO",
		"768",
		"ISO 3166-2:TG"
	],
	[
		"TK",
		"TKL",
		"772",
		"ISO 3166-2:TK"
	],
	[
		"TO",
		"TON",
		"776",
		"ISO 3166-2:TO"
	],
	[
		"TT",
		"TTO",
		"780",
		"ISO 3166-2:TT"
	],
	[
		"TN",
		"TUN",
		"788",
		"ISO 3166-2:TN"
	],
	[
		"TR",
		"TUR",
		"792",
		"ISO 3166-2:TR"
	],
	[
		"TM",
		"TKM",
		"795",
		"ISO 3166-2:TM"
	],
	[
		"TC",
		"TCA",
		"796",
		"ISO 3166-2:TC"
	],
	[
		"TV",
		"TUV",
		"798",
		"ISO 3166-2:TV"
	],
	[
		"UG",
		"UGA",
		"800",
		"ISO 3166-2:UG"
	],
	[
		"UA",
		"UKR",
		"804",
		"ISO 3166-2:UA"
	],
	[
		"AE",
		"ARE",
		"784",
		"ISO 3166-2:AE"
	],
	[
		"GB",
		"GBR",
		"826",
		"ISO 3166-2:GB"
	],
	[
		"US",
		"USA",
		"840",
		"ISO 3166-2:US"
	],
	[
		"UM",
		"UMI",
		"581",
		"ISO 3166-2:UM"
	],
	[
		"UY",
		"URY",
		"858",
		"ISO 3166-2:UY"
	],
	[
		"UZ",
		"UZB",
		"860",
		"ISO 3166-2:UZ"
	],
	[
		"VU",
		"VUT",
		"548",
		"ISO 3166-2:VU"
	],
	[
		"VE",
		"VEN",
		"862",
		"ISO 3166-2:VE"
	],
	[
		"VN",
		"VNM",
		"704",
		"ISO 3166-2:VN"
	],
	[
		"VG",
		"VGB",
		"092",
		"ISO 3166-2:VG"
	],
	[
		"VI",
		"VIR",
		"850",
		"ISO 3166-2:VI"
	],
	[
		"WF",
		"WLF",
		"876",
		"ISO 3166-2:WF"
	],
	[
		"EH",
		"ESH",
		"732",
		"ISO 3166-2:EH"
	],
	[
		"YE",
		"YEM",
		"887",
		"ISO 3166-2:YE"
	],
	[
		"ZM",
		"ZMB",
		"894",
		"ISO 3166-2:ZM"
	],
	[
		"ZW",
		"ZWE",
		"716",
		"ISO 3166-2:ZW"
	],
	[
		"XK",
		"XKX",
		"",
		"ISO 3166-2:XK"
	]
];

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

module.exports = {
	"AF": " أفغانستان",
	"AL": " ألبانيا",
	"DZ": " الجزائر",
	"AS": " ساموا الأمريكية",
	"AD": " أندورا",
	"AO": " أنغولا",
	"AI": " أنغويلا",
	"AQ": " القارة القطبية الجنوبية",
	"AG": " أنتيغوا وباربودا",
	"AR": " الأرجنتين",
	"AM": " أرمينيا",
	"AW": " أروبا",
	"AU": " أستراليا",
	"AT": " النمسا",
	"AZ": " أذربيجان",
	"BS": " باهاماس",
	"BH": " البحرين",
	"BD": " بنغلاديش",
	"BB": " باربادوس",
	"BY": " روسيا البيضاء",
	"BE": " بلجيكا",
	"BZ": " بليز",
	"BJ": " بنين",
	"BM": " برمودا",
	"BT": " بوتان",
	"BO": " بوليفيا",
	"BA": " البوسنة والهرسك",
	"BW": " بوتسوانا",
	"BV": " جزيرة بوفيه",
	"BR": " البرازيل",
	"IO": " إقليم المحيط الهندي البريطاني",
	"BN": " بروناي",
	"BG": " بلغاريا",
	"BF": " بوركينا فاسو",
	"BI": " بوروندي",
	"KH": " كمبوديا",
	"CM": " الكاميرون",
	"CA": " كندا",
	"CV": " الرأس الأخضر",
	"KY": " جزر كايمان",
	"CF": " جمهورية أفريقيا الوسطى",
	"TD": " تشاد",
	"CL": " تشيلي",
	"CN": " الصين",
	"CX": " جزيرة عيد الميلاد",
	"CC": " جزر كوكوس",
	"CO": " كولومبيا",
	"KM": " جزر القمر",
	"CG": " جمهورية الكونغو",
	"CD": " جمهورية الكونغو الديمقراطية",
	"CK": " جزر كوك",
	"CR": " كوستاريكا",
	"CI": " ساحل العاج",
	"HR": " كرواتيا",
	"CU": " كوبا",
	"CY": " قبرص",
	"CZ": " جمهورية التشيك",
	"DK": " الدنمارك",
	"DJ": " جيبوتي",
	"DM": " دومينيكا",
	"DO": " جمهورية الدومينيكان",
	"EC": " الإكوادور",
	"EG": " مصر",
	"SV": " السلفادور",
	"GQ": " غينيا الاستوائية",
	"ER": " إريتريا",
	"EE": " إستونيا",
	"ET": " إثيوبيا",
	"FK": " جزر فوكلاند",
	"FO": " جزر فارو",
	"FJ": " فيجي",
	"FI": " فنلندا",
	"FR": " فرنسا",
	"GF": " غويانا الفرنسية",
	"PF": " بولينزيا الفرنسية",
	"TF": " أراض فرنسية جنوبية وأنتارتيكية",
	"GA": " الغابون",
	"GM": " غامبيا",
	"GE": " جورجيا",
	"DE": " ألمانيا",
	"GH": " غانا",
	"GI": " جبل طارق",
	"GR": " اليونان",
	"GL": " جرينلاند",
	"GD": " غرينادا",
	"GP": " غوادلوب",
	"GU": " غوام",
	"GT": " غواتيمالا",
	"GN": " غينيا",
	"GW": " غينيا بيساو",
	"GY": " غيانا",
	"HT": " هايتي",
	"HM": " جزيرة هيرد وجزر ماكدونالد",
	"VA": "  الفاتيكان",
	"HN": " هندوراس",
	"HK": " هونغ كونغ",
	"HU": " المجر",
	"IS": " آيسلندا",
	"IN": " الهند",
	"ID": " إندونيسيا",
	"IR": " إيران",
	"IQ": " العراق",
	"IE": " أيرلندا",
	"IL": " إسرائيل",
	"IT": " إيطاليا",
	"JM": " جامايكا",
	"JP": " اليابان",
	"JO": " الأردن",
	"KZ": " كازاخستان",
	"KE": " كينيا",
	"KI": " كيريباتي",
	"KP": " كوريا الشمالية",
	"KR": " كوريا الجنوبية",
	"KW": " الكويت",
	"KG": " قيرغيزستان",
	"LA": " لاوس",
	"LV": " لاتفيا",
	"LB": " لبنان",
	"LS": " ليسوتو",
	"LR": " ليبيريا",
	"LY": " ليبيا",
	"LI": " ليختنشتاين",
	"LT": " ليتوانيا",
	"LU": " لوكسمبورغ",
	"MO": " ماكاو",
	"MK": " مقدونيا",
	"MG": " مدغشقر",
	"MW": " مالاوي",
	"MY": " ماليزيا",
	"MV": " جزر المالديف",
	"ML": " مالي",
	"MT": " مالطا",
	"MH": " جزر مارشال",
	"MQ": " مارتينيك",
	"MR": " موريتانيا",
	"MU": " موريشيوس",
	"YT": " مايوت",
	"MX": " المكسيك",
	"FM": " ولايات ميكرونيسيا المتحدة",
	"MD": " مولدوفا",
	"MC": " موناكو",
	"MN": " منغوليا",
	"MS": " مونتسرات",
	"MA": " المغرب",
	"MZ": " موزمبيق",
	"MM": " بورما",
	"NA": " ناميبيا",
	"NR": " ناورو",
	"NP": " نيبال",
	"NL": " هولندا",
	"NC": " كاليدونيا الجديدة",
	"NZ": " نيوزيلندا",
	"NI": " نيكاراغوا",
	"NE": " النيجر",
	"NG": " نيجيريا",
	"NU": " نييوي",
	"NF": " جزيرة نورفولك",
	"MP": " جزر ماريانا الشمالية",
	"NO": " النرويج",
	"OM": " عمان",
	"PK": " باكستان",
	"PW": " بالاو",
	"PS": " فلسطين",
	"PA": " بنما",
	"PG": " بابوا غينيا الجديدة",
	"PY": " باراغواي",
	"PE": " بيرو",
	"PH": " الفلبين",
	"PN": " جزر بيتكيرن",
	"PL": " بولندا",
	"PT": " البرتغال",
	"PR": " بورتوريكو",
	"QA": " قطر",
	"RE": " لا ريونيون",
	"RO": " رومانيا",
	"RU": " روسيا",
	"RW": " رواندا",
	"SH": " سانت هيلينا وأسينشين وتريستان دا كونا",
	"KN": " سانت كيتس ونيفيس",
	"LC": " سانت لوسيا",
	"PM": " سان بيير وميكلون",
	"VC": " سانت فينسنت والغرينادين",
	"WS": " ساموا",
	"SM": " سان مارينو",
	"ST": " ساو تومي وبرينسيب",
	"SA": " السعودية",
	"SN": " السنغال",
	"SC": " سيشل",
	"SL": " سيراليون",
	"SG": " سنغافورة",
	"SK": " سلوفاكيا",
	"SI": " سلوفينيا",
	"SB": " جزر سليمان",
	"SO": " الصومال",
	"ZA": " جنوب أفريقيا",
	"GS": " جورجيا الجنوبية وجزر ساندويتش الجنوبية",
	"ES": " إسبانيا",
	"LK": " سريلانكا",
	"SD": " السودان",
	"SR": " سورينام",
	"SJ": " سفالبارد ويان ماين",
	"SZ": " سوازيلاند",
	"SE": " السويد",
	"CH": " سويسرا",
	"SY": " سوريا",
	"TW": " تايوان",
	"TJ": " طاجيكستان",
	"TZ": " تانزانيا",
	"TH": " تايلاند",
	"TL": " تيمور الشرقية",
	"TG": " توغو",
	"TK": " توكيلاو",
	"TO": " تونغا",
	"TT": "ترينيداد وتوباغو",
	"TN": " تونس",
	"TR": " تركيا",
	"TM": " تركمانستان",
	"TC": " جزر توركس وكايكوس",
	"TV": " توفالو",
	"UG": " أوغندا",
	"UA": " أوكرانيا",
	"AE": " الإمارات العربية المتحدة",
	"GB": " المملكة المتحدة",
	"US": " الولايات المتحدة",
	"UM": " جزر الولايات المتحدة",
	"UY": " الأوروغواي",
	"UZ": " أوزبكستان",
	"VU": " فانواتو",
	"VE": " فنزويلا",
	"VN": " فيتنام",
	"VG": " جزر العذراء البريطانية",
	"VI": " جزر العذراء الأمريكية",
	"WF": " والس وفوتونا",
	"EH": " الصحراء الغربية",
	"YE": " اليمن",
	"ZM": " زامبيا",
	"ZW": " زيمبابوي",
	"AX": " جزر أولاند",
	"BQ": " الجزر الكاريبية الهولندية",
	"CW": " كوراساو",
	"GG": " غيرنزي",
	"IM": " جزيرة مان",
	"JE": " جيرزي",
	"ME": " الجبل الأسود",
	"BL": " سان بارتيلمي",
	"MF": " سانت مارتن (الجزء الفرنسي)",
	"RS": " صربيا",
	"SX": " سانت مارتن (الجزء الهولندي)",
	"SS": " جنوب السودان",
	"XK": " كوسوفو"
};

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afghánistán",
	"AX": "Ålandy",
	"AL": "Albánie",
	"DZ": "Alžírsko",
	"AS": "Americká Samoa",
	"VI": "Americké Panenské ostrovy",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktida",
	"AG": "Antigua a Barbuda",
	"AR": "Argentina",
	"AM": "Arménie",
	"AW": "Aruba",
	"AU": "Austrálie",
	"AZ": "Ázerbájdžán",
	"BS": "Bahamy",
	"BH": "Bahrajn",
	"BD": "Bangladéš",
	"BB": "Barbados",
	"BE": "Belgie",
	"BZ": "Belize",
	"BY": "Bělorusko",
	"BJ": "Benin",
	"BM": "Bermudy",
	"BT": "Bhútán",
	"BO": "Bolívie",
	"BQ": "Bonaire, Svatý Eustach a Saba",
	"BA": "Bosna a Hercegovina",
	"BW": "Botswana",
	"BV": "Bouvetův ostrov",
	"BR": "Brazílie",
	"IO": "Britské indickooceánské území",
	"VG": "Britské Panenské ostrovy",
	"BN": "Brunej",
	"BG": "Bulharsko",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"CK": "Cookovy ostrovy",
	"CW": "Curaçao",
	"TD": "Čad",
	"ME": "Černá Hora",
	"CZ": "Česko",
	"CN": "Čína",
	"DK": "Dánsko",
	"CD": "Demokratická republika Kongo",
	"DM": "Dominika",
	"DO": "Dominikánská republika",
	"DJ": "Džibutsko",
	"EG": "Egypt",
	"EC": "Ekvádor",
	"ER": "Eritrea",
	"EE": "Estonsko",
	"ET": "Etiopie",
	"FO": "Faerské ostrovy",
	"FK": "Falklandy (Malvíny)",
	"FJ": "Fidži",
	"PH": "Filipíny",
	"FI": "Finsko",
	"FR": "Francie",
	"GF": "Francouzská Guyana",
	"TF": "Francouzská jižní a antarktická území",
	"PF": "Francouzská Polynésie",
	"GA": "Gabon",
	"GM": "Gambie",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GD": "Grenada",
	"GL": "Grónsko",
	"GE": "Gruzie",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GW": "Guinea-Bissau",
	"GG": "Guernsey",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heardův ostrov a McDonaldovy ostrovy",
	"HN": "Honduras",
	"HK": "Hongkong",
	"CL": "Chile",
	"HR": "Chorvatsko",
	"IN": "Indie",
	"ID": "Indonésie",
	"IQ": "Irák",
	"IR": "Írán",
	"IE": "Irsko",
	"IS": "Island",
	"IT": "Itálie",
	"IL": "Izrael",
	"JM": "Jamajka",
	"JP": "Japonsko",
	"YE": "Jemen",
	"JE": "Jersey",
	"ZA": "Jihoafrická republika",
	"GS": "Jižní Georgie a Jižní Sandwichovy ostrovy",
	"KR": "Jižní Korea",
	"SS": "Jižní Súdán",
	"JO": "Jordánsko",
	"KY": "Kajmanské ostrovy",
	"KH": "Kambodža",
	"CM": "Kamerun",
	"CA": "Kanada",
	"CV": "Kapverdy",
	"QA": "Katar",
	"KZ": "Kazachstán",
	"KE": "Keňa",
	"KI": "Kiribati",
	"CC": "Kokosové ostrovy",
	"CO": "Kolumbie",
	"KM": "Komory",
	"CG": "Kongo",
	"CR": "Kostarika",
	"CU": "Kuba",
	"KW": "Kuvajt",
	"CY": "Kypr",
	"KG": "Kyrgyzstán",
	"LA": "Laos",
	"LS": "Lesotho",
	"LB": "Libanon",
	"LR": "Libérie",
	"LY": "Libye",
	"LI": "Lichtenštejnsko",
	"LT": "Litva",
	"LV": "Lotyšsko",
	"LU": "Lucembursko",
	"MO": "Macao",
	"MG": "Madagaskar",
	"HU": "Maďarsko",
	"MK": "Makedonie",
	"MY": "Malajsie",
	"MW": "Malawi",
	"MV": "Maledivy",
	"ML": "Mali",
	"MT": "Malta",
	"IM": "Ostrov Man",
	"MA": "Maroko",
	"MH": "Marshallovy ostrovy",
	"MQ": "Martinik",
	"MU": "Mauricius",
	"MR": "Mauritánie",
	"YT": "Mayotte",
	"UM": "Menší odlehlé ostrovy USA",
	"MX": "Mexiko",
	"FM": "Mikronésie",
	"MD": "Moldavsko",
	"MC": "Monako",
	"MN": "Mongolsko",
	"MS": "Montserrat",
	"MZ": "Mosambik",
	"MM": "Myanmar",
	"NA": "Namibie",
	"NR": "Nauru",
	"DE": "Německo",
	"NP": "Nepál",
	"NE": "Niger",
	"NG": "Nigérie",
	"NI": "Nikaragua",
	"NU": "Niue",
	"NL": "Nizozemsko",
	"NF": "Norfolk",
	"NO": "Norsko",
	"NC": "Nová Kaledonie",
	"NZ": "Nový Zéland",
	"OM": "Omán",
	"PK": "Pákistán",
	"PW": "Palau",
	"PS": "Palestinská autonomie",
	"PA": "Panama",
	"PG": "Papua-Nová Guinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"PN": "Pitcairnovy ostrovy",
	"CI": "Pobřeží slonoviny",
	"PL": "Polsko",
	"PR": "Portoriko",
	"PT": "Portugalsko",
	"AT": "Rakousko",
	"RE": "Réunion",
	"GQ": "Rovníková Guinea",
	"RO": "Rumunsko",
	"RU": "Rusko",
	"RW": "Rwanda",
	"GR": "Řecko",
	"PM": "Saint-Pierre a Miquelon",
	"SV": "Salvador",
	"WS": "Samoa",
	"SM": "San Marino",
	"SA": "Saúdská Arábie",
	"SN": "Senegal",
	"KP": "Severní Korea",
	"MP": "Severní Mariany",
	"SC": "Seychely",
	"SL": "Sierra Leone",
	"SG": "Singapur",
	"SK": "Slovensko",
	"SI": "Slovinsko",
	"SO": "Somálsko",
	"AE": "Spojené arabské emiráty",
	"GB": "Spojené království",
	"US": "Spojené státy americké",
	"RS": "Srbsko",
	"CF": "Středoafrická republika",
	"SD": "Súdán",
	"SR": "Surinam",
	"SH": "Svatá Helena, Ascension a Tristan da Cunha",
	"LC": "Svatá Lucie",
	"BL": "Svatý Bartoloměj",
	"KN": "Svatý Kryštof a Nevis",
	"MF": "Svatý Martin (francouzská část)",
	"SX": "Svatý Martin (nizozemská část)",
	"ST": "Svatý Tomáš a Princův ostrov",
	"VC": "Svatý Vincenc a Grenadiny",
	"SZ": "Svazijsko",
	"SY": "Sýrie",
	"SB": "Šalamounovy ostrovy",
	"ES": "Španělsko",
	"SJ": "Špicberky a Jan Mayen",
	"LK": "Šrí Lanka",
	"SE": "Švédsko",
	"CH": "Švýcarsko",
	"TJ": "Tádžikistán",
	"TZ": "Tanzanie",
	"TH": "Thajsko",
	"TW": "Tchaj-wan",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad a Tobago",
	"TN": "Tunisko",
	"TR": "Turecko",
	"TM": "Turkmenistán",
	"TC": "Turks a Caicos",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukrajina",
	"UY": "Uruguay",
	"UZ": "Uzbekistán",
	"CX": "Vánoční ostrov",
	"VU": "Vanuatu",
	"VA": "Vatikán",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"TL": "Východní Timor",
	"WF": "Wallis a Futuna",
	"ZM": "Zambie",
	"EH": "Západní Sahara",
	"ZW": "Zimbabwe",
	"XK": "Kosovo"
};

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afghanistan",
	"AL": "Albanien",
	"DZ": "Algeriet",
	"AS": "Amerikansk Samoa",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktis",
	"AG": "Antigua og Barbuda",
	"AR": "Argentina",
	"AM": "Armenien",
	"AW": "Aruba",
	"AU": "Australien",
	"AT": "Østrig",
	"AZ": "Aserbajdsjan",
	"BS": "Bahamas",
	"BH": "Bahrain",
	"BD": "Bangladesh",
	"BB": "Barbados",
	"BY": "Hviderusland",
	"BE": "Belgien",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermuda",
	"BT": "Bhutan",
	"BO": "Bolivia",
	"BA": "Bosnien-Hercegovina",
	"BW": "Botswana",
	"BV": "Bouvet Island",
	"BR": "Brasilien",
	"IO": "British Indian Ocean Territory",
	"BN": "Brunei Darussalam",
	"BG": "Bulgarien",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KH": "Cambodja",
	"CM": "Cameroun",
	"CA": "Canada",
	"CV": "Kap Verde",
	"KY": "Caymanøerne",
	"CF": "Den Centralafrikanske Republik",
	"TD": "Tchad",
	"CL": "Chile",
	"CN": "Kina",
	"CX": "Juløen",
	"CC": "Cocosøerne",
	"CO": "Colombia",
	"KM": "Comorerne",
	"CG": "Congo",
	"CD": "Demokratiske Republik Congo",
	"CK": "Cookøerne",
	"CR": "Costa Rica",
	"CI": "Elfenbenskysten",
	"HR": "Kroatien",
	"CU": "Cuba",
	"CY": "Cypern",
	"CZ": "Tjekkiet",
	"DK": "Danmark",
	"DJ": "Djibouti",
	"DM": "Dominica",
	"DO": "Dominikanske Republik",
	"EC": "Ecuador",
	"EG": "Egypten",
	"SV": "El Salvador",
	"GQ": "Ækvatorialguinea",
	"ER": "Eritrea",
	"EE": "Estland",
	"ET": "Etiopien",
	"FK": "Falklandsøerne",
	"FO": "Færøerne",
	"FJ": "Fiji",
	"FI": "Finland",
	"FR": "Frankrig",
	"GF": "Fransk Guiana",
	"PF": "Fransk Polynesien",
	"TF": "Franske Sydterritorier",
	"GA": "Gabon",
	"GM": "Gambia",
	"GE": "Georgien",
	"DE": "Tyskland",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GR": "Grækenland",
	"GL": "Grønland",
	"GD": "Grenada",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heard-øen og McDonald-øerne",
	"VA": "Vatikanstaten",
	"HN": "Honduras",
	"HK": "Hong Kong",
	"HU": "Ungarn",
	"IS": "Island",
	"IN": "Indien",
	"ID": "Indonesien",
	"IR": "Iran",
	"IQ": "Irak",
	"IE": "Irland",
	"IL": "Israel",
	"IT": "Italien",
	"JM": "Jamaica",
	"JP": "Japan",
	"JO": "Jordan",
	"KZ": "Kazakhstan",
	"KE": "Kenya",
	"KI": "Kiribati",
	"KP": "Nordkorea",
	"KR": "Sydkorea",
	"KW": "Kuwait",
	"KG": "Kirgisistan",
	"LA": "Laos",
	"LV": "Letland",
	"LB": "Libanon",
	"LS": "Lesotho",
	"LR": "Liberia",
	"LY": "Libyen",
	"LI": "Liechtenstein",
	"LT": "Litauen",
	"LU": "Luxembourg",
	"MO": "Macao",
	"MK": "Makedonien",
	"MG": "Madagaskar",
	"MW": "Malawi",
	"MY": "Malaysia",
	"MV": "Maldiverne",
	"ML": "Mali",
	"MT": "Malta",
	"MH": "Marshalløerne",
	"MQ": "Martinique",
	"MR": "Mauretanien",
	"MU": "Mauritius",
	"YT": "Mayotte",
	"MX": "Mexico",
	"FM": "Mikronesien",
	"MD": "Moldova",
	"MC": "Monaco",
	"MN": "Mongoliet",
	"MS": "Montserrat",
	"MA": "Marokko",
	"MZ": "Mozambique",
	"MM": "Myanmar (Burma)",
	"NA": "Namibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NL": "Holland",
	"NC": "Ny Kaledonien",
	"NZ": "New Zealand",
	"NI": "Nicaragua",
	"NE": "Niger",
	"NG": "Nigeria",
	"NU": "Niue",
	"NF": "Norfolk Island",
	"MP": "Nordmarianerne",
	"NO": "Norge",
	"OM": "Oman",
	"PK": "Pakistan",
	"PW": "Palau",
	"PS": "Palæstina",
	"PA": "Panama",
	"PG": "Papua Ny Guinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"PH": "Filippinerne",
	"PN": "Pitcairn",
	"PL": "Polen",
	"PT": "Portugal",
	"PR": "Puerto Rico",
	"QA": "Qatar",
	"RE": "Réunion",
	"RO": "Rumænien",
	"RU": "Rusland",
	"RW": "Rwanda",
	"SH": "Sankt Helena",
	"KN": "Saint Kitts og Nevis",
	"LC": "Saint Lucia",
	"PM": "Saint-Pierre og Miquelon",
	"VC": "Saint Vincent og Grenadinerne",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "São Tomé og Príncipe",
	"SA": "Saudi-Arabien",
	"SN": "Senegal",
	"SC": "Seychellerne",
	"SL": "Sierra Leone",
	"SG": "Singapore",
	"SK": "Slovakiet",
	"SI": "Slovenien",
	"SB": "Salomonøerne",
	"SO": "Somalia",
	"ZA": "Sydafrika",
	"GS": "South Georgia og South Sandwich Islands",
	"ES": "Spanien",
	"LK": "Sri Lanka",
	"SD": "Sudan",
	"SR": "Surinam",
	"SJ": "Norge Svalbard og Jan Mayen",
	"SZ": "Swaziland",
	"SE": "Sverige",
	"CH": "Schweiz",
	"SY": "Syrien",
	"TW": "Republikken Kina Taiwan",
	"TJ": "Tadsjikistan",
	"TZ": "Tanzania",
	"TH": "Thailand",
	"TL": "Østtimor",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad og Tobago",
	"TN": "Tunesien",
	"TR": "Tyrkiet",
	"TM": "Turkmenistan",
	"TC": "Turks- og Caicosøerne",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukraine",
	"AE": "Forenede Arabiske Emirater",
	"GB": "Storbritannien",
	"US": "USA",
	"UM": "USA's ydre småøer",
	"UY": "Uruguay",
	"UZ": "Usbekistan",
	"VU": "Vanuatu",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"VG": "Britiske Jomfruøer",
	"VI": "Amerikanske Jomfruøer",
	"WF": "Wallis og Futuna",
	"EH": "Vestsahara",
	"YE": "Yemen",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"AX": "Ålandsøerne",
	"BQ": "Nederlandske Antiller",
	"CW": "Curaçao",
	"GG": "Guernsey",
	"IM": "Isle of Man",
	"JE": "Jersey",
	"ME": "Montenegro",
	"BL": "Saint-Barthélemy",
	"MF": "Saint Martin (fransk side)",
	"RS": "Serbien",
	"SX": "Saint Martin (hollandsk side)",
	"SS": "Sydsudan",
	"XK": "Kosovo"
};

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afghanistan",
	"EG": "Ägypten",
	"AX": "Åland",
	"AL": "Albanien",
	"DZ": "Algerien",
	"AS": "Amerikanisch-Samoa",
	"VI": "Amerikanische Jungferninseln",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktika",
	"AG": "Antigua und Barbuda",
	"GQ": "Äquatorialguinea",
	"AR": "Argentinien",
	"AM": "Armenien",
	"AW": "Aruba",
	"AZ": "Aserbaidschan",
	"ET": "Äthiopien",
	"AU": "Australien",
	"BS": "Bahamas",
	"BH": "Bahrain",
	"BD": "Bangladesch",
	"BB": "Barbados",
	"BY": "Weißrussland",
	"BE": "Belgien",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermuda",
	"BT": "Bhutan",
	"BO": "Bolivien",
	"BQ": "Bonaire",
	"BA": "Bosnien und Herzegowina",
	"BW": "Botswana",
	"BV": "Bouvetinsel",
	"BR": "Brasilien",
	"VG": "Britische Jungferninseln",
	"IO": "Britisches Territorium im Indischen Ozean",
	"BN": "Brunei Darussalam",
	"BG": "Bulgarien",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"CL": "Chile",
	"CN": "China",
	"CK": "Cookinseln",
	"CR": "Costa Rica",
	"CI": "Elfenbeinküste",
	"CW": "Curaçao",
	"DK": "Dänemark",
	"DE": "Deutschland",
	"DM": "Dominica",
	"DO": "Dominikanische Republik",
	"DJ": "Dschibuti",
	"EC": "Ecuador",
	"SV": "El Salvador",
	"ER": "Eritrea",
	"EE": "Estland",
	"FK": "Falklandinseln",
	"FO": "Färöer",
	"FJ": "Fidschi",
	"FI": "Finnland",
	"FR": "Frankreich",
	"GF": "Französisch-Guayana",
	"PF": "Französisch-Polynesien",
	"TF": "Französische Süd- und Antarktisgebiete",
	"GA": "Gabun",
	"GM": "Gambia",
	"GE": "Georgien",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GD": "Grenada",
	"GR": "Griechenland",
	"GL": "Grönland",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GG": "Guernsey",
	"GN": "Guinea",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heard und McDonaldinseln",
	"HN": "Honduras",
	"HK": "Hongkong",
	"IN": "Indien",
	"ID": "Indonesien",
	"IM": "Insel Man",
	"IQ": "Irak",
	"IR": "Iran",
	"IE": "Irland",
	"IS": "Island",
	"IL": "Israel",
	"IT": "Italien",
	"JM": "Jamaika",
	"JP": "Japan",
	"YE": "Jemen",
	"JE": "Jersey",
	"JO": "Jordanien",
	"KY": "Kaimaninseln",
	"KH": "Kambodscha",
	"CM": "Kamerun",
	"CA": "Kanada",
	"CV": "Kap Verde",
	"KZ": "Kasachstan",
	"QA": "Katar",
	"KE": "Kenia",
	"KG": "Kirgisistan",
	"KI": "Kiribati",
	"CC": "Kokosinseln",
	"CO": "Kolumbien",
	"KM": "Komoren",
	"CD": "Kongo",
	"KP": "Nordkorea",
	"KR": "Südkorea",
	"HR": "Kroatien",
	"CU": "Kuba",
	"KW": "Kuwait",
	"LA": "Laos",
	"LS": "Lesotho",
	"LV": "Lettland",
	"LB": "Libanon",
	"LR": "Liberia",
	"LY": "Libyen",
	"LI": "Liechtenstein",
	"LT": "Litauen",
	"LU": "Luxemburg",
	"MO": "Macao",
	"MG": "Madagaskar",
	"MW": "Malawi",
	"MY": "Malaysia",
	"MV": "Malediven",
	"ML": "Mali",
	"MT": "Malta",
	"MA": "Marokko",
	"MH": "Marshallinseln",
	"MQ": "Martinique",
	"MR": "Mauretanien",
	"MU": "Mauritius",
	"YT": "Mayotte",
	"MK": "Mazedonien",
	"MX": "Mexiko",
	"FM": "Mikronesien",
	"MD": "Moldawien",
	"MC": "Monaco",
	"MN": "Mongolei",
	"ME": "Montenegro",
	"MS": "Montserrat",
	"MZ": "Mosambik",
	"MM": "Myanmar",
	"NA": "Namibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NC": "Neukaledonien",
	"NZ": "Neuseeland",
	"NI": "Nicaragua",
	"NL": "Niederlande",
	"NE": "Niger",
	"NG": "Nigeria",
	"NU": "Niue",
	"MP": "Nördliche Marianen",
	"NF": "Norfolkinsel",
	"NO": "Norwegen",
	"OM": "Oman",
	"AT": "Österreich",
	"TL": "Osttimor",
	"PK": "Pakistan",
	"PS": "Staat Palästina",
	"PW": "Palau",
	"PA": "Panama",
	"PG": "Papua-Neuguinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"PH": "Philippinen",
	"PN": "Pitcairninseln",
	"PL": "Polen",
	"PT": "Portugal",
	"PR": "Puerto Rico",
	"TW": "Taiwan",
	"CG": "Republik Kongo",
	"RE": "Réunion",
	"RW": "Ruanda",
	"RO": "Rumänien",
	"RU": "Russische Föderation",
	"BL": "Saint-Barthélemy",
	"MF": "Saint-Martin",
	"SB": "Salomonen",
	"ZM": "Sambia",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "São Tomé und Príncipe",
	"SA": "Saudi-Arabien",
	"SE": "Schweden",
	"CH": "Schweiz",
	"SN": "Senegal",
	"RS": "Serbien",
	"SC": "Seychellen",
	"SL": "Sierra Leone",
	"ZW": "Simbabwe",
	"SG": "Singapur",
	"SX": "Sint Maarten",
	"SK": "Slowakei",
	"SI": "Slowenien",
	"SO": "Somalia",
	"ES": "Spanien",
	"LK": "Sri Lanka",
	"SH": "St. Helena",
	"KN": "St. Kitts und Nevis",
	"LC": "St. Lucia",
	"PM": "Saint-Pierre und Miquelon",
	"VC": "St. Vincent und die Grenadinen",
	"ZA": "Südafrika",
	"SD": "Sudan",
	"GS": "Südgeorgien und die Südlichen Sandwichinseln",
	"SS": "Südsudan",
	"SR": "Suriname",
	"SJ": "Svalbard und Jan Mayen",
	"SZ": "Swasiland",
	"SY": "Syrien, Arabische Republik",
	"TJ": "Tadschikistan",
	"TZ": "Tansania, Vereinigte Republik",
	"TH": "Thailand",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad und Tobago",
	"TD": "Tschad",
	"CZ": "Tschechische Republik",
	"TN": "Tunesien",
	"TR": "Türkei",
	"TM": "Turkmenistan",
	"TC": "Turks- und Caicosinseln",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukraine",
	"HU": "Ungarn",
	"UM": "United States Minor Outlying Islands",
	"UY": "Uruguay",
	"UZ": "Usbekistan",
	"VU": "Vanuatu",
	"VA": "Vatikanstadt",
	"VE": "Venezuela",
	"AE": "Vereinigte Arabische Emirate",
	"US": "Vereinigte Staaten von Amerika",
	"GB": "Vereinigtes Königreich Großbritannien und Nordirland",
	"VN": "Vietnam",
	"WF": "Wallis und Futuna",
	"CX": "Weihnachtsinsel",
	"EH": "Westsahara",
	"CF": "Zentralafrikanische Republik",
	"CY": "Zypern",
	"XK": "Kosovo"
};

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afghanistan",
	"AL": "Albania",
	"DZ": "Algeria",
	"AS": "American Samoa",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarctica",
	"AG": "Antigua and Barbuda",
	"AR": "Argentina",
	"AM": "Armenia",
	"AW": "Aruba",
	"AU": "Australia",
	"AT": "Austria",
	"AZ": "Azerbaijan",
	"BS": "Bahamas",
	"BH": "Bahrain",
	"BD": "Bangladesh",
	"BB": "Barbados",
	"BY": "Belarus",
	"BE": "Belgium",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermuda",
	"BT": "Bhutan",
	"BO": "Bolivia",
	"BA": "Bosnia and Herzegovina",
	"BW": "Botswana",
	"BV": "Bouvet Island",
	"BR": "Brazil",
	"IO": "British Indian Ocean Territory",
	"BN": "Brunei Darussalam",
	"BG": "Bulgaria",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KH": "Cambodia",
	"CM": "Cameroon",
	"CA": "Canada",
	"CV": "Cape Verde",
	"KY": "Cayman Islands",
	"CF": "Central African Republic",
	"TD": "Chad",
	"CL": "Chile",
	"CN": "China",
	"CX": "Christmas Island",
	"CC": "Cocos (Keeling) Islands",
	"CO": "Colombia",
	"KM": "Comoros",
	"CG": "Congo",
	"CD": "Congo, the Democratic Republic of the",
	"CK": "Cook Islands",
	"CR": "Costa Rica",
	"CI": "Cote D'Ivoire",
	"HR": "Croatia",
	"CU": "Cuba",
	"CY": "Cyprus",
	"CZ": "Czech Republic",
	"DK": "Denmark",
	"DJ": "Djibouti",
	"DM": "Dominica",
	"DO": "Dominican Republic",
	"EC": "Ecuador",
	"EG": "Egypt",
	"SV": "El Salvador",
	"GQ": "Equatorial Guinea",
	"ER": "Eritrea",
	"EE": "Estonia",
	"ET": "Ethiopia",
	"FK": "Falkland Islands (Malvinas)",
	"FO": "Faroe Islands",
	"FJ": "Fiji",
	"FI": "Finland",
	"FR": "France",
	"GF": "French Guiana",
	"PF": "French Polynesia",
	"TF": "French Southern Territories",
	"GA": "Gabon",
	"GM": "Gambia",
	"GE": "Georgia",
	"DE": "Germany",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GR": "Greece",
	"GL": "Greenland",
	"GD": "Grenada",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heard Island and Mcdonald Islands",
	"VA": "Holy See (Vatican City State)",
	"HN": "Honduras",
	"HK": "Hong Kong",
	"HU": "Hungary",
	"IS": "Iceland",
	"IN": "India",
	"ID": "Indonesia",
	"IR": "Iran, Islamic Republic of",
	"IQ": "Iraq",
	"IE": "Ireland",
	"IL": "Israel",
	"IT": "Italy",
	"JM": "Jamaica",
	"JP": "Japan",
	"JO": "Jordan",
	"KZ": "Kazakhstan",
	"KE": "Kenya",
	"KI": "Kiribati",
	"KP": "Korea, Democratic People's Republic of",
	"KR": "Korea, Republic of",
	"KW": "Kuwait",
	"KG": "Kyrgyzstan",
	"LA": "Lao People's Democratic Republic",
	"LV": "Latvia",
	"LB": "Lebanon",
	"LS": "Lesotho",
	"LR": "Liberia",
	"LY": "Libyan Arab Jamahiriya",
	"LI": "Liechtenstein",
	"LT": "Lithuania",
	"LU": "Luxembourg",
	"MO": "Macao",
	"MK": "Macedonia, the Former Yugoslav Republic of",
	"MG": "Madagascar",
	"MW": "Malawi",
	"MY": "Malaysia",
	"MV": "Maldives",
	"ML": "Mali",
	"MT": "Malta",
	"MH": "Marshall Islands",
	"MQ": "Martinique",
	"MR": "Mauritania",
	"MU": "Mauritius",
	"YT": "Mayotte",
	"MX": "Mexico",
	"FM": "Micronesia, Federated States of",
	"MD": "Moldova, Republic of",
	"MC": "Monaco",
	"MN": "Mongolia",
	"MS": "Montserrat",
	"MA": "Morocco",
	"MZ": "Mozambique",
	"MM": "Myanmar",
	"NA": "Namibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NL": "Netherlands",
	"NC": "New Caledonia",
	"NZ": "New Zealand",
	"NI": "Nicaragua",
	"NE": "Niger",
	"NG": "Nigeria",
	"NU": "Niue",
	"NF": "Norfolk Island",
	"MP": "Northern Mariana Islands",
	"NO": "Norway",
	"OM": "Oman",
	"PK": "Pakistan",
	"PW": "Palau",
	"PS": "Palestinian Territory, Occupied",
	"PA": "Panama",
	"PG": "Papua New Guinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"PH": "Philippines",
	"PN": "Pitcairn",
	"PL": "Poland",
	"PT": "Portugal",
	"PR": "Puerto Rico",
	"QA": "Qatar",
	"RE": "Reunion",
	"RO": "Romania",
	"RU": "Russian Federation",
	"RW": "Rwanda",
	"SH": "Saint Helena",
	"KN": "Saint Kitts and Nevis",
	"LC": "Saint Lucia",
	"PM": "Saint Pierre and Miquelon",
	"VC": "Saint Vincent and the Grenadines",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "Sao Tome and Principe",
	"SA": "Saudi Arabia",
	"SN": "Senegal",
	"SC": "Seychelles",
	"SL": "Sierra Leone",
	"SG": "Singapore",
	"SK": "Slovakia",
	"SI": "Slovenia",
	"SB": "Solomon Islands",
	"SO": "Somalia",
	"ZA": "South Africa",
	"GS": "South Georgia and the South Sandwich Islands",
	"ES": "Spain",
	"LK": "Sri Lanka",
	"SD": "Sudan",
	"SR": "Suriname",
	"SJ": "Svalbard and Jan Mayen",
	"SZ": "Swaziland",
	"SE": "Sweden",
	"CH": "Switzerland",
	"SY": "Syrian Arab Republic",
	"TW": "Taiwan",
	"TJ": "Tajikistan",
	"TZ": "Tanzania, United Republic of",
	"TH": "Thailand",
	"TL": "Timor-Leste",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad and Tobago",
	"TN": "Tunisia",
	"TR": "Turkey",
	"TM": "Turkmenistan",
	"TC": "Turks and Caicos Islands",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukraine",
	"AE": "United Arab Emirates",
	"GB": "United Kingdom",
	"US": "United States of America",
	"UM": "United States Minor Outlying Islands",
	"UY": "Uruguay",
	"UZ": "Uzbekistan",
	"VU": "Vanuatu",
	"VE": "Venezuela",
	"VN": "Viet Nam",
	"VG": "Virgin Islands, British",
	"VI": "Virgin Islands, U.S.",
	"WF": "Wallis and Futuna",
	"EH": "Western Sahara",
	"YE": "Yemen",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"AX": "Åland Islands",
	"BQ": "Bonaire, Sint Eustatius and Saba",
	"CW": "Curaçao",
	"GG": "Guernsey",
	"IM": "Isle of Man",
	"JE": "Jersey",
	"ME": "Montenegro",
	"BL": "Saint Barthélemy",
	"MF": "Saint Martin (French part)",
	"RS": "Serbia",
	"SX": "Sint Maarten (Dutch part)",
	"SS": "South Sudan",
	"XK": "Kosovo"
};

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afganistán",
	"AL": "Albania",
	"DZ": "Argelia",
	"AS": "Samoa Americana",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguila",
	"AQ": "Antártida",
	"AG": "Antigua y Barbuda",
	"AR": "Argentina",
	"AM": "Armenia",
	"AW": "Aruba",
	"AU": "Australia",
	"AT": "Austria",
	"AZ": "Azerbaiyán",
	"BS": "Bahamas",
	"BH": "Bahrein",
	"BD": "Bangladesh",
	"BB": "Barbados",
	"BY": "Belarús",
	"BE": "Bélgica",
	"BZ": "Belice",
	"BJ": "Benin",
	"BM": "Bermudas",
	"BT": "Bhután",
	"BO": "Bolivia",
	"BA": "Bosnia y Herzegovina",
	"BW": "Botswana",
	"BV": "Isla Bouvet",
	"BR": "Brasil",
	"IO": "Territorio Británico del Océano Índico",
	"BN": "Brunei Darussalam",
	"BG": "Bulgaria",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KH": "Camboya",
	"CM": "Camerún",
	"CA": "Canadá",
	"CV": "Cabo Verde",
	"KY": "Islas Caimán",
	"CF": "República Centroafricana",
	"TD": "Chad",
	"CL": "Chile",
	"CN": "China",
	"CX": "Isla de Navidad",
	"CC": "Islas Cocos (Keeling)",
	"CO": "Colombia",
	"KM": "Comoras",
	"CG": "Congo",
	"CD": "Congo (República Democrática del)",
	"CK": "Islas Cook",
	"CR": "Costa Rica",
	"CI": "Côte d'Ivoire",
	"HR": "Croacia",
	"CU": "Cuba",
	"CY": "Chipre",
	"CZ": "República Checa",
	"DK": "Dinamarca",
	"DJ": "Djibouti",
	"DM": "Dominica",
	"DO": "República Dominicana",
	"EC": "Ecuador",
	"EG": "Egipto",
	"SV": "El Salvador",
	"GQ": "Guinea Ecuatorial",
	"ER": "Eritrea",
	"EE": "Estonia",
	"ET": "Etiopía",
	"FK": "Islas Malvinas",
	"FO": "Islas Feroe",
	"FJ": "Fiji",
	"FI": "Finlandia",
	"FR": "Francia",
	"GF": "Guayana Francesa",
	"PF": "Polinesia Francesa",
	"TF": "Tierras Australes Francesas",
	"GA": "Gabón",
	"GM": "Gambia",
	"GE": "Georgia",
	"DE": "Alemania",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GR": "Grecia",
	"GL": "Groenlandia",
	"GD": "Granada",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GW": "Guinea Bissau",
	"GY": "Guyana",
	"HT": "Haití",
	"HM": "Heard e Islas McDonald",
	"VA": "Santa Sede",
	"HN": "Honduras",
	"HK": "Hong Kong",
	"HU": "Hungría",
	"IS": "Islandia",
	"IN": "India",
	"ID": "Indonesia",
	"IR": "Irán (República Islámica de)",
	"IQ": "Iraq",
	"IE": "Irlanda",
	"IL": "Israel",
	"IT": "Italia",
	"JM": "Jamaica",
	"JP": "Japón",
	"JO": "Jordania",
	"KZ": "Kazajstán",
	"KE": "Kenya",
	"KI": "Kiribati",
	"KP": "República Popular Democrática de Corea",
	"KR": "República de Corea",
	"KW": "Kuwait",
	"KG": "Kirguistán",
	"LA": "República Democrática Popular de Lao",
	"LV": "Letonia",
	"LB": "Líbano",
	"LS": "Lesotho",
	"LR": "Liberia",
	"LY": "Libia",
	"LI": "Liechtenstein",
	"LT": "Lituania",
	"LU": "Luxemburgo",
	"MO": "Macao",
	"MK": "Macedonia",
	"MG": "Madagascar",
	"MW": "Malawi",
	"MY": "Malasia",
	"MV": "Maldivas",
	"ML": "Malí",
	"MT": "Malta",
	"MH": "Islas Marshall",
	"MQ": "Martinique",
	"MR": "Mauritania",
	"MU": "Mauricio",
	"YT": "Mayotte",
	"MX": "México",
	"FM": "Micronesia",
	"MD": "Moldavia",
	"MC": "Mónaco",
	"MN": "Mongolia",
	"MS": "Montserrat",
	"MA": "Marruecos",
	"MZ": "Mozambique",
	"MM": "Myanmar",
	"NA": "Namibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NL": "Países Bajos",
	"NC": "Nueva Caledonia",
	"NZ": "Nueva Zelandia",
	"NI": "Nicaragua",
	"NE": "Níger",
	"NG": "Nigeria",
	"NU": "Niue",
	"NF": "Isla Norfolk",
	"MP": "Isla Marianas del Norte",
	"NO": "Noruega",
	"OM": "Omán",
	"PK": "Pakistán",
	"PW": "Palau",
	"PS": "Palestina",
	"PA": "Panamá",
	"PG": "Papua Nueva Guinea",
	"PY": "Paraguay",
	"PE": "Perú",
	"PH": "Filipinas",
	"PN": "Pitcairn",
	"PL": "Polonia",
	"PT": "Portugal",
	"PR": "Puerto Rico",
	"QA": "Qatar",
	"RE": "Reunión",
	"RO": "Rumania",
	"RU": "Rusia",
	"RW": "Rwanda",
	"SH": "Santa Helena, Ascensión y Tristán de Acuña",
	"KN": "Saint Kitts y Nevis",
	"LC": "Santa Lucía",
	"PM": "San Pedro y Miquelón",
	"VC": "San Vicente y las Granadinas",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "Santo Tomé y Príncipe",
	"SA": "Arabia Saudita",
	"SN": "Senegal",
	"SC": "Seychelles",
	"SL": "Sierra Leona",
	"SG": "Singapur",
	"SK": "Eslovaquia",
	"SI": "Eslovenia",
	"SB": "Islas Salomón",
	"SO": "Somalia",
	"ZA": "Sudáfrica",
	"GS": "Georgia del Sur y las Islas Sandwich del Sur",
	"ES": "España",
	"LK": "Sri Lanka",
	"SD": "Sudan",
	"SR": "Suriname",
	"SJ": "Svalbard y Jan Mayen",
	"SZ": "Swazilandia",
	"SE": "Suecia",
	"CH": "Suiza",
	"SY": "República Árabe Siria",
	"TW": "Taiwán",
	"TJ": "Tayikistán",
	"TZ": "Tanzania",
	"TH": "Tailandia",
	"TL": "Timor-Leste",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad y Tobago",
	"TN": "Túnez",
	"TR": "Turquía",
	"TM": "Turkmenistán",
	"TC": "Islas Turcas y Caicos",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ucrania",
	"AE": "Emiratos Árabes Unido",
	"GB": "Reino Unido",
	"US": "Estados Unidos",
	"UM": "Islas Ultramarinas Menores de los Estados Unidos",
	"UY": "Uruguay",
	"UZ": "Uzbekistán",
	"VU": "Vanuatu",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"VG": "Islas Vírgenes británicas",
	"VI": "Islas Vírgenes de los Estados Unidos",
	"WF": "Wallis y Futuna",
	"EH": "Sahara Occidental",
	"YE": "Yemen",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"AX": "Islas Åland",
	"BQ": "Bonaire, San Eustaquio y Saba",
	"CW": "Curaçao",
	"GG": "Guernsey",
	"IM": "Isla de Man",
	"JE": "Jersey",
	"ME": "Montenegro",
	"BL": "Saint Barthélemy",
	"MF": "Saint Martin (francesa)",
	"RS": "Serbia",
	"SX": "Sint Maarten (neerlandesa)",
	"SS": "Sudán del Sur",
	"XK": "Kosovo"
};

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afganistan",
	"AX": "Ahvenamaa",
	"AL": "Albaania",
	"DZ": "Alžeeria",
	"AS": "Ameerika Samoa",
	"US": "Ameerika Ühendriigid",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktis",
	"AG": "Antigua ja Barbuda",
	"MO": "Aomen - Hiina erihalduspiirkond",
	"AE": "Araabia Ühendemiraadid",
	"AR": "Argentina",
	"AM": "Armeenia",
	"AW": "Aruba",
	"AZ": "Aserbaidžaan",
	"AU": "Austraalia",
	"AT": "Austria",
	"BS": "Bahama",
	"BH": "Bahrein",
	"BD": "Bangladesh",
	"BB": "Barbados",
	"PW": "Belau",
	"BE": "Belgia",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermuda",
	"BT": "Bhutan",
	"BO": "Boliivia",
	"BA": "Bosnia ja Hertsegoviina",
	"BW": "Botswana",
	"BV": "Bouvet’i saar",
	"BR": "Brasiilia",
	"BQ": "Bonaire, Sint Eustatius ja Saba",
	"IO": "Briti India ookeani ala",
	"VG": "Briti Neitsisaared",
	"BN": "Brunei",
	"BG": "Bulgaaria",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"CO": "Colombia",
	"CK": "Cooki saared",
	"CR": "Costa Rica",
	"CI": "Côte d'Ivoire",
	"CW": "Curaçao",
	"DJ": "Djibouti",
	"DM": "Dominica",
	"DO": "Dominikaani Vabariik",
	"EC": "Ecuador",
	"EE": "Eesti",
	"EG": "Egiptus",
	"GQ": "Ekvatoriaal-Guinea",
	"SV": "El Salvador",
	"ER": "Eritrea",
	"ET": "Etioopia",
	"FK": "Falklandi saared",
	"FJ": "Fidži",
	"PH": "Filipiinid",
	"FO": "Fääri saared",
	"GA": "Gabon",
	"GM": "Gambia",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GD": "Grenada",
	"GE": "Gruusia",
	"GL": "Gröönimaa",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GG": "Guernsey",
	"GN": "Guinea",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heard ja McDonald saared",
	"CN": "Hiina",
	"ES": "Hispaania",
	"NL": "Holland",
	"HN": "Honduras",
	"HK": "Hongkong - Hiina erihalduspiirkond",
	"HR": "Horvaatia",
	"TL": "Ida-Timor",
	"IE": "Iirimaa",
	"IL": "Iisrael",
	"IN": "India",
	"ID": "Indoneesia",
	"IQ": "Iraak",
	"IR": "Iraan",
	"IS": "Island",
	"IT": "Itaalia",
	"JP": "Jaapan",
	"JM": "Jamaica",
	"YE": "Jeemen",
	"JE": "Jersey",
	"JO": "Jordaania",
	"CX": "Jõulusaar",
	"KY": "Kaimanisaared",
	"KH": "Kambodža",
	"CM": "Kamerun",
	"CA": "Kanada",
	"KZ": "Kasahstan",
	"QA": "Katar",
	"KE": "Kenya",
	"CF": "Kesk-Aafrika Vabariik",
	"KI": "Kiribati",
	"KM": "Komoorid",
	"CD": "Kongo DV",
	"CG": "Kongo-Brazzaville",
	"CC": "Kookossaared",
	"GR": "Kreeka",
	"CU": "Kuuba",
	"KW": "Kuveit",
	"KG": "Kõrgõzstan",
	"CY": "Küpros",
	"LA": "Laos",
	"LT": "Leedu",
	"LS": "Lesotho",
	"LR": "Libeeria",
	"LI": "Liechtenstein",
	"LB": "Liibanon",
	"LY": "Liibüa",
	"LU": "Luksemburg",
	"ZA": "Lõuna-Aafrika Vabariik",
	"GS": "Lõuna-Georgia ja Lõuna-Sandwichi saared",
	"KR": "Lõuna-Korea",
	"LV": "Läti",
	"EH": "Lääne-Sahara",
	"MG": "Madagaskar",
	"MK": "Makedoonia",
	"MY": "Malaisia",
	"MW": "Malawi",
	"MV": "Maldiivid",
	"ML": "Mali",
	"MT": "Malta",
	"IM": "Mani saar",
	"MA": "Maroko",
	"MH": "Marshalli saared",
	"MQ": "Martinique",
	"MR": "Mauritaania",
	"MU": "Mauritius",
	"YT": "Mayotte",
	"MX": "Mehhiko",
	"FM": "Mikroneesia Liiduriigid",
	"MD": "Moldova",
	"MC": "Monaco",
	"MN": "Mongoolia",
	"ME": "Montenegro",
	"MS": "Montserrat",
	"MZ": "Mosambiik",
	"MM": "Myanmar",
	"NA": "Namiibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NI": "Nicaragua",
	"NG": "Nigeeria",
	"NE": "Niger",
	"NU": "Niue",
	"NF": "Norfolk",
	"NO": "Norra",
	"OM": "Omaan",
	"PG": "Paapua Uus-Guinea",
	"PK": "Pakistan",
	"PS": "Palestiina ala",
	"PA": "Panama",
	"PY": "Paraguay",
	"PE": "Peruu",
	"PN": "Pitcairn",
	"PL": "Poola",
	"PT": "Portugal",
	"GF": "Prantsuse Guajaana",
	"TF": "Prantsuse Lõunaalad",
	"PF": "Prantsuse Polüneesia",
	"FR": "Prantsusmaa",
	"PR": "Puerto Rico",
	"KP": "Põhja-Korea",
	"MP": "Põhja-Mariaanid",
	"RE": "Réunion",
	"CV": "Roheneemesaared",
	"SE": "Rootsi",
	"SX": "Sint Maarten",
	"RO": "Rumeenia",
	"RW": "Rwanda",
	"SB": "Saalomoni Saared",
	"BL": "Saint Barthélemy",
	"SH": "Saint Helena",
	"KN": "Saint Kitts ja Nevis",
	"LC": "Saint Lucia",
	"MF": "Saint Martin",
	"PM": "Saint Pierre ja Miquelon",
	"VC": "Saint Vincent ja Grenadiinid",
	"DE": "Saksamaa",
	"ZM": "Sambia",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "São Tomé ja Príncipe",
	"SA": "Saudi Araabia",
	"SC": "Seišellid",
	"SN": "Senegal",
	"RS": "Serbia",
	"SL": "Sierra Leone",
	"SG": "Singapur",
	"SK": "Slovakkia",
	"SI": "Sloveenia",
	"SO": "Somaalia",
	"FI": "Soome",
	"LK": "Sri Lanka",
	"SD": "Sudaan",
	"SS": "Lõuna-Sudaan",
	"SR": "Suriname",
	"GB": "Suurbritannia",
	"SZ": "Svaasimaa",
	"SJ": "Svalbard ja Jan Mayen",
	"SY": "Süüria",
	"CH": "Šveits",
	"ZW": "Zimbabwe",
	"DK": "Taani",
	"TJ": "Tadžikistan",
	"TH": "Tai",
	"TW": "Taiwan",
	"TZ": "Tansaania",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad ja Tobago",
	"TD": "Tšaad",
	"CZ": "Tšehhi",
	"CL": "Tšiili",
	"TN": "Tuneesia",
	"TC": "Turks ja Caicos",
	"TV": "Tuvalu",
	"TR": "Türgi",
	"TM": "Türkmenistan",
	"UG": "Uganda",
	"UA": "Ukraina",
	"HU": "Ungari",
	"UY": "Uruguay",
	"VI": "USA Neitsisaared",
	"UZ": "Usbekistan",
	"NC": "Uus-Kaledoonia",
	"NZ": "Uus-Meremaa",
	"BY": "Valgevene",
	"WF": "Wallis ja Futuna",
	"VU": "Vanuatu",
	"VA": "Vatikan",
	"RU": "Venemaa",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"UM": "Ühendriikide hajasaared",
	"XK": "Kosovo"
};

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afganistan",
	"AX": "Ahvenanmaa",
	"NL": "Alankomaat",
	"AL": "Albania",
	"DZ": "Algeria",
	"AS": "Amerikan Samoa",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktis",
	"AG": "Antigua ja Barbuda",
	"AE": "Arabiemiirikunnat",
	"AR": "Argentiina",
	"AM": "Armenia",
	"AW": "Aruba",
	"AU": "Australia",
	"AZ": "Azerbaidžan",
	"BS": "Bahama",
	"BH": "Bahrain",
	"BD": "Bangladesh",
	"BB": "Barbados",
	"BE": "Belgia",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermuda",
	"BT": "Bhutan",
	"BO": "Bolivia",
	"BQ": "Bonaire, Sint Eustatius ja Saba",
	"BA": "Bosnia ja Hertsegovina",
	"BW": "Botswana",
	"BV": "Bouvet’nsaari",
	"BR": "Brasilia",
	"IO": "Brittiläinen Intian valtameren alue",
	"VG": "Brittiläiset Neitsytsaaret",
	"BN": "Brunei",
	"BG": "Bulgaria",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KY": "Caymansaaret",
	"CL": "Chile",
	"CK": "Cookinsaaret",
	"CR": "Costa Rica",
	"CW": "Curaçao",
	"DJ": "Djibouti",
	"DM": "Dominica",
	"DO": "Dominikaaninen tasavalta",
	"EC": "Ecuador",
	"EG": "Egypti",
	"SV": "El Salvador",
	"ER": "Eritrea",
	"ES": "Espanja",
	"ET": "Etiopia",
	"ZA": "Etelä-Afrikka",
	"GS": "Etelä-Georgia ja Eteläiset Sandwichsaaret",
	"SS": "Etelä-Sudan",
	"FK": "Falklandinsaaret",
	"FO": "Färsaaret",
	"FJ": "Fidži",
	"PH": "Filippiinit",
	"GA": "Gabon",
	"GM": "Gambia",
	"GE": "Georgia",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GD": "Grenada",
	"GL": "Grönlanti",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GG": "Guernsey",
	"GN": "Guinea",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heard ja McDonaldinsaaret",
	"HN": "Honduras",
	"HK": "Hongkong",
	"ID": "Indonesia",
	"IN": "Intia",
	"IQ": "Irak",
	"IR": "Iran",
	"IE": "Irlanti",
	"IS": "Islanti",
	"IL": "Israel",
	"IT": "Italia",
	"TL": "Itä-Timor",
	"AT": "Itävalta",
	"JM": "Jamaika",
	"JP": "Japani",
	"YE": "Jemen",
	"JE": "Jersey",
	"JO": "Jordania",
	"CX": "Joulusaari",
	"KH": "Kambodža",
	"CM": "Kamerun",
	"CA": "Kanada",
	"CV": "Kap Verde",
	"KZ": "Kazakstan",
	"KE": "Kenia",
	"CF": "Keski-Afrikan tasavalta",
	"CN": "Kiina",
	"KG": "Kirgisia",
	"KI": "Kiribati",
	"CO": "Kolumbia",
	"KM": "Komorit",
	"CD": "Kongon demokraattinen tasavalta",
	"CG": "Kongon tasavalta",
	"CC": "Kookossaaret",
	"KP": "Korean demokraattinen kansantasavalta",
	"KR": "Korean tasavalta",
	"GR": "Kreikka",
	"HR": "Kroatia",
	"CU": "Kuuba",
	"KW": "Kuwait",
	"CY": "Kypros",
	"LA": "Laos",
	"LV": "Latvia",
	"LS": "Lesotho",
	"LB": "Libanon",
	"LR": "Liberia",
	"LY": "Libya",
	"LI": "Liechtenstein",
	"LT": "Liettua",
	"LU": "Luxemburg",
	"EH": "Länsi-Sahara",
	"MO": "Macao",
	"MG": "Madagaskar",
	"MK": "Makedonia",
	"MW": "Malawi",
	"MV": "Malediivit",
	"MY": "Malesia",
	"ML": "Mali",
	"MT": "Malta",
	"IM": "Mansaari",
	"MA": "Marokko",
	"MH": "Marshallinsaaret",
	"MQ": "Martinique",
	"MR": "Mauritania",
	"MU": "Mauritius",
	"YT": "Mayotte",
	"MX": "Meksiko",
	"FM": "Mikronesian liittovaltio",
	"MD": "Moldova",
	"MC": "Monaco",
	"MN": "Mongolia",
	"ME": "Montenegro",
	"MS": "Montserrat",
	"MZ": "Mosambik",
	"MM": "Myanmar",
	"NA": "Namibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NI": "Nicaragua",
	"NE": "Niger",
	"NG": "Nigeria",
	"NU": "Niue",
	"NF": "Norfolkinsaari",
	"NO": "Norja",
	"CI": "Norsunluurannikko",
	"OM": "Oman",
	"PK": "Pakistan",
	"PW": "Palau",
	"PS": "Palestiina",
	"PA": "Panama",
	"PG": "Papua-Uusi-Guinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"MP": "Pohjois-Mariaanit",
	"PN": "Pitcairn",
	"PT": "Portugali",
	"PR": "Puerto Rico",
	"PL": "Puola",
	"GQ": "Päiväntasaajan Guinea",
	"QA": "Qatar",
	"FR": "Ranska",
	"TF": "Ranskan eteläiset alueet",
	"GF": "Ranskan Guayana",
	"PF": "Ranskan Polynesia",
	"RE": "Réunion",
	"RO": "Romania",
	"RW": "Ruanda",
	"SE": "Ruotsi",
	"BL": "Saint-Barthélemy",
	"SH": "Saint Helena",
	"KN": "Saint Kitts ja Nevis",
	"LC": "Saint Lucia",
	"MF": "Saint-Martin",
	"PM": "Saint-Pierre ja Miquelon",
	"VC": "Saint Vincent ja Grenadiinit",
	"DE": "Saksa",
	"SB": "Salomonsaaret",
	"ZM": "Sambia",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "São Tomé ja Príncipe",
	"SA": "Saudi-Arabia",
	"SN": "Senegal",
	"RS": "Serbia",
	"SC": "Seychellit",
	"SL": "Sierra Leone",
	"SG": "Singapore",
	"SX": "Sint Maarten",
	"SK": "Slovakia",
	"SI": "Slovenia",
	"SO": "Somalia",
	"LK": "Sri Lanka",
	"SD": "Sudan",
	"FI": "Suomi",
	"SR": "Suriname",
	"SJ": "Svalbard ja Jan Mayen",
	"SZ": "Swazimaa",
	"CH": "Sveitsi",
	"SY": "Syyria",
	"TJ": "Tadžikistan",
	"TW": "Taiwan",
	"TZ": "Tansania",
	"DK": "Tanska",
	"TH": "Thaimaa",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad ja Tobago",
	"TD": "Tšad",
	"CZ": "Tšekki",
	"TN": "Tunisia",
	"TR": "Turkki",
	"TM": "Turkmenistan",
	"TC": "Turks- ja Caicossaaret",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukraina",
	"HU": "Unkari",
	"UY": "Uruguay",
	"NC": "Uusi-Kaledonia",
	"NZ": "Uusi-Seelanti",
	"UZ": "Uzbekistan",
	"BY": "Valko-Venäjä",
	"VU": "Vanuatu",
	"VA": "Vatikaanivaltio",
	"VE": "Venezuela",
	"RU": "Venäjä",
	"VN": "Vietnam",
	"EE": "Viro",
	"WF": "Wallis ja Futunasaaret",
	"GB": "Yhdistynyt kuningaskunta",
	"US": "Yhdysvallat",
	"VI": "Yhdysvaltain Neitsytsaaret",
	"UM": "Yhdysvaltain pienet erillissaaret",
	"ZW": "Zimbabwe",
	"XK": "Kosovo"
};

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afghanistan",
	"AL": "Albanie",
	"DZ": "Algérie",
	"AS": "Samoa américaine",
	"AD": "Andorre",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarctique",
	"AG": "Antigua et Barbuda",
	"AR": "Argentine",
	"AM": "Arménie",
	"AW": "Aruba",
	"AU": "Australie",
	"AT": "Autriche",
	"AZ": "Azerbaidjan",
	"BS": "Bahamas",
	"BH": "Bahrein",
	"BD": "Bangladesh",
	"BB": "Barbade",
	"BY": "Bielorussie",
	"BE": "Belgique",
	"BZ": "Belize",
	"BJ": "Bénin",
	"BM": "Bermudes",
	"BT": "Bhoutan",
	"BO": "Bolivie",
	"BA": "Bosnie-Herzégovine",
	"BW": "Botswana",
	"BV": "Île Bouvet",
	"BR": "Brésil",
	"IO": "Océan Indien Britannique",
	"BN": "Brunei Darussalam",
	"BG": "Bulgarie",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KH": "Cambodge",
	"CM": "Cameroun",
	"CA": "Canada",
	"CV": "Cap-Vert",
	"KY": "Caïmanes",
	"CF": "Centrafricaine, République",
	"TD": "Tchad",
	"CL": "Chili",
	"CN": "Chine",
	"CX": "Île Christmas",
	"CC": "Cocos",
	"CO": "Colombie",
	"KM": "Comores",
	"CG": "Congo, République populaire",
	"CD": "Congo, République démocratique",
	"CK": "Îles Cook",
	"CR": "Costa Rica",
	"CI": "Côte-d'Ivoire",
	"HR": "Croatie",
	"CU": "Cuba",
	"CY": "Chypre",
	"CZ": "Tchéquie",
	"DK": "Danemark",
	"DJ": "Djibouti",
	"DM": "Dominique",
	"DO": "République Dominicaine",
	"EC": "Équateur",
	"EG": "Égypte",
	"SV": "El Salvador",
	"GQ": "Guinée équatoriale",
	"ER": "Érythrée",
	"EE": "Estonie",
	"ET": "Éthiopie",
	"FK": "Îles Malouines",
	"FO": "Îles Féroé",
	"FJ": "Fidji",
	"FI": "Finlande",
	"FR": "France Métropolitaine",
	"GF": "Guyane française",
	"PF": "Polynésie française",
	"TF": "Terres australes françaises",
	"GA": "Gabon",
	"GM": "Gambie",
	"GE": "Géorgie",
	"DE": "Allemagne",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GR": "Grèce",
	"GL": "Groenland",
	"GD": "Grenada",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinée",
	"GW": "Guinée-Bissau",
	"GY": "Guyana",
	"HT": "Haïti",
	"HM": "Îles Heard-et-MacDonald",
	"VA": "Saint-Siège",
	"HN": "Honduras",
	"HK": "Hong Kong",
	"HU": "Hongrie",
	"IS": "Islande",
	"IN": "Inde",
	"ID": "Indonésie",
	"IR": "Iran",
	"IQ": "Irak",
	"IE": "Irlande",
	"IL": "Israël",
	"IT": "Italie",
	"JM": "Jamaïque",
	"JP": "Japon",
	"JO": "Jordanie",
	"KZ": "Kazakhstan",
	"KE": "Kenya",
	"KI": "Kiribati",
	"KP": "Corée du Nord, République populaire démocratique",
	"KR": "Corée du Sud, République",
	"KW": "Koweit",
	"KG": "Kirghistan",
	"LA": "Laos",
	"LV": "Lettonie",
	"LB": "Liban",
	"LS": "Lesotho",
	"LR": "Libéria",
	"LY": "Libye",
	"LI": "Liechtenstein",
	"LT": "Lituanie",
	"LU": "Luxembourg, Grand-Duché",
	"MO": "Macao",
	"MK": "Macédoine, Ex-République yougoslave",
	"MG": "Madagascar",
	"MW": "Malawi",
	"MY": "Malaisie",
	"MV": "Maldives",
	"ML": "Mali",
	"MT": "Malte",
	"MH": "Îles Marshall",
	"MQ": "Martinique",
	"MR": "Mauritanie",
	"MU": "Maurice",
	"YT": "Mayotte",
	"MX": "Mexique",
	"FM": "Micronésie",
	"MD": "Moldavie",
	"MC": "Monaco",
	"MN": "Mongolie",
	"MS": "Montserrat",
	"MA": "Maroc",
	"MZ": "Mozambique",
	"MM": "Myanmar",
	"NA": "Namibie",
	"NR": "Nauru",
	"NP": "Népal",
	"NL": "Pays-Bas",
	"NC": "Nouvelle-Calédonie",
	"NZ": "Nouvelle-Zélande",
	"NI": "Nicaragua",
	"NE": "Niger",
	"NG": "Nigéria",
	"NU": "Niué",
	"NF": "Île Norfolk",
	"MP": "Mariannes du Nord",
	"NO": "Norvège",
	"OM": "Oman",
	"PK": "Pakistan",
	"PW": "Palau",
	"PS": "Palestine",
	"PA": "Panama",
	"PG": "Papouasie-Nouvelle-Guinée",
	"PY": "Paraguay",
	"PE": "Pérou",
	"PH": "Philippines",
	"PN": "Pitcairn",
	"PL": "Pologne",
	"PT": "Portugal",
	"PR": "Porto Rico",
	"QA": "Qatar",
	"RE": "Réunion",
	"RO": "Roumanie",
	"RU": "Russie",
	"RW": "Rwanda",
	"SH": "Sainte-Hélène",
	"KN": "Saint-Christophe-et-Niévès",
	"LC": "Sainte-Lucie",
	"PM": "Saint Pierre and Miquelon",
	"VC": "Saint-Vincent et les Grenadines",
	"WS": "Samoa",
	"SM": "Saint-Marin",
	"ST": "São Tomé et Principe",
	"SA": "Arabie Saoudite",
	"SN": "Sénégal",
	"SC": "Seychelles",
	"SL": "Sierra Leone",
	"SG": "Singapour",
	"SK": "Slovaquie",
	"SI": "Slovénie",
	"SB": "Salomon",
	"SO": "Somalie",
	"ZA": "Afrique du Sud",
	"GS": "Géorgie du Sud-et-les Îles Sandwich du Sud",
	"ES": "Espagne",
	"LK": "Sri Lanka",
	"SD": "Soudan",
	"SR": "Suriname",
	"SJ": "Svalbard et Île Jan Mayen",
	"SZ": "Ngwane, Royaume du Swaziland",
	"SE": "Suède",
	"CH": "Suisse",
	"SY": "Syrie",
	"TW": "Taïwan",
	"TJ": "Tadjikistan",
	"TZ": "Tanzanie, République unie",
	"TH": "Thaïlande",
	"TL": "Timor Leste",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad et Tobago",
	"TN": "Tunisie",
	"TR": "Turquie",
	"TM": "Turkménistan",
	"TC": "Îles Turques-et-Caïques",
	"TV": "Tuvalu",
	"UG": "Ouganda",
	"UA": "Ukraine",
	"AE": "Émirats arabes unis",
	"GB": "Royaume-Uni",
	"US": "États-Unis",
	"UM": "États-Unis d'Amérique",
	"UY": "Uruguay",
	"UZ": "Ouzbékistan",
	"VU": "Vanuatu",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"VG": "Îles vierges britanniques",
	"VI": "Îles vierges américaines",
	"WF": "Wallis et Futuna",
	"EH": "Sahara occidental",
	"YE": "Yémen",
	"ZM": "Zambie",
	"ZW": "Zimbabwe",
	"AX": "Åland",
	"BQ": "Bonaire, Saint-Eustache et Saba",
	"CW": "Curaçao",
	"GG": "Guernesey",
	"IM": "Île de Man",
	"JE": "Jersey",
	"ME": "Monténégro",
	"BL": "Saint-Barthélemy",
	"MF": "Saint-Martin (partie française)",
	"RS": "Serbie",
	"SX": "Saint-Martin (partie néerlandaise)",
	"SS": "Sud-Soudan",
	"XK": "Kosovo"
};

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afganisztán",
	"AL": "Albánia",
	"DZ": "Algéria",
	"AS": "Amerikai Szamoa",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktisz",
	"AG": "Antigua és Barbuda",
	"AR": "Argentína",
	"AM": "Örményország",
	"AW": "Aruba",
	"AU": "Ausztrália",
	"AT": "Ausztria",
	"AZ": "Azerbajdzsán",
	"BS": "Bahama-szigetek",
	"BH": "Bahrein",
	"BD": "Banglades",
	"BB": "Barbados",
	"BY": "Fehéroroszország",
	"BE": "Belgium",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermuda",
	"BT": "Bhután",
	"BO": "Bolívia",
	"BA": "Bosznia-Hercegovina",
	"BW": "Botswana",
	"BV": "Bouvet-sziget",
	"BR": "Brazília",
	"IO": "Brit Indiai-óceáni Terület",
	"BN": "Brunei",
	"BG": "Bulgária",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KH": "Kambodzsa",
	"CM": "Kamerun",
	"CA": "Kanada",
	"CV": "Zöld-foki Köztársaság",
	"KY": "Kajmán-szigetek",
	"CF": "Közép-afrikai Köztársaság",
	"TD": "Csád",
	"CL": "Chile",
	"CN": "Kína",
	"CX": "Karácsony-sziget",
	"CC": "Kókusz (Keeling)-szigetek",
	"CO": "Kolumbia",
	"KM": "Comore-szigetek",
	"CG": "Kongói Köztársaság",
	"CD": "Kongói Demokratikus Köztársaság",
	"CK": "Cook-szigetek",
	"CR": "Costa Rica",
	"CI": "Elefántcsontpart",
	"HR": "Horvátország",
	"CU": "Kuba",
	"CY": "Ciprus",
	"CZ": "Csehország",
	"DK": "Dánia",
	"DJ": "Dzsibuti",
	"DM": "Dominikai Közösség",
	"DO": "Dominikai Köztársaság",
	"EC": "Ecuador",
	"EG": "Egyiptom",
	"SV": "Salvador",
	"GQ": "Egyenlítői-Guinea",
	"ER": "Eritrea",
	"EE": "Észtország",
	"ET": "Etiópia",
	"FK": "Falkland-szigetek",
	"FO": "Feröer",
	"FJ": "Fidzsi-szigetek",
	"FI": "Finnország",
	"FR": "Franciaország",
	"GF": "Francia Guyana",
	"PF": "Francia Polinézia",
	"TF": "Francia déli területek",
	"GA": "Gabon",
	"GM": "Gambia",
	"GE": "Grúzia",
	"DE": "Németország",
	"GH": "Ghána",
	"GI": "Gibraltár",
	"GR": "Görögország",
	"GL": "Grönland",
	"GD": "Grenada",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GW": "Bissau-Guinea",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heard-sziget és McDonald-szigetek",
	"VA": "Vatikán",
	"HN": "Honduras",
	"HK": "Hong Kong",
	"HU": "Magyarország",
	"IS": "Izland",
	"IN": "India",
	"ID": "Indonézia",
	"IR": "Irán",
	"IQ": "Irak",
	"IE": "Írország",
	"IL": "Izrael",
	"IT": "Olaszország",
	"JM": "Jamaica",
	"JP": "Japán",
	"JO": "Jordánia",
	"KZ": "Kazahsztán",
	"KE": "Kenya",
	"KI": "Kiribati",
	"KP": "Észak-Korea",
	"KR": "Dél-Korea",
	"KW": "Kuvait",
	"KG": "Kirgizisztán",
	"LA": "Laosz",
	"LV": "Lettország",
	"LB": "Libanon",
	"LS": "Lesotho",
	"LR": "Libéria",
	"LY": "Líbia",
	"LI": "Liechtenstein",
	"LT": "Litvánia",
	"LU": "Luxemburg",
	"MO": "Makao",
	"MK": "Macedónia",
	"MG": "Madagaszkár",
	"MW": "Malawi",
	"MY": "Malajzia",
	"MV": "Maldív-szigetek",
	"ML": "Mali",
	"MT": "Málta",
	"MH": "Marshall-szigetek",
	"MQ": "Martinique",
	"MR": "Mauritánia",
	"MU": "Mauritius",
	"YT": "Mayotte",
	"MX": "Mexikó",
	"FM": "Mikronéziai Szövetségi Államok",
	"MD": "Moldova",
	"MC": "Monaco",
	"MN": "Mongólia",
	"MS": "Montserrat",
	"MA": "Marokkó",
	"MZ": "Mozambik",
	"MM": "Mianmar",
	"NA": "Namíbia",
	"NR": "Nauru",
	"NP": "Nepál",
	"NL": "Hollandia",
	"NC": "Új-Kaledónia",
	"NZ": "Új-Zéland",
	"NI": "Nicaragua",
	"NE": "Niger",
	"NG": "Nigéria",
	"NU": "Niue",
	"NF": "Norfolk-sziget",
	"MP": "Északi-Mariana-szigetek",
	"NO": "Norvégia",
	"OM": "Omán",
	"PK": "Pakisztán",
	"PW": "Palau",
	"PS": "Palesztina",
	"PA": "Panama",
	"PG": "Pápua Új-Guinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"PH": "Fülöp-szigetek",
	"PN": "Pitcairn-szigetek",
	"PL": "Lengyelország",
	"PT": "Portugália",
	"PR": "Puerto Rico",
	"QA": "Katar",
	"RE": "Réunion",
	"RO": "Románia",
	"RU": "Oroszország",
	"RW": "Ruanda",
	"SH": "Saint Helena",
	"KN": "Saint Kitts és Nevis",
	"LC": "Saint Lucia",
	"PM": "Saint Pierre and Miquelon",
	"VC": "Saint Vincent és a Grenadine-szigetek",
	"WS": "Szamoa",
	"SM": "San Marino",
	"ST": "São Tomé és Príncipe",
	"SA": "Szaudi-Arábia",
	"SN": "Szenegál",
	"SC": "Seychelle-szigetek",
	"SL": "Sierra Leone",
	"SG": "Szingapúr",
	"SK": "Szlovákia",
	"SI": "Szlovénia",
	"SB": "Salamon-szigetek",
	"SO": "Szomália",
	"ZA": "Dél-Afrika",
	"GS": "Déli-Georgia és Déli-Sandwich-szigetek",
	"ES": "Spanyolország",
	"LK": "Sri Lanka",
	"SD": "Szudán",
	"SR": "Suriname",
	"SJ": "Spitzbergák és Jan Mayen",
	"SZ": "Szváziföld",
	"SE": "Svédország",
	"CH": "Svájc",
	"SY": "Szíria",
	"TW": "Tajvan",
	"TJ": "Tádzsikisztán",
	"TZ": "Tanzánia",
	"TH": "Thaiföld",
	"TL": "Kelet-Timor",
	"TG": "Togo",
	"TK": "Tokelau-szigetek",
	"TO": "Tonga",
	"TT": "Trinidad és Tobago",
	"TN": "Tunézia",
	"TR": "Törökország",
	"TM": "Türkmenisztán",
	"TC": "Turks- és Caicos-szigetek",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukrajna",
	"AE": "Egyesült Arab Emírségek",
	"GB": "Egyesült Királyság",
	"US": "Amerikai Egyesült Államok",
	"UM": "Az Amerikai Egyesült Államok lakatlan külbirtokai",
	"UY": "Uruguay",
	"UZ": "Üzbegisztán",
	"VU": "Vanuatu",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"VG": "Brit Virgin-szigetek",
	"VI": "Amerikai Virgin-szigetek",
	"WF": "Wallis és Futuna",
	"EH": "Nyugat-Szahara",
	"YE": "Jemen",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"AX": "Åland",
	"BQ": "Karibi Hollandia",
	"CW": "Curaçao",
	"GG": "Guernsey",
	"IM": "Man-sziget",
	"JE": "Jersey",
	"ME": "Montenegró",
	"BL": "Saint Barthélemy",
	"MF": "Szent Márton-sziget (francia rész)",
	"RS": "Szerbia",
	"SX": "Szent Márton-sziget (holland rész)",
	"SS": "Dél-Szudán",
	"XK": "Koszovó"
};

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports = {
	"AD": "Andorra",
	"AE": "Emirati Arabi Uniti",
	"AF": "Afghanistan",
	"AG": "Antigua e Barbuda",
	"AI": "Anguilla",
	"AL": "Albania",
	"AM": "Armenia",
	"AO": "Angola",
	"AQ": "Antartide",
	"AR": "Argentina",
	"AS": "Samoa Americane",
	"AT": "Austria",
	"AU": "Australia",
	"AW": "Aruba",
	"AX": "Isole Åland",
	"AZ": "Azerbaigian",
	"BA": "Bosnia ed Erzegovina",
	"BB": "Barbados",
	"BD": "Bangladesh",
	"BE": "Belgio",
	"BF": "Burkina Faso",
	"BG": "Bulgaria",
	"BH": "Bahrain",
	"BI": "Burundi",
	"BJ": "Benin",
	"BL": "Saint-Barthélemy",
	"BM": "Bermuda",
	"BN": "Brunei",
	"BO": "Bolivia",
	"BQ": "Isole BES",
	"BR": "Brasile",
	"BS": "Bahamas",
	"BT": "Bhutan",
	"BV": "Isola Bouvet",
	"BW": "Botswana",
	"BY": "Bielorussia",
	"BZ": "Belize",
	"CA": "Canada",
	"CC": "Isole Cocos e Keeling",
	"CD": "Repubblica Democratica del Congo",
	"CF": "Repubblica Centrafricana",
	"CG": "Repubblica del Congo",
	"CH": "Svizzera",
	"CI": "Costa d'Avorio",
	"CK": "Isole Cook",
	"CL": "Cile",
	"CM": "Camerun",
	"CN": "Cina",
	"CO": "Colombia",
	"CR": "Costa Rica",
	"CU": "Cuba",
	"CV": "Capo Verde",
	"CW": "Curaçao",
	"CX": "Isola del Natale",
	"CY": "Cipro",
	"CZ": "Repubblica Ceca",
	"DE": "Germania",
	"DJ": "Gibuti",
	"DK": "Danimarca",
	"DM": "Dominica",
	"DO": "Repubblica Dominicana",
	"DZ": "Algeria",
	"EC": "Ecuador",
	"EE": "Estonia",
	"EG": "Egitto",
	"EH": "Sahara Occidentale",
	"ER": "Eritrea",
	"ES": "Spagna",
	"ET": "Etiopia",
	"FI": "Finlandia",
	"FJ": "Figi",
	"FK": "Isole Falkland",
	"FM": "Stati Federati di Micronesia",
	"FO": "Isole Fær Øer",
	"FR": "Francia",
	"GA": "Gabon",
	"GB": "Regno Unito",
	"GD": "Grenada",
	"GE": "Georgia",
	"GF": "Guyana Francese",
	"GG": "Guernsey",
	"GH": "Ghana",
	"GI": "Gibilterra",
	"GL": "Groenlandia",
	"GM": "Gambia",
	"GN": "Guinea",
	"GP": "Guadalupa",
	"GQ": "Guinea Equatoriale",
	"GR": "Grecia",
	"GS": "Georgia del Sud e isole Sandwich meridionali",
	"GT": "Guatemala",
	"GU": "Guam",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HK": "Hong Kong",
	"HM": "Isole Heard e McDonald",
	"HN": "Honduras",
	"HR": "Croazia",
	"HT": "Haiti",
	"HU": "Ungheria",
	"ID": "Indonesia",
	"IE": "Irlanda",
	"IL": "Israele",
	"IM": "Isola di Man",
	"IN": "India",
	"IO": "Territori Britannici dell'Oceano Indiano",
	"IQ": "Iraq",
	"IR": "Iran",
	"IS": "Islanda",
	"IT": "Italia",
	"JE": "Jersey",
	"JM": "Giamaica",
	"JO": "Giordania",
	"JP": "Giappone",
	"KE": "Kenya",
	"KG": "Kirghizistan",
	"KH": "Cambogia",
	"KI": "Kiribati",
	"KM": "Comore",
	"KN": "Saint Kitts e Nevis",
	"KP": "Corea del Nord",
	"KR": "Corea del Sud",
	"KW": "Kuwait",
	"KY": "Isole Cayman",
	"KZ": "Kazakistan",
	"LA": "Laos",
	"LB": "Libano",
	"LC": "Santa Lucia",
	"LI": "Liechtenstein",
	"LK": "Sri Lanka",
	"LR": "Liberia",
	"LS": "Lesotho",
	"LT": "Lituania",
	"LU": "Lussemburgo",
	"LV": "Lettonia",
	"LY": "Libia",
	"MA": "Marocco",
	"MC": "Monaco",
	"MD": "Moldavia",
	"ME": "Montenegro",
	"MF": "Saint-Martin",
	"MG": "Madagascar",
	"MH": "Isole Marshall",
	"MK": "Macedonia",
	"ML": "Mali",
	"MM": "Birmania  Myanmar",
	"MN": "Mongolia",
	"MO": "Macao",
	"MP": "Isole Marianne Settentrionali",
	"MQ": "Martinica",
	"MR": "Mauritania",
	"MS": "Montserrat",
	"MT": "Malta",
	"MU": "Mauritius",
	"MV": "Maldive",
	"MW": "Malawi",
	"MX": "Messico",
	"MY": "Malesia",
	"MZ": "Mozambico",
	"NA": "Namibia",
	"NC": "Nuova Caledonia",
	"NE": "Niger",
	"NF": "Isola Norfolk",
	"NG": "Nigeria",
	"NI": "Nicaragua",
	"NL": "Paesi Bassi",
	"NO": "Norvegia",
	"NP": "Nepal",
	"NR": "Nauru",
	"NU": "Niue",
	"NZ": "Nuova Zelanda",
	"OM": "Oman",
	"PA": "Panamá",
	"PE": "Perù",
	"PF": "Polinesia Francese",
	"PG": "Papua Nuova Guinea",
	"PH": "Filippine",
	"PK": "Pakistan",
	"PL": "Polonia",
	"PM": "Saint Pierre e Miquelon",
	"PN": "Isole Pitcairn",
	"PR": "Porto Rico",
	"PS": "Stato di Palestina",
	"PT": "Portogallo",
	"PW": "Palau",
	"PY": "Paraguay",
	"QA": "Qatar",
	"RE": "Réunion",
	"RO": "Romania",
	"RS": "Serbia",
	"RU": "Russia",
	"RW": "Ruanda",
	"SA": "Arabia Saudita",
	"SB": "Isole Salomone",
	"SC": "Seychelles",
	"SD": "Sudan",
	"SE": "Svezia",
	"SG": "Singapore",
	"SH": "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
	"SI": "Slovenia",
	"SJ": "Svalbard e Jan Mayen",
	"SK": "Slovacchia",
	"SL": "Sierra Leone",
	"SM": "San Marino",
	"SN": "Senegal",
	"SO": "Somalia",
	"SR": "Suriname",
	"SS": "Sudan del Sud",
	"ST": "São Tomé e Príncipe",
	"SV": "El Salvador",
	"SX": "Sint Maarten",
	"SY": "Siria",
	"SZ": "Swaziland",
	"TC": "Isole Turks e Caicos",
	"TD": "Ciad",
	"TF": "Territori Francesi del Sud",
	"TG": "Togo",
	"TH": "Thailandia",
	"TJ": "Tagikistan",
	"TK": "Tokelau",
	"TL": "Timor Est",
	"TM": "Turkmenistan",
	"TN": "Tunisia",
	"TO": "Tonga",
	"TR": "Turchia",
	"TT": "Trinidad e Tobago",
	"TV": "Tuvalu",
	"TW": "Repubblica di Cina",
	"TZ": "Tanzania",
	"UA": "Ucraina",
	"UG": "Uganda",
	"UM": "Isole minori esterne degli Stati Uniti",
	"US": "Stati Uniti d'America",
	"UY": "Uruguay",
	"UZ": "Uzbekistan",
	"VA": "Città del Vaticano",
	"VC": "Saint Vincent e Grenadine",
	"VE": "Venezuela",
	"VG": "Isole Vergini Britanniche",
	"VI": "Isole Vergini Americane",
	"VN": "Vietnam",
	"VU": "Vanuatu",
	"WF": "Wallis e Futuna",
	"WS": "Samoa",
	"YE": "Yemen",
	"YT": "Mayotte",
	"ZA": "Sudafrica",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"XK": "Kosovo"
};

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

module.exports = {
	"AF": "아프가니스탄",
	"AL": "알바니아",
	"DZ": "알제리",
	"AS": "아메리칸 사모아",
	"AD": "안도라",
	"AO": "앙골라",
	"AI": "앵 귈라",
	"AQ": "남극 대륙",
	"AG": "앤티가 바부 다",
	"AR": "아르헨티나",
	"AM": "아르메니아",
	"AW": "아루바",
	"AU": "호주",
	"AT": "오스트리아",
	"AZ": "아제르바이잔",
	"BS": "바하마",
	"BH": "바레인",
	"BD": "방글라데시",
	"BB": "바베이도스",
	"BY": "벨라루스",
	"BE": "벨기에",
	"BZ": "벨리즈",
	"BJ": "베냉",
	"BM": "버뮤다",
	"BT": "부탄",
	"BO": "볼리비아",
	"BA": "보스니아 헤르체고비나",
	"BW": "보츠와나",
	"BV": "부베 섬",
	"BR": "브라질",
	"IO": "영국령 인도양 지역",
	"BN": "브루나이 다루 살람",
	"BG": "불가리아",
	"BF": "부키 나 파소",
	"BI": "부룬디",
	"KH": "캄보디아",
	"CM": "카메룬",
	"CA": "캐나다",
	"CV": "카보 베르데",
	"KY": "케이맨 제도",
	"CF": "중앙 아프리카 공화국",
	"TD": "차드",
	"CL": "칠레",
	"CN": "중국",
	"CX": "크리스마스 섬",
	"CC": "코코스 군도",
	"CO": "콜롬비아",
	"KM": "코모로",
	"CG": "콩고",
	"CD": "콩고 민주 공화국",
	"CK": "쿡 제도",
	"CR": "코스타리카",
	"CI": "코트 디부 아르",
	"HR": "크로아티아",
	"CU": "쿠바",
	"CY": "키프로스",
	"CZ": "체코 공화국",
	"DK": "덴마크",
	"DJ": "지부티",
	"DM": "도미니카 공화국",
	"DO": "도미니카 공화국",
	"EC": "에콰도르",
	"EG": "이집트",
	"SV": "엘살바도르",
	"GQ": "적도 기니",
	"ER": "에리트레아",
	"EE": "에스토니아",
	"ET": "에티오피아",
	"FK": "포클랜드 제도 (말 비나 스)",
	"FO": "페로 제도",
	"FJ": "피지",
	"FI": "핀란드",
	"FR": "프랑스",
	"GF": "프랑스 령 기아나",
	"PF": "프랑스 령 폴리네시아의",
	"TF": "프랑스 남부 지역",
	"GA": "가봉",
	"GM": "감비아",
	"GE": "그루지야",
	"DE": "독일",
	"GH": "가나",
	"GI": "지브롤터",
	"GR": "그리스",
	"GL": "그린란드",
	"GD": "그레나다",
	"GP": "과들루프",
	"GU": "괌",
	"GT": "과테말라",
	"GN": "기니",
	"GW": "기니 비사우",
	"GY": "가이아나",
	"HT": "아이티",
	"HM": "허드 섬 및 맥도널드 제도",
	"VA": "성좌 (바티칸 시국)",
	"HN": "온두라스",
	"HK": "홍콩",
	"HU": "헝가리",
	"IS": "아이슬란드",
	"IN": "인도",
	"ID": "인도네시아 공화국",
	"IR": "이란, 이슬람 공화국",
	"IQ": "이라크",
	"IE": "아일랜드",
	"IL": "이스라엘",
	"IT": "이탈리아",
	"JM": "자메이카",
	"JP": "일본",
	"JO": "요르단",
	"KZ": "카자흐스탄",
	"KE": "케냐",
	"KI": "키리바시",
	"KP": "한국, 조선 민주주의 인민 공화국",
	"KR": "대한민국",
	"KW": "쿠웨이트",
	"KG": "키르기즈스탄",
	"LA": "라오스 인민 민주주의 공화국",
	"LV": "라트비아",
	"LB": "레바논",
	"LS": "레소토",
	"LR": "라이베리아",
	"LY": "리비아 아랍 자 마히리 야",
	"LI": "리히텐슈타인",
	"LT": "리투아니아",
	"LU": "룩셈부르크",
	"MO": "마카오",
	"MK": "마케도니아, 이전의 유고 슬라비아 공화국",
	"MG": "마다가스카르",
	"MW": "말라위",
	"MY": "말레이시아",
	"MV": "몰디브",
	"ML": "말리",
	"MT": "몰타",
	"MH": "마샬 군도",
	"MQ": "마르티니크",
	"MR": "모리타니",
	"MU": "모리셔스",
	"YT": "마 요트",
	"MX": "멕시코",
	"FM": "미크로네시아,",
	"MD": "몰도바, 공화국",
	"MC": "모나코",
	"MN": "몽골리아",
	"MS": "몬세 라트",
	"MA": "모로코",
	"MZ": "모잠비크",
	"MM": "미얀마",
	"NA": "나미비아",
	"NR": "나우루",
	"NP": "네팔",
	"NL": "네덜란드",
	"NC": "뉴 칼레도니아",
	"NZ": "뉴질랜드",
	"NI": "니카라과",
	"NE": "니제르",
	"NG": "나이지리아",
	"NU": "니우에",
	"NF": "노퍽 섬",
	"MP": "북 마리아나 제도",
	"NO": "노르웨이",
	"OM": "오만",
	"PK": "파키스탄",
	"PW": "팔라우",
	"PS": "팔레스타인 자치구, 점령 자",
	"PA": "파나마",
	"PG": "파푸아 뉴기니",
	"PY": "파라과이",
	"PE": "페루",
	"PH": "필리핀 제도",
	"PN": "핏 케언",
	"PL": "폴란드",
	"PT": "포르투갈",
	"PR": "푸에르토 리코",
	"QA": "카타르",
	"RE": "재결합",
	"RO": "루마니아",
	"RU": "러시아 연방",
	"RW": "르완다",
	"SH": "세인트 헬레나",
	"KN": "세인트 키츠 네비스",
	"LC": "세인트 루시아",
	"PM": "생 피에르 미 클롱",
	"VC": "세인트 빈센트 그레나딘",
	"WS": "사모아",
	"SM": "산 마리노",
	"ST": "상투 메 프린시 페",
	"SA": "사우디 아라비아",
	"SN": "세네갈",
	"SC": "세이셸",
	"SL": "시에라 리온",
	"SG": "싱가포르",
	"SK": "슬로바키아",
	"SI": "슬로베니아",
	"SB": "솔로몬 제도",
	"SO": "소말리아",
	"ZA": "남아프리카",
	"GS": "사우스 조지아 및 사우스 샌드위치 제도",
	"ES": "스페인",
	"LK": "스리랑카",
	"SD": "수단",
	"SR": "수리남",
	"SJ": "스발 바르와 얀 메이 엔",
	"SZ": "스와질란드",
	"SE": "스웨덴",
	"CH": "스위스",
	"SY": "시리아",
	"TW": "대만",
	"TJ": "타지키스탄",
	"TZ": "탄자니아, 유엔",
	"TH": "태국",
	"TL": "동 티모르",
	"TG": "가다",
	"TK": "토켈 라우",
	"TO": "통가",
	"TT": "트리니다드 토바고",
	"TN": "튀니지",
	"TR": "터키",
	"TM": "투르크 메니스탄",
	"TC": "터크 스 케이 커스 제도",
	"TV": "투발루",
	"UG": "우간다",
	"UA": "우크라이나",
	"AE": "아랍 에미리트",
	"GB": "영국",
	"US": "미국",
	"UM": "미국령 군소 제도",
	"UY": "우루과이",
	"UZ": "우즈베키스탄",
	"VU": "바누아투",
	"VE": "베네수엘라",
	"VN": "베트남",
	"VG": "영국령 버진 아일랜드",
	"VI": "미국령 버진 아일랜드",
	"WF": "월리스 푸 투나",
	"EH": "서사하라",
	"YE": "예멘 아랍 공화국",
	"ZM": "잠비아",
	"ZW": "짐바브웨",
	"AX": "올란드 제도",
	"BQ": "보네르, 신트 유스 타티 우스, 사바",
	"CW": "쿠라 사오",
	"GG": "건지 섬",
	"IM": "아일 오브 맨",
	"JE": "저지",
	"ME": "몬테네그로",
	"BL": "생 바르 텔레 미",
	"MF": "세인트 마틴 (프랑스어 부분)",
	"RS": "세르비아",
	"SX": "신트 마틴 (네덜란드어 부분)",
	"SS": "남 수단",
	"XK": "코소보"
};

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports = {
	"AD": "Andorra",
	"AE": "De forente arabiske emirater",
	"AF": "Afghanistan",
	"AG": "Antigua og Barbuda",
	"AI": "Anguilla",
	"AL": "Albania",
	"AM": "Armenia",
	"AO": "Angola",
	"AQ": "Antarktis",
	"AR": "Argentina",
	"AS": "Amerikansk Samoa",
	"AT": "Østerrike",
	"AU": "Australia",
	"AW": "Aruba",
	"AX": "Åland",
	"AZ": "Aserbajdsjan",
	"BA": "Bosnia-Hercegovina",
	"BB": "Barbados",
	"BD": "Bangladesh",
	"BE": "Belgia",
	"BF": "Burkina Faso",
	"BG": "Bulgaria",
	"BH": "Bahrain",
	"BI": "Burundi",
	"BJ": "Benin",
	"BL": "Saint-Barthélemy",
	"BM": "Bermuda",
	"BN": "Brunei",
	"BO": "Bolivia",
	"BQ": "Karibisk Nederland",
	"BR": "Brasil",
	"BS": "Bahamas",
	"BT": "Bhutan",
	"BV": "Bouvetøya",
	"BW": "Botswana",
	"BY": "Hviterussland",
	"BZ": "Belize",
	"CA": "Canada",
	"CC": "Kokosøyene",
	"CD": "Kongo",
	"CF": "Den sentralafrikanske republikk",
	"CG": "Kongo-Brazzaville",
	"CH": "Sveits",
	"CI": "Elfenbenskysten",
	"CK": "Cookøyene",
	"CL": "Chile",
	"CM": "Kamerun",
	"CN": "Kina",
	"CO": "Colombia",
	"CR": "Costa Rica",
	"CU": "Cuba",
	"CV": "Kapp Verde",
	"CW": "Curaçao",
	"CX": "Christmasøya",
	"CY": "Kypros",
	"CZ": "Tsjekkia",
	"DE": "Tyskland",
	"DJ": "Djibouti",
	"DK": "Danmark",
	"DM": "Dominica",
	"DO": "Den dominikanske republikk",
	"DZ": "Algerie",
	"EC": "Ecuador",
	"EE": "Estland",
	"EG": "Egypt",
	"EH": "Vest-Sahara",
	"ER": "Eritrea",
	"ES": "Spania",
	"ET": "Etiopia",
	"FI": "Finland",
	"FJ": "Fiji",
	"FK": "Falklandsøyene",
	"FM": "Mikronesiaføderasjonen",
	"FO": "Færøyene",
	"FR": "Frankrike",
	"GA": "Gabon",
	"GB": "Storbritannia",
	"GD": "Grenada",
	"GE": "Georgia",
	"GF": "Fransk Guyana",
	"GG": "Guernsey",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GL": "Grønland",
	"GM": "Gambia",
	"GN": "Guinea",
	"GP": "Guadeloupe",
	"GQ": "Ekvatorial-Guinea",
	"GR": "Hellas",
	"GS": "Sør-Georgia og de søre Sandwichøyene",
	"GT": "Guatemala",
	"GU": "Guam",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HK": "Hongkong",
	"HM": "Heard- og McDonald-øyene",
	"HN": "Honduras",
	"HR": "Kroatia",
	"HT": "Haiti",
	"HU": "Ungarn",
	"ID": "Indonesia",
	"IE": "Irland",
	"IL": "Israel",
	"IM": "Man",
	"IN": "India",
	"IO": "Britisk territorium i Indiahavet",
	"IQ": "Irak",
	"IR": "Iran",
	"IS": "Island",
	"IT": "Italia",
	"JE": "Jersey",
	"JM": "Jamaica",
	"JO": "Jordan",
	"JP": "Japan",
	"KE": "Kenya",
	"KG": "Kirgisistan",
	"KH": "Kambodsja",
	"KI": "Kiribati",
	"KM": "Komorene",
	"KN": "Saint Kitts og Nevis",
	"KP": "Nord-Korea",
	"KR": "Sør-Korea",
	"KW": "Kuwait",
	"KY": "Caymanøyene",
	"KZ": "Kasakhstan",
	"LA": "Laos",
	"LB": "Libanon",
	"LC": "Saint Lucia",
	"LI": "Liechtenstein",
	"LK": "Sri Lanka",
	"LR": "Liberia",
	"LS": "Lesotho",
	"LT": "Litauen",
	"LU": "Luxembourg",
	"LV": "Latvia",
	"LY": "Libya",
	"MA": "Marokko",
	"MC": "Monaco",
	"MD": "Moldova",
	"ME": "Montenegro",
	"MF": "Saint-Martin",
	"MG": "Madagaskar",
	"MH": "Marshalløyene",
	"MK": "Makedonia",
	"ML": "Mali",
	"MM": "Burma",
	"MN": "Mongolia",
	"MO": "Macao",
	"MP": "Nord-Marianene",
	"MQ": "Martinique",
	"MR": "Mauritania",
	"MS": "Montserrat",
	"MT": "Malta",
	"MU": "Mauritius",
	"MV": "Maldivene",
	"MW": "Malawi",
	"MX": "Mexico",
	"MY": "Malaysia",
	"MZ": "Mosambik",
	"NA": "Namibia",
	"NC": "Ny-Caledonia",
	"NE": "Niger",
	"NF": "Norfolk Island",
	"NG": "Nigeria",
	"NI": "Nicaragua",
	"NL": "Nederland",
	"NO": "Norge",
	"NP": "Nepal",
	"NR": "Nauru",
	"NU": "Niue",
	"NZ": "New Zealand",
	"OM": "Oman",
	"PA": "Panama",
	"PE": "Peru",
	"PF": "Fransk Polynesia",
	"PG": "Papua Ny-Guinea",
	"PH": "Filippinene",
	"PK": "Pakistan",
	"PL": "Polen",
	"PM": "Saint-Pierre-et-Miquelon",
	"PN": "Pitcairn",
	"PR": "Puerto Rico",
	"PS": "De okkuperte palestinske områdene",
	"PT": "Portugal",
	"PW": "Palau",
	"PY": "Paraguay",
	"QA": "Qatar",
	"RE": "Réunion",
	"RO": "Romania",
	"RS": "Serbia",
	"RU": "Russland",
	"RW": "Rwanda",
	"SA": "Saudi-Arabia",
	"SB": "Salomonøyene",
	"SC": "Seychellene",
	"SD": "Sudan",
	"SE": "Sverige",
	"SG": "Singapore",
	"SH": "St. Helena",
	"SI": "Slovenia",
	"SJ": "Svalbard og Jan Mayen",
	"SK": "Slovakia",
	"SL": "Sierra Leone",
	"SM": "San Marino",
	"SN": "Senegal",
	"SO": "Somalia",
	"SR": "Surinam",
	"SS": "Sør-Sudan",
	"ST": "São Tomé og Príncipe",
	"SV": "El Salvador",
	"SX": "Sint Maarten (Nederlandsk del)",
	"SY": "Syria",
	"SZ": "Swaziland",
	"TC": "Turks- og Caicosøyene",
	"TD": "Tsjad",
	"TF": "Søre franske territorier",
	"TG": "Togo",
	"TH": "Thailand",
	"TJ": "Tadsjikistan",
	"TK": "Tokelau",
	"TL": "Øst-Timor",
	"TM": "Turkmenistan",
	"TN": "Tunisia",
	"TO": "Tonga",
	"TR": "Tyrkia",
	"TT": "Trinidad og Tobago",
	"TV": "Tuvalu",
	"TW": "Taiwan",
	"TZ": "Tanzania",
	"UA": "Ukraina",
	"UG": "Uganda",
	"UM": "USA, mindre, utenforliggende øyer",
	"US": "USA",
	"UY": "Uruguay",
	"UZ": "Usbekistan",
	"VA": "Vatikanstaten",
	"VC": "Saint Vincent og Grenadinene",
	"VE": "Venezuela",
	"VG": "Jomfruøyene (Britisk)",
	"VI": "Jomfruøyene (USA)",
	"VN": "Vietnam",
	"VU": "Vanuatu",
	"WF": "Wallis- og Futunaøyene",
	"WS": "Samoa",
	"YE": "Jemen",
	"YT": "Mayotte",
	"ZA": "Sør-Afrika",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"XK": "Kosovo"
};

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afghanistan",
	"AL": "Albanië",
	"DZ": "Algerije",
	"AS": "Amerikaans-Samoa",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarctica",
	"AG": "Antigua en Barbuda",
	"AR": "Argentinië",
	"AM": "Armenië",
	"AW": "Aruba",
	"AU": "Australië",
	"AT": "Oostenrijk",
	"AZ": "Azerbeidzjan",
	"BS": "Bahama's",
	"BH": "Bahrein",
	"BD": "Bangladesh",
	"BB": "Barbados",
	"BY": "Wit-Rusland",
	"BE": "België",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermuda",
	"BT": "Bhutan",
	"BO": "Bolivië",
	"BA": "Bosnië-Herzegovina",
	"BW": "Botswana",
	"BV": "Bouvet Eiland",
	"BR": "Brazilië",
	"IO": "Brits Indische oceaan",
	"BN": "Brunei Darussalam",
	"BG": "Bulgarije",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KH": "Cambodja",
	"CM": "Kameroen",
	"CA": "Canada",
	"CV": "Kaapverdië",
	"KY": "Kaaimaneilanden",
	"CF": "Centraal-Afrikaanse Republiek",
	"TD": "Tsjaad",
	"CL": "Chili",
	"CN": "China",
	"CX": "Christmaseiland",
	"CC": "Cocoseilanden",
	"CO": "Colombia",
	"KM": "Comoren",
	"CG": "Congo, Volksrepubliek",
	"CD": "Congo, Democratische Republiek",
	"CK": "Cookeilanden",
	"CR": "Costa Rica",
	"CI": "Ivoorkust",
	"HR": "Kroatië",
	"CU": "Cuba",
	"CY": "Cyprus",
	"CZ": "Tsjechië",
	"DK": "Denemarken",
	"DJ": "Djibouti",
	"DM": "Dominica",
	"DO": "Dominicaanse Republiek",
	"EC": "Ecuador",
	"EG": "Egypte",
	"SV": "El Salvador",
	"GQ": "Equatoriaal-Guinea",
	"ER": "Eritrea",
	"EE": "Estland",
	"ET": "Ethiopië",
	"FK": "Falklandeilanden",
	"FO": "Faeröer",
	"FJ": "Fiji",
	"FI": "Finland",
	"FR": "Frankrijk",
	"GF": "Frans-Guyana",
	"PF": "Frans-Polynesië",
	"TF": "Franse Zuidelijke Gebieden",
	"GA": "Gabon",
	"GM": "Gambia",
	"GE": "Georgië",
	"DE": "Duitsland",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GR": "Griekenland",
	"GL": "Groenland",
	"GD": "Grenada",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GW": "Guinee-Bissau",
	"GY": "Guyana",
	"HT": "Haïti",
	"HM": "Heard en McDonaldeilanden",
	"VA": "Heilige Stoel",
	"HN": "Honduras",
	"HK": "Hong Kong",
	"HU": "Hongarije",
	"IS": "IJsland",
	"IN": "India",
	"ID": "Indonesia",
	"IR": "Iran",
	"IQ": "Irak",
	"IE": "Ierland",
	"IL": "Israël",
	"IT": "Italië",
	"JM": "Jamaica",
	"JP": "Japan",
	"JO": "Jordanië",
	"KZ": "Kazachstan",
	"KE": "Kenia",
	"KI": "Kiribati",
	"KP": "Noord-Korea, Democratische Volksrepubliek",
	"KR": "Zuid-Korea",
	"KW": "Koeweit",
	"KG": "Kirgizstan",
	"LA": "Laos",
	"LV": "Letland",
	"LB": "Libanon",
	"LS": "Lesotho",
	"LR": "Liberia",
	"LY": "Libië",
	"LI": "Liechtenstein",
	"LT": "Litouwen",
	"LU": "Luxemburg, Groot-Hertogdom",
	"MO": "Macao",
	"MK": "Macedonië, Ex-Joegoslavische Republiek",
	"MG": "Madagaskar",
	"MW": "Malawi",
	"MY": "Maleisië",
	"MV": "Maldiven",
	"ML": "Mali",
	"MT": "Malta",
	"MH": "Marshalleilanden",
	"MQ": "Martinique",
	"MR": "Mauritanië",
	"MU": "Mauritius",
	"YT": "Mayotte",
	"MX": "Mexico",
	"FM": "Micronesië, Federale Staten",
	"MD": "Moldavië",
	"MC": "Monaco",
	"MN": "Mongolië",
	"MS": "Montserrat",
	"MA": "Marokko",
	"MZ": "Mozambique",
	"MM": "Myanmar",
	"NA": "Namibië",
	"NR": "Nauru",
	"NP": "Nepal",
	"NL": "Nederland",
	"NC": "Nieuw-Caledonië",
	"NZ": "Nieuw-Zeeland",
	"NI": "Nicaragua",
	"NE": "Niger",
	"NG": "Nigeria",
	"NU": "Niue",
	"NF": "Norfolk",
	"MP": "Noordelijke Marianen",
	"NO": "Noorwegen",
	"OM": "Oman",
	"PK": "Pakistan",
	"PW": "Palau",
	"PS": "Palestina",
	"PA": "Panama",
	"PG": "Papoea-Nieuw-Guinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"PH": "Filipijnen",
	"PN": "Pitcairn",
	"PL": "Polen",
	"PT": "Portugal",
	"PR": "Puerto Rico",
	"QA": "Qatar",
	"RE": "Réunion",
	"RO": "Roemenië",
	"RU": "Rusland",
	"RW": "Rwanda",
	"SH": "Sint-Helena",
	"KN": "Saint Kitts en Nevis",
	"LC": "Saint Lucia",
	"PM": "Saint-Pierre en Miquelon",
	"VC": "Saint Vincent en de Grenadines",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "São Tomé en Principe",
	"SA": "Saudi-Arabië",
	"SN": "Senegal",
	"SC": "Seychellen",
	"SL": "Sierra Leone",
	"SG": "Singapore",
	"SK": "Slowakije",
	"SI": "Slovenië",
	"SB": "Salomonseilanden",
	"SO": "Somalië",
	"ZA": "Zuid-Afrika",
	"GS": "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
	"ES": "Spanje",
	"LK": "Sri Lanka",
	"SD": "Soedan",
	"SR": "Suriname",
	"SJ": "Spitsbergen en Jan Mayen",
	"SZ": "Ngwane, Koninkrijk Swaziland",
	"SE": "Zweden",
	"CH": "Zwitserland",
	"SY": "Syrië",
	"TW": "Taiwan",
	"TJ": "Tadzjikistan",
	"TZ": "Tanzania, Verenigde Republiek",
	"TH": "Thailand",
	"TL": "Timor Leste",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad en Tobago",
	"TN": "Tunesië",
	"TR": "Turkije",
	"TM": "Turkmenistan",
	"TC": "Turks- en Caicoseilanden",
	"TV": "Tuvalu",
	"UG": "Oeganda",
	"UA": "Oekraïne",
	"AE": "Verenigde Arabische Emiraten",
	"GB": "Verenigd Koninkrijk",
	"US": "Verenigde Staten van Amerika",
	"UM": "Ver afgelegen eilandjes van de Verenigde Staten",
	"UY": "Uruguay",
	"UZ": "Oezbekistan",
	"VU": "Vanuatu",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"VG": "Maagdeneilanden, Britse",
	"VI": "Maagdeneilanden, Amerikaanse",
	"WF": "Wallis en Futuna",
	"EH": "Westelijke Sahara",
	"YE": "Jemen",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"AX": "Åland",
	"BQ": "Bonaire, Sint Eustatius en Saba",
	"CW": "Curaçao",
	"GG": "Guernsey",
	"IM": "Eiland Man",
	"JE": "Jersey",
	"ME": "Montenegro",
	"BL": "Saint Barthélemy",
	"MF": "Sint-Maarten (Frans deel)",
	"RS": "Servië",
	"SX": "Sint Maarten (Nederlands deel)",
	"SS": "Zuid-Soedan",
	"XK": "Kosovo"
};

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports = {
	"AD": "Andorra",
	"AE": "Dei sameinte arabiske emirata",
	"AF": "Afghanistan",
	"AG": "Antigua og Barbuda",
	"AI": "Anguilla",
	"AL": "Albania",
	"AM": "Armenia",
	"AO": "Angola",
	"AQ": "Antarktis",
	"AR": "Argentina",
	"AS": "Amerikansk Samoa",
	"AT": "Austerrike",
	"AU": "Australia",
	"AW": "Aruba",
	"AX": "Åland",
	"AZ": "Aserbajdsjan",
	"BA": "Bosnia-Hercegovina",
	"BB": "Barbados",
	"BD": "Bangladesh",
	"BE": "Belgia",
	"BF": "Burkina Faso",
	"BG": "Bulgaria",
	"BH": "Bahrain",
	"BI": "Burundi",
	"BJ": "Benin",
	"BL": "Saint-Barthélemy",
	"BM": "Bermuda",
	"BN": "Brunei",
	"BO": "Bolivia",
	"BQ": "Karibisk Nederland",
	"BR": "Brasil",
	"BS": "Bahamas",
	"BT": "Bhutan",
	"BV": "Bouvetøya",
	"BW": "Botswana",
	"BY": "Kviterussland",
	"BZ": "Belize",
	"CA": "Canada",
	"CC": "Kokosøyane",
	"CD": "Kongo",
	"CF": "Den sentralafrikanske republikken",
	"CG": "Kongo-Brazzaville",
	"CH": "Sveits",
	"CI": "Elfenbeinskysten",
	"CK": "Cookøyane",
	"CL": "Chile",
	"CM": "Kamerun",
	"CN": "Kina",
	"CO": "Colombia",
	"CR": "Costa Rica",
	"CU": "Cuba",
	"CV": "Kapp Verde",
	"CW": "Curaçao",
	"CX": "Christmasøya",
	"CY": "Kypros",
	"CZ": "Tsjekkia",
	"DE": "Tyskland",
	"DJ": "Djibouti",
	"DK": "Danmark",
	"DM": "Dominica",
	"DO": "Den dominikanske republikken",
	"DZ": "Algerie",
	"EC": "Ecuador",
	"EE": "Estland",
	"EG": "Egypt",
	"EH": "Vest-Sahara",
	"ER": "Eritrea",
	"ES": "Spania",
	"ET": "Etiopia",
	"FI": "Finland",
	"FJ": "Fiji",
	"FK": "Falklandsøyane",
	"FM": "Mikronesiaføderasjonen",
	"FO": "Færøyane",
	"FR": "Frankrike",
	"GA": "Gabon",
	"GB": "Storbritannia",
	"GD": "Grenada",
	"GE": "Georgia",
	"GF": "Fransk Guyana",
	"GG": "Guernsey",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GL": "Grønland",
	"GM": "Gambia",
	"GN": "Guinea",
	"GP": "Guadeloupe",
	"GQ": "Ekvatorial-Guinea",
	"GR": "Hellas",
	"GS": "Sør-Georgia og de søre Sandwichøyane",
	"GT": "Guatemala",
	"GU": "Guam",
	"GW": "Guinea-Bissau",
	"GY": "Guyana",
	"HK": "Hongkong",
	"HM": "Heard- og McDonald-øyane",
	"HN": "Honduras",
	"HR": "Kroatia",
	"HT": "Haiti",
	"HU": "Ungarn",
	"ID": "Indonesia",
	"IE": "Irland",
	"IL": "Israel",
	"IM": "Man",
	"IN": "India",
	"IO": "Britisk territorium i Indiahavet",
	"IQ": "Irak",
	"IR": "Iran",
	"IS": "Island",
	"IT": "Italia",
	"JE": "Jersey",
	"JM": "Jamaica",
	"JO": "Jordan",
	"JP": "Japan",
	"KE": "Kenya",
	"KG": "Kirgisistan",
	"KH": "Kambodsja",
	"KI": "Kiribati",
	"KM": "Komorane",
	"KN": "Saint Kitts og Nevis",
	"KP": "Nord-Korea",
	"KR": "Sør-Korea",
	"KW": "Kuwait",
	"KY": "Caymanøyane",
	"KZ": "Kasakhstan",
	"LA": "Laos",
	"LB": "Libanon",
	"LC": "Saint Lucia",
	"LI": "Liechtenstein",
	"LK": "Sri Lanka",
	"LR": "Liberia",
	"LS": "Lesotho",
	"LT": "Litauen",
	"LU": "Luxembourg",
	"LV": "Latvia",
	"LY": "Libya",
	"MA": "Marokko",
	"MC": "Monaco",
	"MD": "Moldova",
	"ME": "Montenegro",
	"MF": "Saint-Martin",
	"MG": "Madagaskar",
	"MH": "Marshalløyane",
	"MK": "Makedonia",
	"ML": "Mali",
	"MM": "Burma",
	"MN": "Mongolia",
	"MO": "Macao",
	"MP": "Nord-Marianane",
	"MQ": "Martinique",
	"MR": "Mauritania",
	"MS": "Montserrat",
	"MT": "Malta",
	"MU": "Mauritius",
	"MV": "Maldivane",
	"MW": "Malawi",
	"MX": "Mexico",
	"MY": "Malaysia",
	"MZ": "Mosambik",
	"NA": "Namibia",
	"NC": "Ny-Caledonia",
	"NE": "Niger",
	"NF": "Norfolk Island",
	"NG": "Nigeria",
	"NI": "Nicaragua",
	"NL": "Nederland",
	"NO": "Noreg",
	"NP": "Nepal",
	"NR": "Nauru",
	"NU": "Niue",
	"NZ": "New Zealand",
	"OM": "Oman",
	"PA": "Panama",
	"PE": "Peru",
	"PF": "Fransk Polynesia",
	"PG": "Papua Ny-Guinea",
	"PH": "Filippinane",
	"PK": "Pakistan",
	"PL": "Polen",
	"PM": "Saint-Pierre-et-Miquelon",
	"PN": "Pitcairn",
	"PR": "Puerto Rico",
	"PS": "Dei okkuperte palestinske områda",
	"PT": "Portugal",
	"PW": "Palau",
	"PY": "Paraguay",
	"QA": "Qatar",
	"RE": "Réunion",
	"RO": "Romania",
	"RS": "Serbia",
	"RU": "Russland",
	"RW": "Rwanda",
	"SA": "Saudi-Arabia",
	"SB": "Salomonøyane",
	"SC": "Seychellane",
	"SD": "Sudan",
	"SE": "Sverige",
	"SG": "Singapore",
	"SH": "St. Helena",
	"SI": "Slovenia",
	"SJ": "Svalbard og Jan Mayen",
	"SK": "Slovakia",
	"SL": "Sierra Leone",
	"SM": "San Marino",
	"SN": "Senegal",
	"SO": "Somalia",
	"SR": "Surinam",
	"SS": "Sør-Sudan",
	"ST": "São Tomé og Príncipe",
	"SV": "El Salvador",
	"SX": "Sint Maarten (Nederlandsk del)",
	"SY": "Syria",
	"SZ": "Swaziland",
	"TC": "Turks- og Caicosøyane",
	"TD": "Tsjad",
	"TF": "Søre franske territorier",
	"TG": "Togo",
	"TH": "Thailand",
	"TJ": "Tadsjikistan",
	"TK": "Tokelau",
	"TL": "Aust-Timor",
	"TM": "Turkmenistan",
	"TN": "Tunisia",
	"TO": "Tonga",
	"TR": "Tyrkia",
	"TT": "Trinidad og Tobago",
	"TV": "Tuvalu",
	"TW": "Taiwan",
	"TZ": "Tanzania",
	"UA": "Ukraina",
	"UG": "Uganda",
	"UM": "USA, mindre, utanforliggande øyar",
	"US": "USA",
	"UY": "Uruguay",
	"UZ": "Usbekistan",
	"VA": "Vatikanstaten",
	"VC": "Saint Vincent og Grenadinane",
	"VE": "Venezuela",
	"VG": "Jomfruøyane (Britisk)",
	"VI": "Jomfruøyane (USA)",
	"VN": "Vietnam",
	"VU": "Vanuatu",
	"WF": "Wallis- og Futunaøyane",
	"WS": "Samoa",
	"YE": "Jemen",
	"YT": "Mayotte",
	"ZA": "Sør-Afrika",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"XK": "Kosovo"
};

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afganistan",
	"AL": "Albania",
	"DZ": "Algieria",
	"AS": "Samoa Amerykańskie",
	"AD": "Andora",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktyka",
	"AG": "Antigua i Barbuda",
	"AR": "Argentyna",
	"AM": "Armenia",
	"AW": "Aruba",
	"AU": "Australia",
	"AT": "Austria",
	"AZ": "Azerbejdżan",
	"BS": "Bahamy",
	"BH": "Bahrajn",
	"BD": "Bangladesz",
	"BB": "Barbados",
	"BY": "Białoruś",
	"BE": "Belgia",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermudy",
	"BT": "Bhutan",
	"BO": "Boliwia",
	"BA": "Bośnia i Hercegowina",
	"BW": "Botswana",
	"BV": "Wyspa Bouveta",
	"BR": "Brazylia",
	"IO": "Brytyjskie Terytorium Oceanu Indyjskiego",
	"BN": "Brunei",
	"BG": "Bułgaria",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"KH": "Kambodża",
	"CM": "Kamerun",
	"CA": "Kanada",
	"CV": "Republika Zielonego Przylądka",
	"KY": "Kajmany",
	"CF": "Republika Środkowoafrykańska",
	"TD": "Czad",
	"CL": "Chile",
	"CN": "Chiny",
	"CX": "Wyspa Bożego Narodzenia",
	"CC": "Wyspy Kokosowe",
	"CO": "Kolumbia",
	"KM": "Komory",
	"CG": "Kongo",
	"CD": "Demokratyczna Republika Konga",
	"CK": "Wyspy Cooka",
	"CR": "Kostaryka",
	"CI": "Wybrzeże Kości Słoniowej",
	"HR": "Chorwacja",
	"CU": "Kuba",
	"CY": "Cypr",
	"CZ": "Czechy",
	"DK": "Dania",
	"DJ": "Dżibuti",
	"DM": "Dominika",
	"DO": "Dominikana",
	"EC": "Ekwador",
	"EG": "Egipt",
	"SV": "Salwador",
	"GQ": "Gwinea Równikowa",
	"ER": "Erytrea",
	"EE": "Estonia",
	"ET": "Etiopia",
	"FK": "Falklandy",
	"FO": "Wyspy Owcze",
	"FJ": "Fidżi",
	"FI": "Finlandia",
	"FR": "Francja",
	"GF": "Gujana Francuska",
	"PF": "Polinezja Francuska",
	"TF": "Francuskie Terytoria Południowe i Antarktyczne",
	"GA": "Gabon",
	"GM": "Gambia",
	"GE": "Gruzja",
	"DE": "Niemcy",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GR": "Grecja",
	"GL": "Grenlandia",
	"GD": "Grenada",
	"GP": "Gwadelupa",
	"GU": "Guam",
	"GT": "Gwatemala",
	"GN": "Gwinea",
	"GW": "Gwinea Bissau",
	"GY": "Gujana",
	"HT": "Haiti",
	"HM": "Wyspy Heard i McDonalda",
	"VA": "Watykan",
	"HN": "Honduras",
	"HK": "Hongkong",
	"HU": "Węgry",
	"IS": "Islandia",
	"IN": "Indie",
	"ID": "Indonezja",
	"IR": "Iran",
	"IQ": "Irak",
	"IE": "Irlandia",
	"IL": "Izrael",
	"IT": "Włochy",
	"JM": "Jamajka",
	"JP": "Japonia",
	"JO": "Jordania",
	"KZ": "Kazachstan",
	"KE": "Kenia",
	"KI": "Kiribati",
	"KP": "Korea Północna",
	"KR": "Korea Południowa",
	"KW": "Kuwejt",
	"KG": "Kirgistan",
	"LA": "Laos",
	"LV": "Łotwa",
	"LB": "Liban",
	"LS": "Lesotho",
	"LR": "Liberia",
	"LY": "Libia",
	"LI": "Liechtenstein",
	"LT": "Litwa",
	"LU": "Luksemburg",
	"MO": "Makau",
	"MK": "Macedonia",
	"MG": "Madagaskar",
	"MW": "Malawi",
	"MY": "Malezja",
	"MV": "Malediwy",
	"ML": "Mali",
	"MT": "Malta",
	"MH": "Wyspy Marshalla",
	"MQ": "Martynika",
	"MR": "Mauretania",
	"MU": "Mauritius",
	"YT": "Majotta",
	"MX": "Meksyk",
	"FM": "Mikronezja",
	"MD": "Mołdawia",
	"MC": "Monako",
	"MN": "Mongolia",
	"MS": "Montserrat",
	"MA": "Maroko",
	"MZ": "Mozambik",
	"MM": "Mjanma",
	"NA": "Namibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NL": "Holandia",
	"NC": "Nowa Kaledonia",
	"NZ": "Nowa Zelandia",
	"NI": "Nikaragua",
	"NE": "Niger",
	"NG": "Nigeria",
	"NU": "Niue",
	"NF": "Norfolk",
	"MP": "Mariany Północne",
	"NO": "Norwegia",
	"OM": "Oman",
	"PK": "Pakistan",
	"PW": "Palau",
	"PS": "Palestyna",
	"PA": "Panama",
	"PG": "Papua-Nowa Gwinea",
	"PY": "Paragwaj",
	"PE": "Peru",
	"PH": "Filipiny",
	"PN": "Pitcairn",
	"PL": "Polska",
	"PT": "Portugalia",
	"PR": "Portoryko",
	"QA": "Katar",
	"RE": "Reunion",
	"RO": "Rumunia",
	"RU": "Rosja",
	"RW": "Rwanda",
	"SH": "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
	"KN": "Saint Kitts i Nevis",
	"LC": "Saint Lucia",
	"PM": "Saint-Pierre i Miquelon",
	"VC": "Saint Vincent i Grenadyny",
	"WS": "Samoa",
	"SM": "San Marino",
	"ST": "Wyspy Świętego Tomasza i Książęca",
	"SA": "Arabia Saudyjska",
	"SN": "Senegal",
	"SC": "Seszele",
	"SL": "Sierra Leone",
	"SG": "Singapur",
	"SK": "Słowacja",
	"SI": "Słowenia",
	"SB": "Wyspy Salomona",
	"SO": "Somalia",
	"ZA": "Południowa Afryka",
	"GS": "Georgia Południowa i Sandwich Południowy",
	"ES": "Hiszpania",
	"LK": "Sri Lanka",
	"SD": "Sudan",
	"SR": "Surinam",
	"SJ": "Svalbard i Jan Mayen",
	"SZ": "Suazi",
	"SE": "Szwecja",
	"CH": "Szwajcaria",
	"SY": "Syria",
	"TW": "Tajwan",
	"TJ": "Tadżykistan",
	"TZ": "Tanzania",
	"TH": "Tajlandia",
	"TL": "Timor Wschodni",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trynidad i Tobago",
	"TN": "Tunezja",
	"TR": "Turcja",
	"TM": "Turkmenistan",
	"TC": "Turks i Caicos",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukraina",
	"AE": "Zjednoczone Emiraty Arabskie",
	"GB": "Wielka Brytania",
	"US": "Stany Zjednoczone",
	"UM": "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
	"UY": "Urugwaj",
	"UZ": "Uzbekistan",
	"VU": "Vanuatu",
	"VE": "Wenezuela",
	"VN": "Wietnam",
	"VG": "Brytyjskie Wyspy Dziewicze",
	"VI": "Wyspy Dziewicze Stanów Zjednoczonych",
	"WF": "Wallis i Futuna",
	"EH": "Sahara Zachodnia",
	"YE": "Jemen",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"AX": "Wyspy Alandzkie",
	"BQ": "Bonaire, Sint Eustatius i Saba",
	"CW": "Curaçao",
	"GG": "Guernsey",
	"IM": "Wyspa Man",
	"JE": "Jersey",
	"ME": "Czarnogóra",
	"BL": "Saint-Barthélemy",
	"MF": "Saint-Martin",
	"RS": "Serbia",
	"SX": "Sint Maarten",
	"SS": "Sudan Południowy",
	"XK": "Kosowo"
};

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

module.exports = {
	"AF": "Afeganistão",
	"ZA": "África do Sul",
	"AL": "Albânia",
	"DE": "Alemanha",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antártida",
	"AG": "Antígua e Barbuda",
	"SA": "Arábia Saudita",
	"DZ": "Argélia",
	"AR": "Argentina",
	"AM": "Armênia",
	"AW": "Aruba",
	"AU": "Austrália",
	"AT": "Áustria",
	"AZ": "Azerbaijão",
	"BS": "Bahamas",
	"BH": "Bahrein",
	"BD": "Bangladesh",
	"BB": "Barbados",
	"BE": "Bélgica",
	"BZ": "Belize",
	"BJ": "Benin",
	"BM": "Bermudas",
	"BY": "Bielorrússia",
	"BO": "Bolívia",
	"BA": "Bósnia e Herzegovina",
	"BW": "Botsuana",
	"BR": "Brasil",
	"BN": "Brunei",
	"BG": "Bulgária",
	"BF": "Burquina Faso",
	"BI": "Burundi",
	"BT": "Butão",
	"CV": "Cabo Verde",
	"KH": "Camboja",
	"CA": "Canadá",
	"QA": "Catar",
	"KZ": "Cazaquistão",
	"TD": "Chade",
	"CL": "Chile",
	"CN": "China",
	"CY": "Chipre",
	"VA": "Cidade do Vaticano",
	"SG": "Cingapura",
	"CO": "Colômbia",
	"KM": "Comores",
	"CG": "Congo - Brazzaville",
	"CD": "Congo - Kinshasa",
	"KP": "Coreia do Norte",
	"KR": "Coreia do Sul",
	"CI": "Costa do Marfim",
	"CR": "Costa Rica",
	"HR": "Croácia",
	"CU": "Cuba",
	"CW": "Curaçao",
	"DK": "Dinamarca",
	"DJ": "Djibuti",
	"DM": "Dominica",
	"EG": "Egito",
	"SV": "El Salvador",
	"AE": "Emirados Árabes Unidos",
	"EC": "Equador",
	"ER": "Eritreia",
	"SK": "Eslováquia",
	"SI": "Eslovênia",
	"ES": "Espanha",
	"US": "Estados Unidos",
	"EE": "Estônia",
	"ET": "Etiópia",
	"FJ": "Fiji",
	"PH": "Filipinas",
	"FI": "Finlândia",
	"FR": "França",
	"GA": "Gabão",
	"GM": "Gâmbia",
	"GH": "Gana",
	"GE": "Geórgia",
	"GS": "Geórgia do Sul e Ilhas Sandwich do Sul",
	"GI": "Gibraltar",
	"GD": "Granada",
	"GR": "Grécia",
	"GL": "Groenlândia",
	"GP": "Guadalupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GG": "Guernsey",
	"GY": "Guiana",
	"GF": "Guiana Francesa",
	"GN": "Guiné",
	"GW": "Guiné Bissau",
	"GQ": "Guiné Equatorial",
	"HT": "Haiti",
	"NL": "Holanda",
	"HN": "Honduras",
	"HK": "Hong Kong, RAE da China",
	"HU": "Hungria",
	"YE": "Iêmen",
	"BV": "Ilhas Bouvet",
	"CX": "Ilha Christmas",
	"IM": "Ilha de Man",
	"NF": "Ilha Norfolk",
	"AX": "Ilhas Åland",
	"KY": "Ilhas Caiman",
	"CC": "Ilhas Cocos (Keeling)",
	"CK": "Ilhas Cook",
	"UM": "Ilhas Distantes dos EUA",
	"HM": "Ilha Heard e Ilha McDonald",
	"FO": "Ilhas Faroe",
	"FK": "Ilhas Malvinas",
	"MP": "Ilhas Marianas do Norte",
	"MH": "Ilhas Marshall",
	"PN": "Ilhas Pitcairn",
	"SB": "Ilhas Salomão",
	"TC": "Ilhas Turks e Caicos",
	"VG": "Ilhas Virgens Britânicas",
	"VI": "Ilhas Virgens dos EUA",
	"IN": "Índia",
	"ID": "Indonésia",
	"IR": "Irã",
	"IQ": "Iraque",
	"IE": "Irlanda",
	"IS": "Islândia",
	"IL": "Israel",
	"IT": "Itália",
	"JM": "Jamaica",
	"JP": "Japão",
	"JE": "Jersey",
	"JO": "Jordânia",
	"KW": "Kuwait",
	"LA": "Laos",
	"LS": "Lesoto",
	"LV": "Letônia",
	"LB": "Líbano",
	"LR": "Libéria",
	"LY": "Líbia",
	"LI": "Liechtenstein",
	"LT": "Lituânia",
	"LU": "Luxemburgo",
	"MO": "Macau, RAE da China",
	"MK": "Macedônia",
	"MG": "Madagascar",
	"MY": "Malásia",
	"MW": "Malawi",
	"MV": "Maldivas",
	"ML": "Mali",
	"MT": "Malta",
	"MA": "Marrocos",
	"MQ": "Martinica",
	"MU": "Maurício",
	"MR": "Mauritânia",
	"YT": "Mayotte",
	"MX": "México",
	"MM": "Mianmar (Birmânia)",
	"FM": "Micronésia",
	"MZ": "Moçambique",
	"MD": "Moldávia",
	"MC": "Mônaco",
	"MN": "Mongólia",
	"ME": "Montenegro",
	"MS": "Montserrat",
	"NA": "Namíbia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NI": "Nicarágua",
	"NE": "Níger",
	"NG": "Nigéria",
	"NU": "Niue",
	"NO": "Noruega",
	"NC": "Nova Caledônia",
	"NZ": "Nova Zelândia",
	"OM": "Omã",
	"BQ": "Países Baixos Caribenhos",
	"PW": "Palau",
	"PA": "Panamá",
	"PG": "Papua-Nova Guiné",
	"PK": "Paquistão",
	"PY": "Paraguai",
	"PE": "Peru",
	"PF": "Polinésia Francesa",
	"PL": "Polônia",
	"PR": "Porto Rico",
	"PT": "Portugal",
	"KE": "Quênia",
	"KG": "Quirguistão",
	"KI": "Quiribati",
	"GB": "Reino Unido",
	"CF": "República Centro-Africana",
	"DO": "República Dominicana",
	"CM": "República dos Camarões",
	"CZ": "República Tcheca",
	"RE": "Reunião",
	"RO": "Romênia",
	"RW": "Ruanda",
	"RU": "Rússia",
	"EH": "Saara Ocidental",
	"PM": "Saint Pierre e Miquelon",
	"WS": "Samoa",
	"AS": "Samoa Americana",
	"SM": "San Marino",
	"SH": "Santa Helena",
	"LC": "Santa Lúcia",
	"BL": "São Bartolomeu",
	"KN": "São Cristóvão e Nevis",
	"MF": "São Martinho",
	"ST": "São Tomé e Príncipe",
	"VC": "São Vicente e Granadinas",
	"SN": "Senegal",
	"SL": "Serra Leoa",
	"RS": "Sérvia",
	"SC": "Seychelles",
	"SX": "Sint Maarten",
	"SY": "Síria",
	"SO": "Somália",
	"LK": "Sri Lanka",
	"SZ": "Suazilândia",
	"SD": "Sudão",
	"SS": "Sudão do Sul",
	"SE": "Suécia",
	"CH": "Suíça",
	"SR": "Suriname",
	"SJ": "Svalbard e Jan Mayen",
	"TH": "Tailândia",
	"TW": "Taiwan",
	"TJ": "Tajiquistão",
	"TZ": "Tanzânia",
	"IO": "Território Britânico do Oceano Índico",
	"TF": "Territórios Franceses do Sul",
	"PS": "Territórios palestinos",
	"TL": "Timor-Leste",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad e Tobago",
	"TN": "Tunísia",
	"TM": "Turcomenistão",
	"TR": "Turquia",
	"TV": "Tuvalu",
	"UA": "Ucrânia",
	"UG": "Uganda",
	"UY": "Uruguai",
	"UZ": "Uzbequistão",
	"VU": "Vanuatu",
	"VE": "Venezuela",
	"VN": "Vietnã",
	"WF": "Wallis e Futuna",
	"ZM": "Zâmbia",
	"ZW": "Zimbábue",
	"XK": "Kosovo"
};

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

module.exports = {
	"AU": "Австралия",
	"AT": "Австрия",
	"AZ": "Азербайджан",
	"AX": "Аландские острова",
	"AL": "Албания",
	"DZ": "Алжир",
	"VI": "Виргинские Острова (США)",
	"AS": "Американское Самоа",
	"AI": "Ангилья",
	"AO": "Ангола",
	"AD": "Андорра",
	"AQ": "Антарктида",
	"AG": "Антигуа и Барбуда",
	"AR": "Аргентина",
	"AM": "Армения",
	"AW": "Аруба",
	"AF": "Афганистан",
	"BS": "Багамы",
	"BD": "Бангладеш",
	"BB": "Барбадос",
	"BH": "Бахрейн",
	"BZ": "Белиз",
	"BY": "Белоруссия",
	"BE": "Бельгия",
	"BJ": "Бенин",
	"BM": "Бермуды",
	"BG": "Болгария",
	"BO": "Боливия",
	"BQ": "Бонэйр, Синт-Эстатиус и Саба",
	"BA": "Босния и Герцеговина",
	"BW": "Ботсвана",
	"BR": "Бразилия",
	"IO": "Британская территория в Индийском океане",
	"VG": "Виргинские Острова (Великобритания)",
	"BN": "Бруней",
	"BF": "Буркина-Фасо",
	"BI": "Бурунди",
	"BT": "Бутан",
	"VU": "Вануату",
	"VA": "Ватикан",
	"GB": "Великобритания",
	"HU": "Венгрия",
	"VE": "Венесуэла",
	"UM": "Внешние малые острова (США)",
	"TL": "Восточный Тимор",
	"VN": "Вьетнам",
	"GA": "Габон",
	"HT": "Гаити",
	"GY": "Гайана",
	"GM": "Гамбия",
	"GH": "Гана",
	"GP": "Гваделупа",
	"GT": "Гватемала",
	"GF": "Гвиана",
	"GN": "Гвинея",
	"GW": "Гвинея-Бисау",
	"DE": "Германия",
	"GG": "Гернси",
	"GI": "Гибралтар",
	"HN": "Гондурас",
	"HK": "Гонконг",
	"GD": "Гренада",
	"GL": "Гренландия",
	"GR": "Греция",
	"GE": "Грузия",
	"GU": "Гуам",
	"DK": "Дания",
	"JE": "Джерси",
	"DJ": "Джибути",
	"DM": "Доминика",
	"DO": "Доминиканская Республика",
	"CD": "Демократическая Республика Конго",
	"EG": "Египет",
	"ZM": "Замбия",
	"EH": "САДР",
	"ZW": "Зимбабве",
	"IL": "Израиль",
	"IN": "Индия",
	"ID": "Индонезия",
	"JO": "Иордания",
	"IQ": "Ирак",
	"IR": "Иран",
	"IE": "Ирландия",
	"IS": "Исландия",
	"ES": "Испания",
	"IT": "Италия",
	"YE": "Йемен",
	"CV": "Кабо-Верде",
	"KZ": "Казахстан",
	"KY": "Острова Кайман",
	"KH": "Камбоджа",
	"CM": "Камерун",
	"CA": "Канада",
	"QA": "Катар",
	"KE": "Кения",
	"CY": "Кипр",
	"KG": "Киргизия",
	"KI": "Кирибати",
	"TW": "Китайская Республика",
	"KP": "КНДР (Корейская Народно-Демократическая Республика)",
	"CN": "КНР (Китайская Народная Республика)",
	"CC": "Кокосовые острова",
	"CO": "Колумбия",
	"KM": "Коморы",
	"CR": "Коста-Рика",
	"CI": "Кот-д’Ивуар",
	"CU": "Куба",
	"KW": "Кувейт",
	"CW": "Кюрасао",
	"LA": "Лаос",
	"LV": "Латвия",
	"LS": "Лесото",
	"LR": "Либерия",
	"LB": "Ливан",
	"LY": "Ливия",
	"LT": "Литва",
	"LI": "Лихтенштейн",
	"LU": "Люксембург",
	"MU": "Маврикий",
	"MR": "Мавритания",
	"MG": "Мадагаскар",
	"YT": "Майотта",
	"MO": "Макао",
	"MK": "Македония",
	"MW": "Малави",
	"MY": "Малайзия",
	"ML": "Мали",
	"MV": "Мальдивы",
	"MT": "Мальта",
	"MA": "Марокко",
	"MQ": "Мартиника",
	"MH": "Маршалловы Острова",
	"MX": "Мексика",
	"FM": "Микронезия",
	"MZ": "Мозамбик",
	"MD": "Молдавия",
	"MC": "Монако",
	"MN": "Монголия",
	"MS": "Монтсеррат",
	"MM": "Мьянма",
	"NA": "Намибия",
	"NR": "Науру",
	"NP": "Непал",
	"NE": "Нигер",
	"NG": "Нигерия",
	"NL": "Нидерланды",
	"NI": "Никарагуа",
	"NU": "Ниуэ",
	"NZ": "Новая Зеландия",
	"NC": "Новая Каледония",
	"NO": "Норвегия",
	"AE": "ОАЭ",
	"OM": "Оман",
	"BV": "Остров Буве",
	"IM": "Остров Мэн",
	"CK": "Острова Кука",
	"NF": "Остров Норфолк",
	"CX": "Остров Рождества",
	"PN": "Острова Питкэрн",
	"SH": "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
	"PK": "Пакистан",
	"PW": "Палау",
	"PS": "Государство Палестина",
	"PA": "Панама",
	"PG": "Папуа — Новая Гвинея",
	"PY": "Парагвай",
	"PE": "Перу",
	"PL": "Польша",
	"PT": "Португалия",
	"PR": "Пуэрто-Рико",
	"CG": "Республика Конго",
	"KR": "Республика Корея",
	"RE": "Реюньон",
	"RU": "Россия",
	"RW": "Руанда",
	"RO": "Румыния",
	"SV": "Сальвадор",
	"WS": "Самоа",
	"SM": "Сан-Марино",
	"ST": "Сан-Томе и Принсипи",
	"SA": "Саудовская Аравия",
	"SZ": "Свазиленд",
	"MP": "Северные Марианские Острова",
	"SC": "Сейшельские Острова",
	"BL": "Сен-Бартелеми",
	"MF": "Сен-Мартен",
	"PM": "Сен-Пьер и Микелон",
	"SN": "Сенегал",
	"VC": "Сент-Винсент и Гренадины",
	"KN": "Сент-Китс и Невис",
	"LC": "Сент-Люсия",
	"RS": "Сербия",
	"SG": "Сингапур",
	"SX": "Синт-Мартен",
	"SY": "Сирия",
	"SK": "Словакия",
	"SI": "Словения",
	"SB": "Соломоновы Острова",
	"SO": "Сомали",
	"SD": "Судан",
	"SR": "Суринам",
	"US": "США",
	"SL": "Сьерра-Леоне",
	"TJ": "Таджикистан",
	"TH": "Таиланд",
	"TZ": "Танзания",
	"TC": "Теркс и Кайкос",
	"TG": "Того",
	"TK": "Токелау",
	"TO": "Тонга",
	"TT": "Тринидад и Тобаго",
	"TV": "Тувалу",
	"TN": "Тунис",
	"TM": "Туркмения",
	"TR": "Турция",
	"UG": "Уганда",
	"UZ": "Узбекистан",
	"UA": "Украина",
	"WF": "Уоллис и Футуна",
	"UY": "Уругвай",
	"FO": "Фареры",
	"FJ": "Фиджи",
	"PH": "Филиппины",
	"FI": "Финляндия",
	"FK": "Фолклендские острова",
	"FR": "Франция",
	"PF": "Французская Полинезия",
	"TF": "Французские Южные и Антарктические Территории",
	"HM": "Херд и Макдональд",
	"HR": "Хорватия",
	"CF": "ЦАР",
	"TD": "Чад",
	"ME": "Черногория",
	"CZ": "Чехия",
	"CL": "Чили",
	"CH": "Швейцария",
	"SE": "Швеция",
	"SJ": "Шпицберген и Ян-Майен",
	"LK": "Шри-Ланка",
	"EC": "Эквадор",
	"GQ": "Экваториальная Гвинея",
	"ER": "Эритрея",
	"EE": "Эстония",
	"ET": "Эфиопия",
	"ZA": "ЮАР",
	"GS": "Южная Георгия и Южные Сандвичевы Острова",
	"SS": "Южный Судан",
	"JM": "Ямайка",
	"JP": "Япония",
	"XK": "Косово"
};

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

module.exports = {
	"AD": "Andorra",
	"AE": "Förenade Arabemiraten",
	"AF": "Afghanistan",
	"AG": "Antigua och Barbuda",
	"AI": "Anguilla",
	"AL": "Albanien",
	"AM": "Armenien",
	"AO": "Angola",
	"AQ": "Antarktis",
	"AR": "Argentina",
	"AS": "Amerikanska Samoa",
	"AT": "Österrike",
	"AU": "Australien",
	"AW": "Aruba",
	"AX": "Åland",
	"AZ": "Azerbajdzjan",
	"BA": "Bosnien och Hercegovina",
	"BB": "Barbados",
	"BD": "Bangladesh",
	"BE": "Belgien",
	"BF": "Burkina Faso",
	"BG": "Bulgarien",
	"BH": "Bahrain",
	"BI": "Burundi",
	"BJ": "Benin",
	"BL": "Saint-Barthélemy",
	"BM": "Bermuda",
	"BN": "Brunei",
	"BO": "Bolivia",
	"BQ": "Bonaire, Saint Eustatius och Saba",
	"BR": "Brasilien",
	"BS": "Bahamas",
	"BT": "Bhutan",
	"BV": "Bouvetön",
	"BW": "Botswana",
	"BY": "Vitryssland",
	"BZ": "Belize",
	"CA": "Kanada",
	"CC": "Kokosöarna",
	"CD": "Demokratiska republiken Kongo",
	"CF": "Centralafrikanska republiken",
	"CG": "Kongo-Brazzaville",
	"CH": "Schweiz",
	"CI": "Elfenbenskusten",
	"CK": "Cooköarna",
	"CL": "Chile",
	"CM": "Kamerun",
	"CN": "Kina",
	"CO": "Colombia",
	"CR": "Costa Rica",
	"CU": "Kuba",
	"CV": "Kap Verde",
	"CW": "Curacao",
	"CX": "Julön",
	"CY": "Cypern",
	"CZ": "Tjeckien",
	"DE": "Tyskland",
	"DJ": "Djibouti",
	"DK": "Danmark",
	"DM": "Dominica",
	"DO": "Dominikanska republiken",
	"DZ": "Algeriet",
	"EC": "Ecuador",
	"EE": "Estland",
	"EG": "Egypten",
	"EH": "Västsahara",
	"ER": "Eritrea",
	"ES": "Spanien",
	"ET": "Etiopien",
	"FI": "Finland",
	"FJ": "Fiji",
	"FK": "Falklandsöarna",
	"FM": "Mikronesiska federationen",
	"FO": "Färöarna",
	"FR": "Frankrike",
	"GA": "Gabon",
	"GB": "Storbritannien",
	"GD": "Grenada",
	"GE": "Georgien",
	"GF": "Franska Guyana",
	"GG": "Guernsey",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GL": "Grönland",
	"GM": "Gambia",
	"GN": "Guinea",
	"GP": "Guadeloupe",
	"GQ": "Ekvatorialguinea",
	"GR": "Grekland",
	"GS": "Sydgeorgien och Sydsandwichöarna",
	"GT": "Guatemala",
	"GU": "Guam",
	"GW": "Guinea Bissau",
	"GY": "Guyana",
	"HK": "Hongkong",
	"HM": "Heard- och McDonaldsöarna",
	"HN": "Honduras",
	"HR": "Kroatien",
	"HT": "Haiti",
	"HU": "Ungern",
	"ID": "Indonesien",
	"IE": "Irland",
	"IL": "Israel",
	"IM": "Isle of Man",
	"IN": "Indien",
	"IO": "Brittiska territoriet i Indiska Oceanen",
	"IQ": "Irak",
	"IR": "Iran",
	"IS": "Island",
	"IT": "Italien",
	"JE": "Jersey",
	"JM": "Jamaica",
	"JO": "Jordanien",
	"JP": "Japan",
	"KE": "Kenya",
	"KG": "Kirgizistan",
	"KH": "Kambodja",
	"KI": "Kiribati",
	"KM": "Komorerna",
	"KN": "Saint Kitts och Nevis",
	"KP": "Nordkorea",
	"KR": "Sydkorea",
	"KW": "Kuwait",
	"KY": "Caymanöarna",
	"KZ": "Kazakstan",
	"LA": "Laos",
	"LB": "Libanon",
	"LC": "Saint Lucia",
	"LI": "Liechtenstein",
	"LK": "Sri Lanka",
	"LR": "Liberia",
	"LS": "Lesotho",
	"LT": "Litauen",
	"LU": "Luxemburg",
	"LV": "Lettland",
	"LY": "Libyen",
	"MA": "Marocko",
	"MC": "Monaco",
	"MD": "Moldavien",
	"ME": "Montenegro",
	"MF": "Saint Martin (franska delen)",
	"MG": "Madagaskar",
	"MH": "Marshallöarna",
	"MK": "Makedonien",
	"ML": "Mali",
	"MM": "Burma",
	"MN": "Mongoliet",
	"MO": "Macau",
	"MP": "Nordmarianerna",
	"MQ": "Martinique",
	"MR": "Mauretanien",
	"MS": "Montserrat",
	"MT": "Malta",
	"MU": "Mauritius",
	"MV": "Maldiverna",
	"MW": "Malawi",
	"MX": "Mexiko",
	"MY": "Malaysia",
	"MZ": "Moçambique",
	"NA": "Namibia",
	"NC": "Nya Kaledonien",
	"NE": "Niger",
	"NF": "Norfolkön",
	"NG": "Nigeria",
	"NI": "Nicaragua",
	"NL": "Nederländerna",
	"NO": "Norge",
	"NP": "Nepal",
	"NR": "Nauru",
	"NU": "Niue",
	"NZ": "Nya Zeeland",
	"OM": "Oman",
	"PA": "Panama",
	"PE": "Peru",
	"PF": "Franska Polynesien",
	"PG": "Papua Nya Guinea",
	"PH": "Filippinerna",
	"PK": "Pakistan",
	"PL": "Polen",
	"PM": "Saint-Pierre och Miquelon",
	"PN": "Pitcairnöarna",
	"PR": "Puerto Rico",
	"PS": "Palestinska territoriet, ockuperade",
	"PT": "Portugal",
	"PW": "Palau",
	"PY": "Paraguay",
	"QA": "Qatar",
	"RE": "Réunion",
	"RO": "Rumänien",
	"RS": "Serbien",
	"RU": "Ryssland",
	"RW": "Rwanda",
	"SA": "Saudiarabien",
	"SB": "Salomonöarna",
	"SC": "Seychellerna",
	"SD": "Sudan",
	"SE": "Sverige",
	"SG": "Singapore",
	"SH": "Sankta Helena",
	"SI": "Slovenien",
	"SJ": "Svalbard och Jan Mayen",
	"SK": "Slovakien",
	"SL": "Sierra Leone",
	"SM": "San Marino",
	"SN": "Senegal",
	"SO": "Somalia",
	"SR": "Surinam",
	"SS": "Sydsudan",
	"ST": "São Tomé och Príncipe",
	"SV": "El Salvador",
	"SX": "Sint Maarten (nederländska delen)",
	"SY": "Syrien",
	"SZ": "Swaziland",
	"TC": "Turks- och Caicosöarna",
	"TD": "Tchad",
	"TF": "Franska södra territorierna",
	"TG": "Togo",
	"TH": "Thailand",
	"TJ": "Tadzjikistan",
	"TK": "Tokelauöarna",
	"TL": "Östtimor",
	"TM": "Turkmenistan",
	"TN": "Tunisien",
	"TO": "Tonga",
	"TR": "Turkiet",
	"TT": "Trinidad och Tobago",
	"TV": "Tuvalu",
	"TW": "Taiwan",
	"TZ": "Tanzania",
	"UA": "Ukraina",
	"UG": "Uganda",
	"UM": "USA:s yttre öar",
	"US": "USA",
	"UY": "Uruguay",
	"UZ": "Uzbekistan",
	"VA": "Vatikanstaten",
	"VC": "Saint Vincent och Grenadinerna",
	"VE": "Venezuela",
	"VG": "Brittiska Jungfruöarna",
	"VI": "Amerikanska Jungfruöarna",
	"VN": "Vietnam",
	"VU": "Vanuatu",
	"WF": "Wallis- och Futunaöarna",
	"WS": "Samoa",
	"YE": "Jemen",
	"YT": "Mayotte",
	"ZA": "Sydafrika",
	"ZM": "Zambia",
	"ZW": "Zimbabwe",
	"XK": "Kosovo"
};

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

module.exports = {
	"AD": "Andorra",
	"AE": "Birleşik Arap Emirlikleri",
	"AF": "Afganistan",
	"AG": "Antigua ve Barbuda",
	"AI": "Anguilla",
	"AL": "Arnavutluk",
	"AM": "Ermenistan",
	"AO": "Angola",
	"AQ": "Antarktika",
	"AR": "Arjantin",
	"AS": "Amerikan Samoası",
	"AT": "Avusturya",
	"AU": "Avustralya",
	"AW": "Aruba",
	"AX": "Åland Adaları",
	"AZ": "Azerbaycan",
	"BA": "Bosna Hersek",
	"BB": "Barbados",
	"BD": "Bangladeş",
	"BE": "Belçika",
	"BF": "Burkina Faso",
	"BG": "Bulgaristan",
	"BH": "Bahreyn",
	"BI": "Burundi",
	"BJ": "Benin",
	"BL": "Saint Barthelemy",
	"BM": "Bermuda",
	"BN": "Brunei",
	"BO": "Bolivya",
	"BQ": "Karayip Hollanda",
	"BR": "Brezilya",
	"BS": "Bahamalar",
	"BT": "Butan",
	"BV": "Bouvet Adası",
	"BW": "Botsvana",
	"BY": "Beyaz Rusya",
	"BZ": "Belize",
	"CA": "Kanada",
	"CC": "Cocos (Keeling) Adaları",
	"CD": "Kongo - Kinşasa",
	"CF": "Orta Afrika Cumhuriyeti",
	"CG": "Kongo - Brazavil",
	"CH": "İsviçre",
	"CI": "Fildişi Sahili",
	"CK": "Cook Adaları",
	"CL": "Şili",
	"CM": "Kamerun",
	"CN": "Çin",
	"CO": "Kolombiya",
	"CR": "Kosta Rika",
	"CU": "Küba",
	"CV": "Cape Verde",
	"CW": "Curaçao",
	"CX": "Christmas Adası",
	"CY": "Güney Kıbrıs Rum Kesimi",
	"CZ": "Çek Cumhuriyeti",
	"DE": "Almanya",
	"DJ": "Cibuti",
	"DK": "Danimarka",
	"DM": "Dominika",
	"DO": "Dominik Cumhuriyeti",
	"DZ": "Cezayir",
	"EC": "Ekvador",
	"EE": "Estonya",
	"EG": "Mısır",
	"EH": "Batı Sahara",
	"ER": "Eritre",
	"ES": "İspanya",
	"ET": "Etiyopya",
	"FI": "Finlandiya",
	"FJ": "Fiji",
	"FK": "Falkland Adaları",
	"FM": "Mikronezya",
	"FO": "Faroe Adaları",
	"FR": "Fransa",
	"GA": "Gabon",
	"GB": "Birleşik Krallık",
	"GD": "Grenada",
	"GE": "Gürcistan",
	"GF": "Fransız Guyanası",
	"GG": "Guernsey",
	"GH": "Gana",
	"GI": "Cebelitarık",
	"GL": "Grönland",
	"GM": "Gambiya",
	"GN": "Gine",
	"GP": "Guadalupe",
	"GQ": "Ekvator Ginesi",
	"GR": "Yunanistan",
	"GS": "Güney Georgia ve Güney Sandwich Adaları",
	"GT": "Guatemala",
	"GU": "Guam",
	"GW": "Gine-Bissau",
	"GY": "Guyana",
	"HK": "Çin Hong Kong ÖYB",
	"HM": "Heard Adası ve McDonald Adaları",
	"HN": "Honduras",
	"HR": "Hırvatistan",
	"HT": "Haiti",
	"HU": "Macaristan",
	"ID": "Endonezya",
	"IE": "İrlanda",
	"IL": "İsrail",
	"IM": "Man Adası",
	"IN": "Hindistan",
	"IO": "Britanya Hint Okyanusu Toprakları",
	"IQ": "Irak",
	"IR": "İran",
	"IS": "İzlanda",
	"IT": "İtalya",
	"JE": "Jersey",
	"JM": "Jamaika",
	"JO": "Ürdün",
	"JP": "Japonya",
	"KE": "Kenya",
	"KG": "Kırgızistan",
	"KH": "Kamboçya",
	"KI": "Kiribati",
	"KM": "Komorlar",
	"KN": "Saint Kitts ve Nevis",
	"KP": "Kuzey Kore",
	"KR": "Güney Kore",
	"KW": "Kuveyt",
	"KY": "Cayman Adaları",
	"KZ": "Kazakistan",
	"LA": "Laos",
	"LB": "Lübnan",
	"LC": "Saint Lucia",
	"LI": "Liechtenstein",
	"LK": "Sri Lanka",
	"LR": "Liberya",
	"LS": "Lesoto",
	"LT": "Litvanya",
	"LU": "Lüksemburg",
	"LV": "Letonya",
	"LY": "Libya",
	"MA": "Fas",
	"MC": "Monako",
	"MD": "Moldova",
	"ME": "Karadağ",
	"MF": "Saint Martin",
	"MG": "Madagaskar",
	"MH": "Marshall Adaları",
	"MK": "Makedonya",
	"ML": "Mali",
	"MM": "Myanmar (Burma)",
	"MN": "Moğolistan",
	"MO": "Çin Makao ÖYB",
	"MP": "Kuzey Mariana Adaları",
	"MQ": "Martinik",
	"MR": "Moritanya",
	"MS": "Montserrat",
	"MT": "Malta",
	"MU": "Mauritius",
	"MV": "Maldivler",
	"MW": "Malavi",
	"MX": "Meksika",
	"MY": "Malezya",
	"MZ": "Mozambik",
	"NA": "Namibya",
	"NC": "Yeni Kaledonya",
	"NE": "Nijer",
	"NF": "Norfolk Adası",
	"NG": "Nijerya",
	"NI": "Nikaragua",
	"NL": "Hollanda",
	"NO": "Norveç",
	"NP": "Nepal",
	"NR": "Nauru",
	"NU": "Niue",
	"NZ": "Yeni Zelanda",
	"OM": "Umman",
	"PA": "Panama",
	"PE": "Peru",
	"PF": "Fransız Polinezyası",
	"PG": "Papua Yeni Gine",
	"PH": "Filipinler",
	"PK": "Pakistan",
	"PL": "Polonya",
	"PM": "Saint Pierre ve Miquelon",
	"PN": "Pitcairn Adaları",
	"PR": "Porto Riko",
	"PS": "Filistin Bölgeleri",
	"PT": "Portekiz",
	"PW": "Palau",
	"PY": "Paraguay",
	"QA": "Katar",
	"RE": "Réunion",
	"RO": "Romanya",
	"RS": "Sırbistan",
	"RU": "Rusya",
	"RW": "Ruanda",
	"SA": "Suudi Arabistan",
	"SB": "Solomon Adaları",
	"SC": "Seyşeller",
	"SD": "Sudan",
	"SE": "İsveç",
	"SG": "Singapur",
	"SH": "Saint Helena",
	"SI": "Slovenya",
	"SJ": "Svalbard ve Jan Mayen Adaları",
	"SK": "Slovakya",
	"SL": "Sierra Leone",
	"SM": "San Marino",
	"SN": "Senegal",
	"SO": "Somali",
	"SR": "Surinam",
	"SS": "Güney Sudan",
	"ST": "São Tomé ve Príncipe",
	"SV": "El Salvador",
	"SX": "Sint Maarten",
	"SY": "Suriye",
	"SZ": "Svaziland",
	"TC": "Turks ve Caicos Adaları",
	"TD": "Çad",
	"TF": "Fransız Güney Toprakları",
	"TG": "Togo",
	"TH": "Tayland",
	"TJ": "Tacikistan",
	"TK": "Tokelau",
	"TL": "Timor-Leste",
	"TM": "Türkmenistan",
	"TN": "Tunus",
	"TO": "Tonga",
	"TR": "Türkiye",
	"TT": "Trinidad ve Tobago",
	"TV": "Tuvalu",
	"TW": "Tayvan",
	"TZ": "Tanzanya",
	"UA": "Ukrayna",
	"UG": "Uganda",
	"UM": "ABD Uzak Adaları",
	"US": "ABD",
	"UY": "Uruguay",
	"UZ": "Özbekistan",
	"VA": "Vatikan",
	"VC": "Saint Vincent ve Grenadinler",
	"VE": "Venezuela",
	"VG": "Britanya Virjin Adaları",
	"VI": "ABD Virjin Adaları",
	"VN": "Vietnam",
	"VU": "Vanuatu",
	"WF": "Wallis ve Futuna Adaları",
	"WS": "Samoa",
	"YE": "Yemen",
	"YT": "Mayotte",
	"ZA": "Güney Afrika",
	"ZM": "Zambiya",
	"ZW": "Zimbabve",
	"XK": "Kosova"
};

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = {
	"AU": "Австралія",
	"AT": "Австрія",
	"AZ": "Азербайджан",
	"AX": "Аландські острови",
	"AL": "Албанія",
	"DZ": "Алжир",
	"AS": "Американське Самоа",
	"AI": "Ангілья",
	"AO": "Ангола",
	"AD": "Андорра",
	"AQ": "Антарктида",
	"AG": "Антигуа і Барбуда",
	"MO": "Аоминь",
	"AR": "Аргентина",
	"AM": "Арменія",
	"AW": "Аруба",
	"AF": "Афганістан",
	"BS": "Багами",
	"BD": "Бангладеш",
	"BB": "Барбадос",
	"BH": "Бахрейн",
	"BZ": "Беліз",
	"BE": "Бельгія",
	"BJ": "Бенін",
	"BM": "Бермуди",
	"BY": "Білорусь",
	"BG": "Болгарія",
	"BO": "Болівія",
	"BA": "Боснія і Герцеговина",
	"BW": "Ботсвана",
	"BR": "Бразилія",
	"IO": "Британська Територія в Індійському Океані",
	"VG": "Британські Віргінські Острови",
	"BN": "Бруней Даруссалам",
	"BF": "Буркіна-Фасо",
	"BI": "Бурунді",
	"BT": "Бутан",
	"VU": "Вануату",
	"VA": "Ватикан",
	"GB": "Великобританія",
	"VE": "Венесуела",
	"VI": "Віргінські Острови (США)",
	"WF": "Волліс і Футуна",
	"VN": "В'єтнам",
	"UM": "Зовнішні малі острови (США)",
	"GA": "Габон",
	"HT": "Гаїті",
	"GY": "Гаяна",
	"GM": "Гамбія",
	"GH": "Гана",
	"GP": "Гваделупа",
	"GT": "Гватемала",
	"GF": "Гвіана",
	"GN": "Гвінея",
	"GW": "Гвінея-Бісау",
	"GG": "Гернсі",
	"GI": "Гібралтар",
	"HN": "Гондурас",
	"HK": "Гонконг",
	"GD": "Гренада",
	"GR": "Греція",
	"GE": "Грузія",
	"GU": "Гуам",
	"GL": "Ґренландія",
	"DK": "Данія",
	"JE": "Джерсі",
	"DJ": "Джибуті",
	"DM": "Домініка",
	"DO": "Домініканська Республіка",
	"CD": "Демократична Республіка Конго",
	"EC": "Еквадор",
	"GQ": "Екваторіальна Гвінея",
	"ER": "Еритрея",
	"EE": "Естонія",
	"ET": "Ефіопія",
	"EG": "Єгипет",
	"YE": "Ємен",
	"ZM": "Замбія",
	"ZW": "Зімбабве",
	"IL": "Ізраїль",
	"IN": "Індія",
	"ID": "Індонезія",
	"IQ": "Ірак",
	"IR": "Іран",
	"IE": "Ірландія",
	"IS": "Ісландія",
	"ES": "Іспанія",
	"IT": "Італія",
	"JO": "Йорданія",
	"CV": "Кабо-Верде",
	"KZ": "Казахстан",
	"KY": "Кайманові Острови",
	"KH": "Камбоджа",
	"CM": "Камерун",
	"CA": "Канада",
	"BQ": "Карибські Нідерланди",
	"QA": "Катар",
	"KE": "Кенія",
	"CY": "Кіпр",
	"KI": "Кірибаті",
	"KG": "Киргизстан",
	"TW": "Республіка Китай",
	"KP": "КНДР (Корейська Народно-Демократична Республіка)",
	"CN": "КНР (Китайська Народна Республіка)",
	"CC": "Кокосові острови",
	"CO": "Колумбія",
	"KM": "Коморські Острови",
	"XK": "Косово",
	"CR": "Коста-Рика",
	"CI": "Кот-д'Івуар",
	"CU": "Куба",
	"KW": "Кувейт",
	"CW": "Кюрасао",
	"LA": "Лаос",
	"LV": "Латвія",
	"LS": "Лесото",
	"LR": "Ліберія",
	"LB": "Ліван",
	"LY": "Лівія",
	"LT": "Литва",
	"LI": "Ліхтенштейн",
	"LU": "Люксембург",
	"MU": "Маврикій",
	"MR": "Мавританія",
	"MG": "Мадагаскар",
	"YT": "Майотта",
	"MK": "Македонія",
	"MW": "Малаві",
	"MY": "Малайзія",
	"ML": "Малі",
	"MV": "Мальдівы",
	"MT": "Мальта",
	"MA": "Марокко",
	"MQ": "Мартиніка",
	"MH": "Маршаллові Острови",
	"MX": "Мексика",
	"FM": "Мікронезія",
	"MZ": "Мозамбік",
	"MD": "Молдова",
	"MC": "Монако",
	"MN": "Монголія",
	"MS": "Монтсеррат",
	"MM": "М'янма",
	"NA": "Намібія",
	"NR": "Науру",
	"NP": "Непал",
	"NE": "Нігер",
	"NG": "Нігерія",
	"NL": "Нідерланди",
	"NI": "Нікарагуа",
	"DE": "Німеччина",
	"NU": "Ніуе",
	"NZ": "Нова Зеландія",
	"NC": "Нова Каледонія",
	"NO": "Норвегія",
	"AE": "Об'єднані Арабські Емірати",
	"OM": "Оман",
	"BV": "Острів Буве",
	"HM": "Острів Герд і острови Макдональд",
	"IM": "Острів Мен",
	"NF": "Острів Норфолк",
	"CX": "Острів Різдва",
	"CK": "Острови Кука",
	"SH": "Острови Святої Єлени, Вознесіння і Тристан-да-Кунья",
	"TC": "Острови Теркс і Кайкос",
	"PK": "Пакистан",
	"PW": "Палау",
	"PS": "Палестинська держава",
	"PA": "Панама",
	"PG": "Папуа Нова Гвінея",
	"ZA": "ПАР",
	"PY": "Парагвай",
	"PE": "Перу",
	"GS": "Південна Джорджія та Південні Сандвічеві Острови",
	"KR": "Південна Корея",
	"SS": "Південний Судан",
	"MP": "Північні Маріанські Острови",
	"PN": "Піткерн",
	"PL": "Польша",
	"PT": "Португалія",
	"PR": "Пуерто-Ріко",
	"CG": "Республіка Конго",
	"RE": "Реюньйон",
	"RU": "Росія",
	"RW": "Руанда",
	"RO": "Румунія",
	"EH": "САДР",
	"SV": "Сальвадор",
	"WS": "Самоа",
	"SM": "Сан-Маріно",
	"ST": "Сан-Томе і Принсіпі",
	"SA": "Саудівська Аравія",
	"SZ": "Свазіленд",
	"SJ": "Свальбард і Ян-Маєн",
	"SC": "Сейшельські Острови",
	"BL": "Сен-Бартельмі",
	"MF": "Сен-Мартен",
	"PM": "Сен-П'єр і Мікелон",
	"SN": "Сенегал",
	"VC": "Сент-Вінсент і Гренадини",
	"KN": "Сент-Кіттс і Невіс",
	"LC": "Сент-Люсія",
	"RS": "Сербія",
	"SG": "Сінгапур",
	"SX": "Сінт-Мартен",
	"SY": "Сірія",
	"SK": "Словаччина",
	"SI": "Словенія",
	"SB": "Соломонові Острови",
	"SO": "Сомалі",
	"SD": "Судан",
	"SR": "Суринам",
	"TL": "Східний Тимор",
	"US": "США",
	"SL": "Сьєрра-Леоне",
	"TJ": "Таджикистан",
	"TH": "Таїланд",
	"TZ": "Танзанія",
	"TG": "Того",
	"TK": "Токелау",
	"TO": "Тонга",
	"TT": "Тринідад і Тобаго",
	"TV": "Тувалу",
	"TN": "Туніс",
	"TM": "Туркменістан",
	"TR": "Турція",
	"UG": "Уганда",
	"HU": "Угорщина",
	"UZ": "Узбекистан",
	"UA": "Україна",
	"UY": "Уругвай",
	"FO": "Фарерські острови",
	"FJ": "Фіджі",
	"PH": "Філіппіни",
	"FI": "Фінляндія",
	"FK": "Фолклендські Острови",
	"FR": "Франція",
	"PF": "Французька Полінезія",
	"TF": "Французькі Південні і Антарктичні Території",
	"HR": "Хорватія",
	"CF": "Центральноафриканська Республіка",
	"TD": "Чад",
	"ME": "Чорногорія",
	"CZ": "Чехія",
	"CL": "Чілі",
	"CH": "Швейцарія",
	"SE": "Швеція",
	"LK": "Шрі-Ланка",
	"JM": "Ямайка",
	"JP": "Японія"
};

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

module.exports = {
	"AD": "安道尔",
	"AE": "阿联酋",
	"AF": "阿富汗",
	"AG": "安地卡及巴布達",
	"AI": "安圭拉",
	"AL": "阿尔巴尼亚",
	"AM": "亞美尼亞",
	"AO": "安哥拉",
	"AQ": "南极洲",
	"AR": "阿根廷",
	"AS": "美属萨摩亚",
	"AT": "奥地利",
	"AU": "澳大利亚",
	"AW": "阿鲁巴",
	"AX": "奧蘭",
	"AZ": "阿塞拜疆",
	"BA": "波斯尼亚和黑塞哥维那",
	"BB": "巴巴多斯",
	"BD": "孟加拉国",
	"BE": "比利時",
	"BF": "布吉納法索",
	"BG": "保加利亚",
	"BH": "巴林",
	"BI": "布隆迪",
	"BJ": "贝宁",
	"BL": "圣巴泰勒米",
	"BM": "百慕大",
	"BN": "文莱",
	"BO": "玻利维亚",
	"BQ": "加勒比荷兰",
	"BR": "巴西",
	"BS": "巴哈马",
	"BT": "不丹",
	"BV": "布韦岛",
	"BW": "博茨瓦纳",
	"BY": "白俄羅斯",
	"BZ": "伯利兹",
	"CA": "加拿大",
	"CC": "科科斯（基林）群島",
	"CD": "刚果（金)",
	"CF": "中非",
	"CG": "刚果（布)",
	"CH": "瑞士",
	"CI": "科特迪瓦",
	"CK": "庫克群島",
	"CL": "智利",
	"CM": "喀麦隆",
	"CN": "中国",
	"CO": "哥伦比亚",
	"CR": "哥斯达黎加",
	"CU": "古巴",
	"CV": "佛得角",
	"CW": "库拉索",
	"CX": "圣诞岛",
	"CY": "賽普勒斯",
	"CZ": "捷克",
	"DE": "德國",
	"DJ": "吉布提",
	"DK": "丹麥",
	"DM": "多米尼克",
	"DO": "多米尼加",
	"DZ": "阿尔及利亚",
	"EC": "厄瓜多尔",
	"EE": "爱沙尼亚",
	"EG": "埃及",
	"EH": "阿拉伯撒哈拉民主共和国",
	"ER": "厄立特里亚",
	"ES": "西班牙",
	"ET": "衣索比亞",
	"FI": "芬兰",
	"FJ": "斐济",
	"FK": "福克蘭群島",
	"FM": "密克羅尼西亞聯邦",
	"FO": "法罗群岛",
	"FR": "法国",
	"GA": "加彭",
	"GB": "英國",
	"GD": "格瑞那達",
	"GE": "格鲁吉亚",
	"GF": "法属圭亚那",
	"GG": "根西",
	"GH": "加纳",
	"GI": "直布罗陀",
	"GL": "格陵兰",
	"GM": "冈比亚",
	"GN": "几内亚",
	"GP": "瓜德罗普",
	"GQ": "赤道几内亚",
	"GR": "希臘",
	"GS": "南乔治亚和南桑威奇群岛",
	"GT": "危地马拉",
	"GU": "關島",
	"GW": "几内亚比绍",
	"GY": "圭亚那",
	"HK": "香港",
	"HM": "赫德岛和麦克唐纳群岛",
	"HN": "宏都拉斯",
	"HR": "克罗地亚",
	"HT": "海地",
	"HU": "匈牙利",
	"ID": "印尼",
	"IE": "爱尔兰",
	"IL": "以色列",
	"IM": "马恩岛",
	"IN": "印度",
	"IO": "英屬印度洋領地",
	"IQ": "伊拉克",
	"IR": "伊朗",
	"IS": "冰島",
	"IT": "義大利",
	"JE": "澤西",
	"JM": "牙买加",
	"JO": "约旦",
	"JP": "日本",
	"KE": "肯尼亚",
	"KG": "吉尔吉斯斯坦",
	"KH": "柬埔寨",
	"KI": "基里巴斯",
	"KM": "科摩罗",
	"KN": "圣基茨和尼维斯",
	"KP": "朝鲜",
	"KR": "韩国",
	"KW": "科威特",
	"KY": "开曼群岛",
	"KZ": "哈萨克斯坦",
	"LA": "老挝",
	"LB": "黎巴嫩",
	"LC": "圣卢西亚",
	"LI": "列支敦斯登",
	"LK": "斯里蘭卡",
	"LR": "利比里亚",
	"LS": "賴索托",
	"LT": "立陶宛",
	"LU": "卢森堡",
	"LV": "拉脫維亞",
	"LY": "利比亞",
	"MA": "摩洛哥",
	"MC": "摩納哥",
	"MD": "摩尔多瓦",
	"ME": "蒙特內哥羅",
	"MF": "法属圣马丁",
	"MG": "马达加斯加",
	"MH": "马绍尔群岛",
	"MK": "馬其頓",
	"ML": "马里",
	"MM": "緬甸",
	"MN": "蒙古",
	"MO": "澳門",
	"MP": "北馬里亞納群島",
	"MQ": "马提尼克",
	"MR": "毛里塔尼亚",
	"MS": "蒙特塞拉特",
	"MT": "馬爾他",
	"MU": "模里西斯",
	"MV": "馬爾地夫",
	"MW": "马拉维",
	"MX": "墨西哥",
	"MY": "马来西亚",
	"MZ": "莫桑比克",
	"NA": "纳米比亚",
	"NC": "新喀里多尼亞",
	"NE": "尼日尔",
	"NF": "诺福克岛",
	"NG": "奈及利亞",
	"NI": "尼加拉瓜",
	"NL": "荷蘭",
	"NO": "挪威",
	"NP": "尼泊尔",
	"NR": "瑙鲁",
	"NU": "纽埃",
	"NZ": "新西蘭",
	"OM": "阿曼",
	"PA": "巴拿马",
	"PE": "秘魯",
	"PF": "法屬玻里尼西亞",
	"PG": "巴布亚新几内亚",
	"PH": "菲律賓",
	"PK": "巴基斯坦",
	"PL": "波蘭",
	"PM": "圣皮埃尔和密克隆",
	"PN": "皮特凯恩群岛",
	"PR": "波多黎各",
	"PS": "巴勒斯坦",
	"PT": "葡萄牙",
	"PW": "帛琉",
	"PY": "巴拉圭",
	"QA": "卡塔尔",
	"RE": "留尼汪",
	"RO": "羅馬尼亞",
	"RS": "塞爾維亞",
	"RU": "俄羅斯",
	"RW": "卢旺达",
	"SA": "沙烏地阿拉伯",
	"SB": "所罗门群岛",
	"SC": "塞舌尔",
	"SD": "苏丹",
	"SE": "瑞典",
	"SG": "新加坡",
	"SH": "聖赫勒拿",
	"SI": "斯洛維尼亞",
	"SJ": "斯瓦尔巴群岛和扬马延岛",
	"SK": "斯洛伐克",
	"SL": "塞拉利昂",
	"SM": "圣马力诺",
	"SN": "塞内加尔",
	"SO": "索馬利亞",
	"SR": "苏里南",
	"SS": "南蘇丹",
	"ST": "聖多美和普林西比",
	"SV": "薩爾瓦多",
	"SX": "荷屬聖馬丁",
	"SY": "叙利亚",
	"SZ": "斯威士兰",
	"TC": "特克斯和凯科斯群岛",
	"TD": "乍得",
	"TF": "法属南部领地",
	"TG": "多哥",
	"TH": "泰國",
	"TJ": "塔吉克斯坦",
	"TK": "托克勞",
	"TL": "东帝汶",
	"TM": "土库曼斯坦",
	"TN": "突尼西亞",
	"TO": "汤加",
	"TR": "土耳其",
	"TT": "千里達及托巴哥",
	"TV": "图瓦卢",
	"TW": "臺灣",
	"TZ": "坦桑尼亚",
	"UA": "烏克蘭",
	"UG": "乌干达",
	"UM": "美國本土外小島嶼",
	"US": "美國",
	"UY": "乌拉圭",
	"UZ": "乌兹别克斯坦",
	"VA": "梵蒂冈",
	"VC": "聖文森及格瑞那丁",
	"VE": "委內瑞拉",
	"VG": "英屬維爾京群島",
	"VI": "美屬維爾京群島",
	"VN": "越南",
	"VU": "瓦努阿圖",
	"WF": "瓦利斯和富圖納",
	"WS": "萨摩亚",
	"YE": "葉門",
	"YT": "马约特",
	"ZA": "南非",
	"ZM": "尚比亞",
	"ZW": "辛巴威",
	"XK": "科索沃"
};

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
  __webpack_require__(241)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(414),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5523f9eb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
  __webpack_require__(238)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(413),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53edae8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(406),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b279d54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-460015d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
  __webpack_require__(246)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(418),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-feaf5034",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(231)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(405),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06359b1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(236)
  __webpack_require__(235)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(411),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42e02444",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(417),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-daba6420",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(407),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(416),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position"
  }, [_c('div', {
    staticClass: "position__button",
    class: {
      'position__button--within': _vm.positionWithinBounds
    },
    on: {
      "click": _vm.getCurrentPosition
    }
  }, [_c('div', {
    staticClass: "position__icon",
    class: {
      'position__icon--within': _vm.positionWithinBounds
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "position__text"
  }, [_vm._v(_vm._s(_vm.$t('myPosition')))])])])
},staticRenderFns: []}

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stores.length > -1) ? _c('div', {
    staticClass: "list"
  }, [_c('div', {
    class: {
      list__gradient: _vm.showGradient
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list__header"
  }, [_vm._v(_vm._s(_vm.listHeaderNo) + " " + _vm._s(_vm.listHeaderSuffix))]), _vm._v(" "), _c('div', {
    staticClass: "list__items",
    attrs: {
      "id": "items"
    }
  }, _vm._l((_vm.stores), function(store, i) {
    return _c('div', {
      staticClass: "list__item",
      class: {
        'list__item--selected': _vm.selectedMarker && store.uuid === _vm.selectedMarker.uuid
      },
      on: {
        "click": function($event) {
          _vm.listClick(store, i)
        }
      }
    }, [_c('div', {
      staticClass: "list__name"
    }, [_c('div', {
      staticClass: "list__type",
      class: {
        'list__type--brand': store.monobrand && (store.monobrand === '1' || store.monobrand === true)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "list__details"
    }, [_vm._v(_vm._s(store.name))])]), _vm._v(" "), _c('div', {
      staticClass: "list__matrix"
    }, [_c('div', {
      staticClass: "list__address"
    }, [_vm._v(_vm._s(store.address) + ", " + _vm._s(store.city))]), _vm._v(" "), (store.distance) ? _c('div', {
      staticClass: "list__distance"
    }, [_vm._v(_vm._s(store.distance.replace('.', ',')) + " " + _vm._s(_vm.$t('matrix')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list__ipad"
    }, [_c('div', {
      staticClass: "list__show"
    }, [_vm._v(_vm._s(_vm.$t('showIpad')))])])])
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    staticClass: "search__input",
    attrs: {
      "placeholder": _vm.$t('search'),
      "id": "autocomplete",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false",
      "type": "text"
    },
    on: {
      "click": _vm.openAutocomplete
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search__icon"
  })]), _vm._v(" "), _c('Position')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gmap-map', {
    ref: "map",
    attrs: {
      "id": "map",
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "options": _vm.mapOptions
    },
    on: {
      "bounds_changed": _vm.onBoundsChanged
    }
  }, [_vm._l((_vm.monoBrandStores), function(s, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": s.coords,
        "icon": _vm.constructIcon('brand', [24, 36])
      },
      on: {
        "click": function($event) {
          _vm.onMarkerClick(_vm.c)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.clusters), function(c, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": c.coords,
        "label": {
          text: ((c.properties || {}).point_count || ' ').toString(),
          fontSize: '11px'
        },
        "icon": _vm.constructIcon('retailer', [24, 36])
      },
      on: {
        "click": function($event) {
          _vm.onMarkerClick(c)
        }
      }
    })
  }), _vm._v(" "), (_vm.currentPosition) ? _c('gmap-marker', {
    key: _vm.position,
    attrs: {
      "position": {
        lat: _vm.currentPosition.latitude,
        lng: _vm.currentPosition.longitude
      },
      "icon": _vm.constructIcon('location', [16, 16])
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authorised",
    class: {
      'authorised--hidden': !_vm.active
    },
    on: {
      "click": function($event) {
        _vm.toggleAuthorised(false)
      }
    }
  }, [_c('div', {
    staticClass: "authorised__container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "authorised__stamp_up"
  }), _vm._v(" "), _c('div', {
    staticClass: "authorised__stamp_down"
  }), _vm._v(" "), _c('div', {
    staticClass: "authorised__text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('legalH1')))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP1')) + "\n      "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP2')) + "\n      "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('legalH2')))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP3')) + "\n      "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP4')) + "\n      "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL1')))]), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL2')))]), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL3')))]), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL4')))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP5')) + "\n      "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP6')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "authorised__close icon-close",
    on: {
      "click": function($event) {
        _vm.toggleAuthorised(false)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner is-loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "overview",
    class: {
      loading: _vm.loading
    }
  }, [_c('Authorised'), _vm._v(" "), _c('Search'), _vm._v(" "), _c('div', {
    staticClass: "stores"
  }, [_c('Type'), _vm._v(" "), _c('GoogleMap', {
    attrs: {
      "lang": _vm.lang
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('Popup'), _vm._v(" "), _c('div'), _vm._v(" "), _c('List')], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "dw-shop header__back",
    attrs: {
      "href": "https://www.danielwellington.com",
      "title": "Go to the store",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticClass: "header__arrow"
  }, [_c('span', {
    staticClass: "header__icon icon-arrow"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__continue"
  }, [_vm._v(_vm._s(_vm.$t('continue')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "dw-logo router-link-active",
    attrs: {
      "to": _vm.locale,
      "title": "Daniel Wellington"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "type"
  }, [_c('div', {
    staticClass: "type__authorised",
    on: {
      "click": function($event) {
        _vm.toggleAuthorised(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('authorised')))])])
},staticRenderFns: []}

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.marker) ? _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popup__details"
  }, [_c('div', {
    staticClass: "popup__close icon-close",
    on: {
      "click": function($event) {
        _vm.closePopup(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup__top"
  }, [_c('div', {
    staticClass: "popup__header"
  }, [(_vm.marker.name) ? _c('div', {
    staticClass: "popup__name"
  }, [_vm._v(_vm._s(_vm.marker.name))]) : _vm._e(), _vm._v(" "), (_vm.marker.distance) ? _c('div', {
    staticClass: "popup__distance"
  }, [_vm._v(_vm._s(_vm.marker.distance.replace('.', ',')) + " " + _vm._s(_vm.$t('matrix')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "popup__contact"
  }, [_c('div', {
    staticClass: "popup__location",
    attrs: {
      "if": "marker.address"
    }
  }, [_vm._v(_vm._s(_vm.marker.address))]), _vm._v(" "), _c('div', {
    staticClass: "popup__location",
    attrs: {
      "if": "marker.address"
    }
  }, [(_vm.marker.zipcode) ? _c('span', [_vm._v(_vm._s(_vm.marker.zipcode) + ",")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.marker.city))]), _vm._v(" "), _c('div', {
    staticClass: "popup__location",
    attrs: {
      "if": "marker.address"
    }
  }, [_vm._v(_vm._s(_vm.marker.state))]), _c('br'), _vm._v(" "), (_vm.phone) ? _c('div', [_vm._v(_vm._s(_vm.phone))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "popup__bottom"
  }, [(_vm.hours) ? _c('div', {
    staticClass: "popup__opening_hours"
  }, [_c('div', {
    staticClass: "popup__open"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('monFri')))]), _vm._v(" "), _c('div', {
    staticClass: "popup__hour"
  }, [(_vm.hours[1]) ? _c('span', [_vm._v(_vm._s(_vm.hours[1].open.slice(0, 2)) + " - " + _vm._s(_vm.hours[1].close.slice(0, 2)))]) : _c('span', [_vm._v(_vm._s(_vm.$t('closed')))])])]), _vm._v(" "), _c('div', {
    staticClass: "popup__open"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('sat')))]), _vm._v(" "), _c('div', {
    staticClass: "popup__hour"
  }, [(_vm.hours[6]) ? _c('span', [_vm._v(_vm._s(_vm.hours[6].open.slice(0, 2)) + " - " + _vm._s(_vm.hours[6].close.slice(0, 2)))]) : _c('span', [_vm._v(_vm._s(_vm.$t('closed')))])])]), _vm._v(" "), _c('div', {
    staticClass: "popup__open"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('sun')))]), _vm._v(" "), _c('div', {
    staticClass: "popup__hour"
  }, [(_vm.hours[0]) ? _c('span', [_vm._v(_vm._s(_vm.hours[0].open.slice(0, 2)) + " - " + _vm._s(_vm.hours[0].close.slice(0, 2)))]) : _c('span', [_vm._v(_vm._s(_vm.$t('closed')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup__links"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm.$t('directions')))])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

module.exports = [
	{
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#ebe3cd"
			}
		]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#523735"
			}
		]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"color": "#f5f1e6"
			}
		]
	},
	{
		"featureType": "administrative",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#c9b2a6"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#dcd2be"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#ae9e90"
			}
		]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#dfd2ae"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#dfd2ae"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#93817c"
			}
		]
	},
	{
		"featureType": "poi.business",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#a5b076"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#447530"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#f5f1e6"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#fdfcf8"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#f8c967"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#e9bc62"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#e98d58"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#db8555"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#806b63"
			}
		]
	},
	{
		"featureType": "transit",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#dfd2ae"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#8f7d77"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"color": "#ebe3cd"
			}
		]
	},
	{
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#dfd2ae"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#b9d3c2"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#92998d"
			}
		]
	}
];

/***/ })

},[166]);


// WEBPACK FOOTER //
// static/js/app.67c9a29b5486056fcc62.js